import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import BackOrdersAvailable from './createEditOrderBackOrders';
import ChangeDeliveryMethodNOOverlayDialog from '../../dialogs/changeDeliveryMethodNOOverlayDialog';
import ChangeDeliveryMethodYESOverlayDialog from '../../dialogs/changeDeliveryMethodYESOverlayDialog';
import ChangeDeliveryMethodYESForAlternateADCOverlayDialog from '../../dialogs/changeDeliveryMethodYESForAlternateADCOverlayDialog';
import ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog from '../../dialogs/changeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog';
import AddCustomerServiceNotesForADCTruckloadOverlayDialog from '../../dialogs/addCustomerServiceNotesForADCTruckloadOverlayDialog';
import AddShippingAddressOverlayDialog from '../../dialogs/addShippingAddressOverlayDialog';
import NotHavingEnoughPointsOverlayDialog from '../../dialogs/notHavingEnoughPointsOverlayDialog';
import ReplaceProductOverlayDialog from '../../dialogs/replaceProductOverlayDialog';
import UpgradeProductOverlayDialog from '../../dialogs/upgradeProductOverlayDialog';
import SubstituteProductOverlayDialog from '../../dialogs/substituteProductOverlayDialog';
import ChangeDeliveryMethodOverlayDialog from '../../dialogs/changeDeliveryMethodOverlayDialog';
import FedExShipmentConfirmationOverlayDialog from '../../dialogs/fedExShipmentConfirmationOverlayDialog';
import AddServicesOverlayDialog from '../../dialogs/addServicesOverlayDialog';
import DuplicatePOOverlayDialog from '../../dialogs/duplicatePOOverlayDialog';
import InvalidSalesAgreementOverlayDialog from '../../dialogs/invalidSalesAgreementOverlayDialog';
import ShippingMethodDescriptionsOverlayDialog from '../../dialogs/shippingMethodDescriptionsOverlayDialog';
import MultipleDeliveryPointCriteriaNotMatchedOverlayDialog from '../../dialogs/multipleDeliveryPointCriteriaNotMatchedOverlayDialog';
// import NoRecordsFoundOverlayDialog from '../../dialogs/noRecordsFoundOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import PriceSourceOverlayDialog from '../../dialogs/priceSourceOverlayDialog';
import SelectPriceSourceOverlayDialog from '../../dialogs/selectPriceSourceOverlayDialog';
import ActionForSDSOverlayDialog from '../../dialogs/actionForSDSOverlayDialog';
import ChangeDeliveryMethodForADCLTLOverlayDialog from '../../dialogs/changeDeliveryMethodForADCLTLOverlayDialog';
import ChangeDeliveryMethodMATUOrLTIAOverlayDialog from '../../dialogs/changeDeliveryMethodMATUOrLTIAOverlayDialog';
import DoNotDeliverySelectedAddressOverlayDialog from '../../dialogs/doNotDeliverySelectedAddressOverlayDialog';
import NoDuplicateFromBackOrdersOverlayDialog from '../../dialogs/noDuplicateFromBackOrdersOverlayDialog';
import LineNoMissingFromBackOrdersOverlayDialog from '../../dialogs/lineNoMissingFromBackOrdersOverlayDialog';
import moment from 'moment';
import countries from '../../common/countries';
import * as messageConstants from '../../common/messageConstants'

import {
	getPriceOrder,
	getPIMItemInfo,
	getOrderableServices,
	checkServicePrices,
	saveCreateOrderPayload,
	checkPricesForSearchResult,
	getTax,
	getMinimumDelivery,
	saveMinimumDeliveryAmount,
	saveDeletedItems,
	updateShippingAddresses,
	getSearchKeywordSuggestionList,
	showAddressVerificationDialog,
	saveOrderableServices,
	getDeliveryCalendar,
	setAvailabilityError
} from '../../../redux/actions';
import { routes } from '../../../redux/api/routes';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggestsAvailPricing';
import AvailQtyEtaDescriptionsOverlayDialog from '../../dialogs/availQtyEtaDescriptionsOverlayDialog';
import { CUSTOMER_CLASS_CODES_FOR_HOLD_OR_FORCE_BACKORDER } from '../../common/LookUpTable';

class EditOrder extends Component {

    constructor(props) {
        super(props);
		this.state = {
			blurCountOfRootLevelPO: 0,
			disableDeliveryAndShippingAddressDropdown: false,
			invalidPONumberMessage: 'PO number cannot include  `,~, | , * , >, <,  or /',
			backOrderErrorMessage: '',
			showBackOrders: false,
			visibleBackOrders: false,
			duplicateItems: [],
			minDate1: moment().add(1, 'day'),
			minDate2: moment().add(1, 'day'),
			minDate3: moment().add(1, 'day'),
			maxDate1: null,
			maxDate2: null,
			maxDate3: null,
			searchKeywordItem: [],
			createOrderForm: {
				params: {
					legacyId: '',
					orderDate: '',
					orderType: 'Standard Sales',
					deliveryMode: 'single',
					deliveryMethod: '',
					alternateADC: '',
					defaultAlternateADC: '',
					billingReference: [],
					billingAddress: null,
					shippingAddress: null,
					poNumber: '',
					requestedDeliveryDate: '',
					requestedDeliveryDate2: '',
					requestedDeliveryDate3: '',
					deliveryPhone: '',
					deliveryInstructions: '',
					pointValue: '',
					orderWeight: '',
					items: [],

					createdById: '',
					createdBy: '',
					email: '',
					accountNumber: '',
					orderSubTotal: '',
					orderTotal: '',
					customerServiceNotes: '',
					orderTax: '',
					isPriceOrderServiceIsDown: false,
				},
				errors: {
					poNumberError: '',
					deliveryMethodError: '',
					shippingAddressError: '',
					requestedDeliveryDateError: '',
					deliveryPhoneError: '',
				},
			},

			shippingMethodList: [],
			adcDeliveryCalendar: null,
			sdsDeliveryCalendar: null,

			orderAvailabilityCompleted: true,

			priceOrderParallelCallsData: [],
			priceOrderParallelCallsDataByHoldBackorders: [],
			firstDeliveryPoints: '',
			secondDeliveryPoints: '',
			thirdDeliveryPoints: '',
			billingProfile: null,
			shippingAddress: null,
			addressList: [],
			date: null,
			date2: null,
			date3: null,

			showPriceSourceOverlayDialog: false,
			showSelectPriceSourceOverlayDialog: false,
			showAddShippingAddressOverlayDialog: false,
			showSubstituteProductOverlayDialog: false,
			showInvalidSalesAgreementOverlayDialog: false,
			showChangeDeliveryMethodOverlayDialog: false,
			showChangeDeliveryMethodNOOverlayDialog: false,
			showChangeDeliveryMethodYESOverlayDialog: false,
			showMultipleDeliveryPointCriteriaNotMatchedOverlayDialog: false,
			showNotHavingEnoughPointsOverlayDialog: false,
			showFedExShipmentConfirmationOverlayDialog: false,
			showDuplicatePOOverlayDialog: false,
			showShippingMethodDescriptionsOverlayDialog: false,
			showChangeDeliveryMethodForADCLTLOverlayDialog: false,
			showChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog: false,
			showAddCustomerServiceNotesForADCTruckloadOverlayDialog: false,
			showChangeDeliveryMethodMATUOrLTIAOverlayDialog: false,
			showActionForSDSOverlayDialog: false,
			showDoNotDeliverySelectedAddressOverlayDialog: false,
			showGroupETADescriptionDialog: false,
			showAvailQtyEtaDescriptionsOverlayDialog: false,

			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',

			showAddServicesOverlayDialog: false,
			replacementSKUData: null,
			substituteSKUData: null,
			upgradeSKUData: null,
			selectedPriceSource: null,
			availableServices: null,
			selectedSKU: '',
			selectedSKUIndex: '',

			defaultShippingAddress: null,
			defaultDeliveryMethod: 'SDS Delivery',

			products :  [], //This will contains added extra products by clicking on "Add" link
			isAvailabilityCallCompleted: false,
			isPricingCallCompleted: false,
			isPimCallCompleted: false,
			availabilityData: null,
			pricingData: null,
			pimData: null,
			disableCalendar: false,

			last30DaysOrders: null,
			last60DaysOrders: null,
			taxDetails: null,
			isLast30DaysOrdersCompleted: false,
			isLast60DaysOrdersCompleted: false,
			isGetTaxServiceCallCompleted: false,
			isGetMinimumDeliveryCallCompleted: false,
			isPriceOrderParallelCallsCompleted: false,

			isSDS_LOC: false,
			isSDS_will_call_loc: false,
			isADC_will_call_loc: false,
			isADC_loc: false,

			isDuplicatePONumber: false,
			invalidPONumberRootLevel: false,

			isRequiredToMakeRecursiveAvailabilityCall: false,
		};
		this.handleAddNotesForADCTruckLoad = this.handleAddNotesForADCTruckLoad.bind(this);
		this.handleCallBackAction = this.handleCallBackAction.bind(this);
		this.checkIfETAIsAfterMaxDateForAnyBackOrderDelivery = this.checkIfETAIsAfterMaxDateForAnyBackOrderDelivery.bind(this);
		this.onChangeUpdateItems = this.onChangeUpdateItems.bind(this);
		this.updateAvailability = this.updateAvailability.bind(this);
		this.validateSubstituteCriteria = this.validateSubstituteCriteria.bind(this);
		this.callbackToUpdateItemsAfterAvailability = this.callbackToUpdateItemsAfterAvailability.bind(this);
		this.checkVelocityCustomerAndAction = this.checkVelocityCustomerAndAction.bind(this);
		this.isPriceOrderServiceIsDown = this.isPriceOrderServiceIsDown.bind(this);
		this.updatePoNumberAtLineLevel = this.updatePoNumberAtLineLevel.bind(this);
		this.handleBlurOfRootLevelPO = this.handleBlurOfRootLevelPO.bind(this);
		this.onChangeUpdateParam = this.onChangeUpdateParam.bind(this);
		this.getUnsocClassifications = this.getUnsocClassifications.bind(this);
		this.getSiteNumberOfSelectedShippingAddress = this.getSiteNumberOfSelectedShippingAddress.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleChange2 = this.handleChange2.bind(this);
		this.getZipCode = this.getZipCode.bind(this);
		this.handleChange3 = this.handleChange3.bind(this);
		this.getUpdatedDateAsOrMinDate = this.getUpdatedDateAsOrMinDate.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.preparePayloadOfCurrentDelivery = this.preparePayloadOfCurrentDelivery.bind(this);
		this.updatePricing = this.updatePricing.bind(this);
		this.resetSelectedSKU = this.resetSelectedSKU.bind(this);
		this.checkShowingOrdersCriteria = this.checkShowingOrdersCriteria.bind(this);
		this.callBackAfterAddingNewProduct = this.callBackAfterAddingNewProduct.bind(this);
		this.getLocTypeAccordingToDeliveryMethod = this.getLocTypeAccordingToDeliveryMethod.bind(this);
		this.redirectToReviewOrderPage = this.redirectToReviewOrderPage.bind(this);
		this.callBackToCheckParallelCallCompleted = this.callBackToCheckParallelCallCompleted.bind(this);
		this.getDeliveryMethod = this.getDeliveryMethod.bind(this);
		this.manageAvailableServices = this.manageAvailableServices.bind(this);
		this.addM038ServiceItem = this.addM038ServiceItem.bind(this);
		this.removeM038ServiceItem = this.removeM038ServiceItem.bind(this);
		this.updateDeliveryMethodDropdown = this.updateDeliveryMethodDropdown.bind(this);
		this.checkIfNeedToAddOrRemoveM038 = this.checkIfNeedToAddOrRemoveM038.bind(this);
		this.handleDuplicatePOAction = this.handleDuplicatePOAction.bind(this);
		this.checkIfDuplicatePOOrNot = this.checkIfDuplicatePOOrNot.bind(this);
		this.updateOrderPoints = this.updateOrderPoints.bind(this);
		this.getShippingAddressZipCode = this.getShippingAddressZipCode.bind(this);
		this.getShippingAddressState = this.getShippingAddressState.bind(this);
		this.checkAvailabilityOfAddedServices = this.checkAvailabilityOfAddedServices.bind(this);
		this.makeParallelCallsOfPriceOrderForMultipleDelivery = this.makeParallelCallsOfPriceOrderForMultipleDelivery.bind(this);
		this.checkIfStateIsAk = this.checkIfStateIsAk.bind(this);
		this.isBackOrderEligible = this.isBackOrderEligible.bind(this);
    }

	resetSelectedSKU() {
		var self = this;
		setTimeout(() => {
			self.setState({
				selectedSKU: '',
				selectedSKUIndex: '',
			})
		}, 1000);
	}

	isBackOrderEligible(item, LocalStorageVar){
		let returnVal = false;
		const self = this,
		{ params } = self.state.createOrderForm;

		if(params.deliveryMode === 'multiple'){
			if(item.requestedDeliveryDateBackUp == 'delivery1' && params.requestedDeliveryDate &&
				(moment(item.eta).isBefore(moment(params.requestedDeliveryDate)))){
					returnVal = true
			}
			else if(item.requestedDeliveryDateBackUp == 'delivery2' && params.requestedDeliveryDate2 &&
				(moment(item.eta).isBefore(moment(params.requestedDeliveryDate2)))){
					returnVal = true
			}
			else if(item.requestedDeliveryDateBackUp == 'delivery3' && params.requestedDeliveryDate3 &&
				(moment(item.eta).isBefore(moment(params.requestedDeliveryDate3)))){
					returnVal = true
			}
		}
		else if((moment(item.eta).isBefore(moment(LocalStorageVar)))){
			returnVal = true
		}
		return returnVal;
	}

	updateAvailabilityOnRDDChange = (delivery, requestedDeliveryDate) => {
		const { createOrderForm: { params: { items }}} = this.state;

		let isOrderAvailabilityCheckRequired = false;
		for (const item of items) {
			if (item.requestedDeliveryDate === delivery && requestedDeliveryDate) {
				isOrderAvailabilityCheckRequired = true;
				break;
			}
		}

		if (isOrderAvailabilityCheckRequired) {
			if (!this.state.isRequiredToMakeRecursiveAvailabilityCall) {
				this.setState({
					isRequiredToMakeRecursiveAvailabilityCall: true
				}, () => {
					this.updateAvailability();
				})
			} else {
				this.updateAvailability();
			}
		}
	}

	handleChange(date) {
		const self = this;
		const param = self.state.createOrderForm.params;
		const items = param.items;
		param.requestedDeliveryDate = date && date.format('MM/DD/YYYY');
		let LocalStorageVar = date.format('MM/DD/YYYY');
		items.forEach(itm => {
			if(this.isBackOrderEligible(itm,LocalStorageVar) && (itm.actionError == "error" || itm.onHold == "Y")){
				delete itm.onHold;	
				itm.actionError="";
			}
		  })
	  	self.setState({
		  	date: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
			  		requestedDeliveryDate: date && date.format('MM/DD/YYYY'),
					isRDDChanged: true
				},
				errors: {
					...self.state.createOrderForm.errors,
					requestedDeliveryDateError: ""
				}
		  	}
	  	}, () => {
			self.updateWarehouseDetails(date ? date.format('MM/DD/YYYY') : null);
			self.updateAvailabilityOnRDDChange('delivery1', date);
		});
		localStorage.setItem("RDDate", JSON.stringify(date.format('MM/DD/YYYY')));
	}

	handleChange2(date) {
		const self = this;
		const param = self.state.createOrderForm.params;
		param.requestedDeliveryDate2 = date && date.format('MM/DD/YYYY');
		const items = param.items;
		items.forEach(itm => {
			if(this.isBackOrderEligible(itm,null) && (itm.actionError == "error" || itm.onHold == "Y")){
				delete itm.onHold;	
				itm.actionError="";
			}
		})
	  	self.setState({
		  	date2: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					requestedDeliveryDate2: date && date.format('MM/DD/YYYY')
				},
				errors: {
					...self.state.createOrderForm.errors,
					requestedDeliveryDate2Error: ""
				}
			}
		}, () => {
			self.updateWarehouseDetails(date ? date.format('MM/DD/YYYY') : null);
			self.updateAvailabilityOnRDDChange('delivery2', date);
		});
	}

	handleChange3(date) {
		const self = this;
		const param = self.state.createOrderForm.params;
		param.requestedDeliveryDate3= date && date.format('MM/DD/YYYY');
		const items = param.items;
		items.forEach(itm => {
			if(this.isBackOrderEligible(itm,null) && (itm.actionError == "error" || itm.onHold == "Y")){
				delete itm.onHold;	
				itm.actionError="";
			}
		})
	  	self.setState({
		  	date3: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					requestedDeliveryDate3: date && date.format('MM/DD/YYYY')
				},
				errors: {
					...self.state.createOrderForm.errors,
					requestedDeliveryDate3Error: ""
				}
			}
		}, () => {
			self.updateWarehouseDetails(date ? date.format('MM/DD/YYYY') : null);
			self.updateAvailabilityOnRDDChange('delivery3', date);
		});
	}

	updateWarehouseDetails(dt) {
		const self = this;
		if (dt) {
			self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, "", resp => {
				// DO NOTHING, it will just update required data to store for future use
				self.setState({newShippingData:resp})
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), dt, false, self.props.getCountry(), true);
		}
	}

	handleAddNotesForADCTruckLoad(notesData) {
		const self = this;
		//Handle notes here
		let { params } = self.state.createOrderForm;
		params.customerServiceNotes = notesData;
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params
			},
			showAddCustomerServiceNotesForADCTruckloadOverlayDialog: false
		}, () => {
			// Continue with other logic of making service call
			self.checkIfDuplicatePOOrNot();
		});
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillMount() {
		if(!this.props.state.order.createOrderPayload) {
			browserHistory.push("/manageorders");
		} else {
			const self = this;
			const { userDetails } = self.props.state.user;
			const { createOrderPayload, shippingMethodList, availabilityError } = self.props.state.order;
			const response = self.props.state.order.billingReference;
			let billingReference = [];

			if(response) {
				if(response.status && response.responseObject && response.responseObject.length > 0) {
					billingReference = JSON.parse(JSON.stringify(response.responseObject));
					billingReference.forEach((item) => {
						createOrderPayload.billingReference.forEach((itm) => {
							if(item.name === itm.name) {
								item.value = itm.value;
							}
						});
					});
				}
			}
			// set values which are already available
			if(createOrderPayload && createOrderPayload.billingReference) {
				// check if internamName is ther then use that to update name attribute
				//		to solve browser back as when browser back is pressed internalName wont be available
				createOrderPayload.billingReference.forEach(itm => {
					itm.name = itm.name || itm.internalName;
				});
				billingReference.forEach(item => {
					const isValueAvailable = _.find(createOrderPayload.billingReference, {name: item.name});
					item.value = isValueAvailable ? isValueAvailable.value : '';
				});
			}
			// remove "CUSTOMER MINIMUM DELIVERY" if it exists
			if(createOrderPayload && createOrderPayload.items) {
				createOrderPayload.items = _.pullAllBy(createOrderPayload.items, [{item: 'CUSTOMER MINIMUM DELIVERY'}, {item: 'LTL FREIGHT CHARGE'}, {item: 'HANDLING CHARGE'}], 'item');
			}
			// As per discussion on 06-May-20 commenting out below code to avoid checking duplicate po
			// // check for duplicate po number
			// const { bookedOrders } = self.props.state.order;
			// let isDuplicatePONumber = false;
			// bookedOrders.forEach(item => {
			// 	if(item.orderHeader.ponumber === createOrderPayload.poNumber) {
			// 		isDuplicatePONumber = true;
			// 	}
			// });
			const deliveryMethod = createOrderPayload.deliveryMethod === 'FedEx Ground' ? '' : createOrderPayload.deliveryMethod;
			response.responseObject = billingReference;
			self.setState({
				// As per discussion on 06-May-20 commenting out below code to avoid checking duplicate po
				// isDuplicatePONumber,
				disableDeliveryAndShippingAddressDropdown: deliveryMethod === 'ADC Velocity',
				showGroupETADescriptionDialog: false,
				showAvailQtyEtaDescriptionsOverlayDialog: false,
				showBackOrders: false,
				visibleBackOrders: false,
				availabilityError: availabilityError ? true : false,
				date: createOrderPayload.requestedDeliveryDate ? moment(createOrderPayload.requestedDeliveryDate) : null,
				date2: createOrderPayload.requestedDeliveryDate2 ? moment(createOrderPayload.requestedDeliveryDate2) : null,
				date3: createOrderPayload.requestedDeliveryDate3 ? moment(createOrderPayload.requestedDeliveryDate3) : null,
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						...createOrderPayload,
						requestedDeliveryDate: createOrderPayload.requestedDeliveryDate && moment(createOrderPayload.requestedDeliveryDate).format('MM/DD/YYYY'),
						orderDate: moment(createOrderPayload.orderDate).format('MM/DD/YYYY'),
						createdById: userDetails.sso,
						createdBy: userDetails.firstName + " " + userDetails.lastName,
						deliveryMethod: createOrderPayload.deliveryMethod === 'FedEx Ground' ? '' : createOrderPayload.deliveryMethod,
						alternateADC: createOrderPayload.alternateADC ? createOrderPayload.alternateADC : ((deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') ? self.props.state.user.selectedADC : ''),
						defaultAlternateADC: createOrderPayload.defaultAlternateADC ? createOrderPayload.defaultAlternateADC : ((deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') ? self.props.state.user.defaultSelectedADC : ''),
						deliveryPhone: createOrderPayload.deliveryPhone ? self.props.normalizePhoneNumber(createOrderPayload.deliveryPhone) : '',
						billingReference,
					}
				},
				billingProfile: response?JSON.parse(JSON.stringify(response)):null,
				shippingMethodList: JSON.parse(JSON.stringify(shippingMethodList)),
			}, () => {
				self.updateMinimumDeliveryDateByDelivery();
			});
		}
	}

	updateMinimumDeliveryDateByDelivery(callback) {
		const self = this;
		let minDate1 = moment().add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		let minDate2 = moment().add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		let minDate3 = moment().add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		const deliveryCalendarType = self.props.getDeliveryCalendarType(self.state.createOrderForm.params.deliveryMethod);
		const isSDSDeliveryCalendarAvailable = !!(self.state.sdsDeliveryCalendar && self.state.sdsDeliveryCalendar.deliveryMethod === self.state.createOrderForm.params.deliveryMethod && self.state.sdsDeliveryCalendar.dates);
		if(self.state.createOrderForm.params.deliveryMethod === 'ADC Will Call') {
			minDate1 = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
			minDate2 = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
			minDate3 = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
		} else if (deliveryCalendarType === 'SDS') {
			if (isSDSDeliveryCalendarAvailable) {
				const firstAvailableCalendarDate = self.state.sdsDeliveryCalendar.dates.find(calendarDate => calendarDate.available && calendarDate.date);
				if (firstAvailableCalendarDate) {
					minDate1 = moment(firstAvailableCalendarDate.date);
					minDate2 = moment(firstAvailableCalendarDate.date);
					minDate3 = moment(firstAvailableCalendarDate.date);
				}
			}
		} else if (deliveryCalendarType === 'ADC') {
			if (self.state.adcDeliveryCalendar && self.state.adcDeliveryCalendar.firstAvailableCalendarDate) {
				minDate1 = moment(self.state.adcDeliveryCalendar.firstAvailableCalendarDate);
				minDate2 = moment(self.state.adcDeliveryCalendar.firstAvailableCalendarDate);
				minDate3 = moment(self.state.adcDeliveryCalendar.firstAvailableCalendarDate);
			}
		}


		let { date, date2, date3 } = self.state;
		let { requestedDeliveryDate, requestedDeliveryDate2, requestedDeliveryDate3 } = self.state.createOrderForm.params;
		if(date && date.isBefore(minDate1) && self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery1')) {
			date = null;
			requestedDeliveryDate = '';
		}
		if(date2 && date2.isBefore(minDate2) && self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery2')) {
			date2 = null;
			requestedDeliveryDate2 = '';
		}
		if(date3 && date3.isBefore(minDate3) && self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery3')) {
			date3 = null;
			requestedDeliveryDate3 = '';
		}
		// default max dates will be null
		let maxDate1 = null;
		let maxDate2 = null;
		let maxDate3 = null;
		// if any individual delivery is having original order number then need to set maxdate with mindate + 7 days
		if (self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery1' && item.originalOrderNumber)) {
			maxDate1 = moment(minDate1).add(7, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		}
		if (self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery2' && item.originalOrderNumber)) {
			maxDate2 = moment(minDate2).add(7, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		}
		if (self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery3' && item.originalOrderNumber)) {
			maxDate3 = moment(minDate3).add(7, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		}
		if (deliveryCalendarType === 'SDS' && isSDSDeliveryCalendarAvailable) {
			const lastAvailableCalendarDate = self.state.sdsDeliveryCalendar.dates.findLast(calendarDate => calendarDate.available && calendarDate.date);
			if (lastAvailableCalendarDate) {
				maxDate1 = maxDate1 || moment(lastAvailableCalendarDate.date);
				maxDate2 = maxDate2 || moment(lastAvailableCalendarDate.date);
				maxDate3 = maxDate3 || moment(lastAvailableCalendarDate.date);
			}
		}
		// clear selection of date if selected date is after max date
		if (date && (date.isAfter(maxDate1) || (deliveryCalendarType === 'SDS' && isSDSDeliveryCalendarAvailable && !self.state.sdsDeliveryCalendar.dates.some(calendarDate => calendarDate.available && calendarDate.date === date.format('MM/DD/YYYY'))))) {
			date = null;
			requestedDeliveryDate = '';
		}
		if (date2 && (date2.isAfter(maxDate2) || (deliveryCalendarType === 'SDS' && isSDSDeliveryCalendarAvailable && !self.state.sdsDeliveryCalendar.dates.some(calendarDate => calendarDate.available && calendarDate.date === date2.format('MM/DD/YYYY'))))) {
			date2 = null;
			requestedDeliveryDate2 = '';
		}
		if (date3 && (date3.isAfter(maxDate3) || (deliveryCalendarType === 'SDS' && isSDSDeliveryCalendarAvailable && !self.state.sdsDeliveryCalendar.dates.some(calendarDate => calendarDate.available && calendarDate.date === date3.format('MM/DD/YYYY'))))) {
			date3 = null;
			requestedDeliveryDate3 = '';
		}
		self.setState({
			date,
			date2,
			date3,
			minDate1,
			minDate2,
			minDate3,
			maxDate1,
			maxDate2,
			maxDate3,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					requestedDeliveryDate,
					requestedDeliveryDate2,
					requestedDeliveryDate3
				}
			}
		}, () => {
			callback && callback();
		});
	}

	getLatestFDDByDelivery(delivery) {
		const self = this;
		const { state } = self;
		const { items } = state.createOrderForm.params;
		let fdd = null;
		const deliveryItems = items.filter(item => item.requestedDeliveryDateBackUp === delivery && !item.originalOrderNumber && item.onHold !== 'Y');
		deliveryItems.forEach(item => {
			if(item.geego_distribution_start_date && moment(item.geego_distribution_start_date).isAfter(moment())) {
				if(!fdd || moment(fdd).isBefore(moment(item.geego_distribution_start_date))) {
					fdd = item.geego_distribution_start_date;
				}
			}
		});
		if(fdd) {
			fdd = moment(fdd).startOf('day');
		}
		return fdd;
	}

	componentDidMount() {
		const self = this;
		window.scrollTo(0, 0);
		if(!self.props.state.order.createOrderPayload) {
			browserHistory.push("/manageorders");
			return;
		}
		const { selectedAccount } = self.props.state.user;
		const addressList = self.props.getCombinedAddresses();
		let addressList1 = JSON.parse(JSON.stringify(addressList));
		if(addressList1) {
			addressList1 = _.filter(addressList1, {PURPOSE: "BILL_TO"});
		}
		let shippingAddressList = JSON.parse(JSON.stringify(addressList));
		if(shippingAddressList) {
			shippingAddressList = _.filter(shippingAddressList, {PURPOSE: "SHIP_TO"});
			shippingAddressList = _.orderBy(shippingAddressList, ['PRIMARYINDICATOR'], ['desc']);
		}
		let billingAddressList = JSON.parse(JSON.stringify(addressList));
		if(billingAddressList) {
			if(billingAddressList.find(itm => itm.PURPOSE === "BILL_TO")) {
				billingAddressList = billingAddressList.filter(itm => itm.PURPOSE === "BILL_TO");
			} else {
				billingAddressList = billingAddressList.filter(itm => itm.PURPOSE === "SOLD_TO");
			}
		}
		const billingAddress = billingAddressList && billingAddressList.length > 0 && billingAddressList[0];

		const { createOrderPayload } = self.props.state.order;
		let itemsNames ='';
		self.state.createOrderForm.params.items.map((item)=>{
			itemsNames = `${itemsNames} ${item.item}`;
			if(item.itemType == 'M' && item.shippingAddress){
				item.shippingAddress.country = self.props.state.user.selectedAddress && JSON.parse(self.props.state.user.selectedAddress).COUNTRY;
				item.shippingAddress.state = self.state.createOrderForm.params.shippingAddress.state;
				}
		})
		self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${itemsNames.trim()}&accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${self.props.getZipCode()}&page=search`, resp => {
			self.setState({
				searchKeywordItem : resp.responseObject		
			})
			});
		createOrderPayload.items.map(itm =>{
			itm.requestedDeliveryDateBackUp = itm.requestedDeliveryDate;
		})
		if(createOrderPayload && createOrderPayload.shippingAddressList) {
			shippingAddressList = createOrderPayload.shippingAddressList;
		}
		localStorage.setItem("RDDate", JSON.stringify(self.state.createOrderForm.params.requestedDeliveryDate))
		self.setState({
			addressList: addressList1,
			shippingAddressList,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					billingAddress: {
						name: selectedAccount.ORGANIZATIONNAME,
						address1: billingAddress.ADDRESS1,
						address2: "",
						address3: "",
						address4: "",
						city: billingAddress.CITY,
						state: billingAddress.STATE,
						zip: billingAddress.POSTALCODE,
						phone: '',
						addressId: billingAddress.SITE_USE_ID,
						county: billingAddress.COUNTY,
					},
					shippingAddress: {
						...self.state.createOrderForm.params.shippingAddress,
						name: self.state.createOrderForm.params.shippingAddress.addressName || selectedAccount.ORGANIZATIONNAME,
						country:self.props.state.user.selectedAddress && JSON.parse(self.props.state.user.selectedAddress).COUNTRY,
						state:self.state.createOrderForm.params.shippingAddress.state
					}
				}
			}
		}, () => {
			if(self.state.createOrderForm.params.shippingAddress && (!self.state.createOrderForm.params.shippingAddress.addressId || self.state.createOrderForm.params.shippingAddress.addressId === 'null')) {
				const { shippingAddressList } = self.state,
					{ shippingAddress } = self.state.createOrderForm.params;
				if(shippingAddressList && shippingAddressList.length > 0) {
					const data = _.find(shippingAddressList, {
						ADDRESS1: shippingAddress.address1,
						CITY: shippingAddress.city,
						STATE: shippingAddress.state,
						POSTALCODE: shippingAddress.zip
					});
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								items: self.props.checkGroupShipDateByAvailabilityAndDelivery(self.state.createOrderForm.params.items),
								shippingAddress: {
									...self.state.createOrderForm.params.shippingAddress,
									SITEID: data && data.SITEID,
									addressId: data && data.SITE_USE_ID
								}
							}
						}
					}, () => {
						const { createOrderPayload } = self.props.state.order;
						const deliveryMethod = createOrderPayload.deliveryMethod;
						self.updateDeliveryMethodDropdown(() => {
							const {
								date,
								date2,
								date3,
								minDate1,
								minDate2,
								minDate3,
								maxDate1,
								maxDate2,
								maxDate3,
								createOrderForm: {
									params: {
										requestedDeliveryDate,
										requestedDeliveryDate2,
										requestedDeliveryDate3,
									}
								}
							} = self.getUpdatedDateAsOrMinDate(deliveryMethod);
							self.setState({
								date,
								date2,
								date3,
								minDate1,
								minDate2,
								minDate3,
								maxDate1,
								maxDate2,
								maxDate3,
								createOrderForm: {
									...self.state.createOrderForm,
									params: {
										...self.state.createOrderForm.params,
										deliveryMethod: createOrderPayload.deliveryMethod === 'FedEx Ground' ? '' : createOrderPayload.deliveryMethod,
										requestedDeliveryDate,
										requestedDeliveryDate2,
										requestedDeliveryDate3,
									}
								},
							}, () => {
										self.checkIfNeedToAddOrRemoveM038();
							});
						}, true);
						self.updateOrderPoints();
					});
				}
			} else {
				self.updateDeliveryMethodDropdown(() => {
					const { deliveryMethod } = self.state.createOrderForm.params;
					// This scenario we are checking specifically for browser back in case if that item is not in list we are adding it back.
					const { shippingMethodList } = self.state;
					if(deliveryMethod !== 'FedEx Ground' && !shippingMethodList.find(itm => itm.label === deliveryMethod)) {
						shippingMethodList.push({
							label: deliveryMethod,
							value: deliveryMethod,
							display: true,
						});
					}
					self.setState({
						shippingMethodList,
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								deliveryMethod
							}
						}
					}, () => {
						const {
							date,
							date2,
							date3,
							minDate1,
							minDate2,
							minDate3,
							maxDate1,
							maxDate2,
							maxDate3,
							createOrderForm: {
								params: {
									requestedDeliveryDate,
									requestedDeliveryDate2,
									requestedDeliveryDate3,
								}
							}
						} = self.getUpdatedDateAsOrMinDate(deliveryMethod);
						const { shippingAddressList } = self.state,
							{ shippingAddress } = self.state.createOrderForm.params;
						let data = null;
						if(shippingAddressList && shippingAddressList.length > 0) {
							data = _.find(shippingAddressList, {
								ADDRESS1: shippingAddress.address1,
								CITY: shippingAddress.city,
								STATE: shippingAddress.state,
								POSTALCODE: shippingAddress.zip
							});
						}
						self.setState({
							date,
							date2,
							date3,
							minDate1,
							minDate2,
							minDate3,
							maxDate1,
							maxDate2,
							maxDate3,
							createOrderForm: {
								...self.state.createOrderForm,
								params: {
									...self.state.createOrderForm.params,
									items: self.props.checkGroupShipDateByAvailabilityAndDelivery(self.state.createOrderForm.params.items),
									shippingAddress: {
										...self.state.createOrderForm.params.shippingAddress,
										SITEID: data && data.SITEID,
										addressId: shippingAddress && shippingAddress.addressId,
									},
									requestedDeliveryDate,
									requestedDeliveryDate2,
									requestedDeliveryDate3,
								}
							},
						}, () => {
									self.checkIfNeedToAddOrRemoveM038();
						});
					});
				}, true);
				self.updateOrderPoints();
			}
		});
	}

	updateSDSDeliveryCalendar = payload => {
		if (this.deliveryCalendarAPITimeoutId !== undefined) {
			clearTimeout(this.deliveryCalendarAPITimeoutId);
		}

		this.deliveryCalendarAPITimeoutId = setTimeout(() => {
			const proceedToOrderReview = this.proceedToOrderReview;
			if (this.proceedToOrderReview) {
				this.proceedToOrderReview = false;
			}
			this.props.getDeliveryCalendar(payload, 'requestType=getSdsCalendar', true, deliveryCalendarResponse => {
				if (this.deliveryCalendarPayload.mode === payload.mode && this.deliveryCalendarPayload.zipcode === payload.zipcode &&
					this.deliveryCalendarPayload.state === payload.state && this.deliveryCalendarPayload.deliveryAgent === payload.deliveryAgent) {
					let dates = [];
					if (deliveryCalendarResponse && deliveryCalendarResponse.responseObject && deliveryCalendarResponse.responseObject.calendar_dates && deliveryCalendarResponse.responseObject.calendar_dates.length) {
						dates = deliveryCalendarResponse.responseObject.calendar_dates;
					}

					this.setState({
						sdsDeliveryCalendar: { ...this.deliveryCalendarPayload, dates }
					}, () => {
						this.updateMinimumDeliveryDateByDelivery(() => {
							if (proceedToOrderReview) {
								const { date, date2, date3 } = this.state;
								const requestedDeliveryDateError = this.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery1') && !date ? "error" : "";
								const requestedDeliveryDate2Error = this.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery2') && !date2 ? "error" : "";
								const requestedDeliveryDate3Error = this.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery3') && !date3 ? "error" : "";

								this.setState({
									createOrderForm: {
										...this.state.createOrderForm,
										errors: {
											...this.state.createOrderForm.errors,
											requestedDeliveryDateError,
											requestedDeliveryDate2Error,
											requestedDeliveryDate3Error
										}
									}
								}, () => {
									if (!(this.state.createOrderForm.errors.requestedDeliveryDateError || this.state.createOrderForm.errors.requestedDeliveryDate2Error || this.state.createOrderForm.errors.requestedDeliveryDate3Error)) {
										this.checkIfDuplicatePOOrNot();
									}
								})
							} else {
								this.props.setAvailabilityError(null);
								this.setState({
									date: null,
									date2: null,
									date3: null,
									createOrderForm: {
										...this.state.createOrderForm,
										params: {
											...this.state.createOrderForm.params,
											requestedDeliveryDate: '',
											requestedDeliveryDate2: '',
											requestedDeliveryDate3: '',
											items: this.state.createOrderForm.params.items && this.props.checkGroupShipDateByAvailabilityAndDelivery(this.state.createOrderForm.params.items.map(item => {
													const { availability, eta, arrivalDate, groupArrivalDate, groupArrivalDateBkp, shipDate, groupShipDate, groupShipDateBkp, availabilityMessage, ...rest } = item;
													return rest;
												}))
										}
									}
								});
							}
						});
					})
				}
			});
		}, 100);
	};

	fetchFirstAvailableDateForADCShipping = payload => {
		if (this.deliveryCalendarAPITimeoutId !== undefined) {
			clearTimeout(this.deliveryCalendarAPITimeoutId);
		}

		this.deliveryCalendarAPITimeoutId = setTimeout(() => {
			const proceedToOrderReview = this.proceedToOrderReview;
			if (this.proceedToOrderReview) {
				this.proceedToOrderReview = false;
			}

			this.props.getDeliveryCalendar(payload, 'requestType=getAdcRdd', true, adcRDDResponse => {
				if (this.deliveryCalendarPayload.shipMethod === payload.shipMethod && this.deliveryCalendarPayload.sourceOrganizationCode === payload.sourceOrganizationCode &&
					this.deliveryCalendarPayload.requestedShipDate === payload.requestedShipDate && this.deliveryCalendarPayload.customerSiteID === payload.customerSiteID &&
					this.deliveryCalendarPayload.zipcode === payload.zipcode && this.deliveryCalendarPayload.state === payload.state && this.deliveryCalendarPayload.country === payload.country) {
					const adcDeliveryCalendar = {
						...this.deliveryCalendarPayload
					};

					if (!adcRDDResponse.responseObject || !adcRDDResponse.responseObject.requestDeliveryDate ||
							adcRDDResponse.responseObject.errorMsg && adcRDDResponse.responseObject.errorMsg.toUpperCase() === 'MRP_ATP_PUB.CALL_ATP IS RETURNED NULL VALUES , NEED TO CHECK WHY IT NOT WORKING') {
						adcDeliveryCalendar.firstAvailableCalendarDate = moment().add(3, 'days').format();
					} else {
						adcDeliveryCalendar.firstAvailableCalendarDate = this.props.pickTheDateFromString(adcRDDResponse.responseObject.requestDeliveryDate, 'MM/DD/YYYY');
					}

					this.setState({
						adcDeliveryCalendar
					}, () => {
						this.updateMinimumDeliveryDateByDelivery(() => {
							if (proceedToOrderReview) {
								const { date, date2, date3 } = this.state;
								const requestedDeliveryDateError = this.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery1') && !date ? "error" : "";
								const requestedDeliveryDate2Error = this.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery2') && !date2 ? "error" : "";
								const requestedDeliveryDate3Error = this.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery3') && !date3 ? "error" : "";

								this.setState({
									createOrderForm: {
										...this.state.createOrderForm,
										errors: {
											...this.state.createOrderForm.errors,
											requestedDeliveryDateError,
											requestedDeliveryDate2Error,
											requestedDeliveryDate3Error
										}
									}
								}, () => {
									if (!(this.state.createOrderForm.errors.requestedDeliveryDateError || this.state.createOrderForm.errors.requestedDeliveryDate2Error || this.state.createOrderForm.errors.requestedDeliveryDate3Error)) {
										this.checkIfDuplicatePOOrNot();
									}
								})
							} else {
								this.props.setAvailabilityError(null);
								this.setState({
									date: null,
									date2: null,
									date3: null,
									createOrderForm: {
										...this.state.createOrderForm,
										params: {
											...this.state.createOrderForm.params,
											requestedDeliveryDate: '',
											requestedDeliveryDate2: '',
											requestedDeliveryDate3: '',
											items: this.state.createOrderForm.params.items && this.props.checkGroupShipDateByAvailabilityAndDelivery(this.state.createOrderForm.params.items.map(item => {
													const { availability, eta, arrivalDate, groupArrivalDate, groupArrivalDateBkp, shipDate, groupShipDate, groupShipDateBkp, availabilityMessage, ...rest } = item;
													return rest;
												}))
										}
									}
								});
							}
						});
					})
				}
			})
		}, 100);
	}

	getShipMethod = deliveryMethod => {
		switch(deliveryMethod) {
			case 'LTIA Ocean Ocean Full Container':
				return 'LTIA-Ocean-Ocean-Full Container';
			case 'MATU Ocean Ocean Full Container':
				return 'MATU-Ocean-Ocean-Full Container';
			default:
				return deliveryMethod;
		}
	}

	componentDidUpdate = () => {
		const { shippingAddress, deliveryMethod, warehouseCode  } = this.state.createOrderForm.params;
		const shipToZipCode = shippingAddress && shippingAddress.zip && shippingAddress.zip.split('-')[0];
		const shipToState = shippingAddress && shippingAddress.state;

		if (shipToZipCode && shipToState && deliveryMethod && warehouseCode) {
			// WCP-6753, For SDS Delivery and SDS Will Call, available dates are fetched from the delivery calendar API
			const mode = deliveryMethod === 'SDS Delivery' ? 'SDS' : deliveryMethod === 'SDS Will Call' ? 'WILLCALL' : null;
			const deliveryCalendarType = this.props.getDeliveryCalendarType(deliveryMethod);
			if (deliveryCalendarType === 'SDS') {
				if (!this.deliveryCalendarPayload ||
					!(
						this.deliveryCalendarPayload.zipcode === shipToZipCode &&
						this.deliveryCalendarPayload.state === shipToState &&
						this.deliveryCalendarPayload.mode === mode &&
						this.deliveryCalendarPayload.deliveryAgent === warehouseCode
					)) {
					const payload = {
						accountNo: this.props.state.user.selectedAccount.ACCOUNTNUMBER,
						zipcode: shipToZipCode,
						state: shipToState,
						mode,
						deliveryAgent: warehouseCode,
						noOfDays: 180
					};
					this.deliveryCalendarPayload = { ...payload, deliveryMethod };
					this.updateSDSDeliveryCalendar(payload);
				}
			} else if (deliveryCalendarType === 'ADC') {
				const shipMethod = this.getShipMethod(deliveryMethod);
				if (!this.deliveryCalendarPayload || !(this.deliveryCalendarPayload.shipMethod === shipMethod && this.deliveryCalendarPayload.sourceOrganizationCode === (this.state.createOrderForm.params.alternateADC || warehouseCode) &&
					this.deliveryCalendarPayload.customerSiteID === shippingAddress.addressId)) {
					let state = shipToState;
					if (shippingAddress.country === 'CA') {
						const province = countries.find(country => country.code === 'CA').regions.find(region => region.name.toUpperCase() === shipToState.toUpperCase() || region.code.toUpperCase() === shipToState.toUpperCase());
						state = province && province.code;
					}
					const payload = {
						accountNo: this.props.state.user.selectedAccount.ACCOUNTNUMBER,
						shipMethod,
						sourceOrganizationCode: this.state.createOrderForm.params.alternateADC || warehouseCode,
						requestedShipDate: moment.tz('America/New_York').format('YYYY-MM-DD'),
						customerSiteID: shippingAddress.addressId,
						zipcode: shippingAddress.country === 'US' ? shipToZipCode : undefined,
						state,
						country: shippingAddress.country || undefined
					};

					this.deliveryCalendarPayload = { ...payload };
					this.fetchFirstAvailableDateForADCShipping(payload);
				}
			}
		}
	};

	componentWillUnmount() {
		if (this.deliveryCalendarAPITimeoutId) {
			clearTimeout(this.deliveryCalendarAPITimeoutId);
		}
	}

	updateOrderPoints() {
		const self = this;
		const { items } = self.state.createOrderForm.params;
		let pointValue = 0.00;
		let orderWeight = 0.00;
		items.forEach(item => {
			if(item.item !== "M038" && item.onHold !== 'Y' && item.quantity) {
				pointValue += (item.quantity * item.perItemPointValue);
				orderWeight += (item.quantity * item.perItemWeight);
			}
		});
		pointValue = parseFloat(pointValue).toFixed(2);
		orderWeight	= parseFloat(orderWeight).toFixed(2);
		setTimeout(() => {
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						pointValue,
						orderWeight,
					}
				}
			});
		}, 100);
	}

	getShippingAddressZipCode() {
		const self = this;
		const { defaultShippingAddress, createOrderForm } = self.state;
		const { shippingAddress } = createOrderForm.params;
		if(shippingAddress && shippingAddress.zip) {
			return shippingAddress.zip.split("-")[0];
		}
		return defaultShippingAddress.zip && defaultShippingAddress.zip.split("-")[0];
	}

	getShippingAddressState() {
		const self = this;
		const { defaultShippingAddress, createOrderForm } = self.state;
		const { shippingAddress } = createOrderForm.params;
		if(shippingAddress && shippingAddress.zip) {
			return shippingAddress.state;
		}
		return defaultShippingAddress.state;
	}

	updateDeliveryMethodDropdown(callback, firstTimeCalled) {
		const self = this;
		self.props.getOrgAttributesByAttributeName("EDI Velocity Indicator", resp => {
			self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), () => {
				self.setState({
					isSDS_LOC: self.checkLocTypeAvailableEditOrderFlow('sds_loc'),
					isSDS_will_call_loc: self.checkLocTypeAvailableEditOrderFlow('sds_will_call_loc'),
					isADC_will_call_loc: self.checkLocTypeAvailableEditOrderFlow('adc_will_call_loc'),
					isADC_loc: self.checkLocTypeAvailableEditOrderFlow('adc_loc'),
					disabledDeliveryDropdown: false,
				}, () => {
					const { shippingMethodData } = self.props.state.order;
					// if its getting called first time then use saved delivery method instead of shippingMethod
					let deliveryMethod = (shippingMethodData && shippingMethodData.responseObject) || "";
					let shippingMethodList = JSON.parse(JSON.stringify(self.props.state.order.shippingMethodList));
					const typeOfAccount = self.props.getSelectedAccountType();
					const isNewAddress = self.state.createOrderForm.params.shippingAddress.newAddress;
					// Update shipping methods as per shippng service
					shippingMethodList.forEach((item) => {
						if (deliveryMethod === "MATU-Ocean-Ocean-Full Container") {
							// If the Ship Method from the SA defaults to MATU-Ocean-Ocean-Full Container also offer ADC LTL and ADC Truckload.
							if(item.value === "ADC Truckload" || item.value === "ADC LTL" || item.value === "MATU-Ocean-Ocean-Full Container") {
								item.display = true;
							} else {
								item.display = false;
							}
						} else {
							if((item.value === "SDS Delivery" || (item.value === "SDS Delivery Next Day" && typeOfAccount !== 'RETAIL')) && self.state.isSDS_LOC) {
								item.display = true;
							} else if((item.value === "ADC Truckload") && self.state.isADC_loc) {
								item.display = true;
							} else if(item.value === "SDS Will Call" && self.state.isSDS_will_call_loc) {
								item.display = true;
							} else if(item.value === "ADC Will Call" && self.state.isADC_will_call_loc) {
								item.display = true;
							} else if(item.value === "ADC LTL" && (deliveryMethod === "ADC LTL" || !self.state.isSDS_LOC)) {
								// to keep this option for next comparision we have to set it true always here
								item.display = true;
							} else if(item.value === "LTIA-Ocean-Ocean-Full Container" && deliveryMethod === "LTIA-Ocean-Ocean-Full Container") {
								// to keep this option for next comparision we have to set it true always here
								item.display = true;
							} else if(item.value === "ADC Velocity" && self.state.isADC_loc && resp && !isNewAddress) {
								item.display = true;
							} else {
								item.display = false;
							}
						}
					});
					if(self.state.isSDS_will_call_loc && deliveryMethod !== 'ADC Will Call') {
						shippingMethodList = _.pullAllBy(shippingMethodList, [{value: 'ADC Will Call'}], 'value');
					} else if(self.state.isADC_will_call_loc) {
						shippingMethodList = _.pullAllBy(shippingMethodList, [{value: 'SDS Will Call'}], 'value');
					}
					// filter out which we dont have to display
					shippingMethodList = shippingMethodList.filter(itm => itm.display);

					// Update shipping methods as per shipping method service response
					let disabledDeliveryDropdown = false;
					// -> if "SHIPPING_METHOD" is there in SA and "ENFORCE_SHIPPING_METHOD_FLAG": "N"
					// -> then show that shipping method
					if(self.props.state.user.selectedPriceSource && self.props.state.user.selectedPriceSource.ENFORCE_SHIPPING_METHOD_FLAG === 'N') {
						// -> if "SHIPPING_METHOD" from SA is "ADC LTL" then only show this.. else dont show ADC LTL at all in the drop down
						if(deliveryMethod) {
							shippingMethodList.forEach((item) => {
								if(shippingMethodData.responseObject === item.value) {
									item.display = true;
								}
							});
						}
					}
					if(deliveryMethod && shippingMethodList.find(itm => itm.display && itm.value === shippingMethodData.responseObject)) {
						// if "SHIPPING_METHOD" from SA is "MATU-Ocean-Ocean-Full Container" or "LTIA-Ocean-Ocean-Full Container", dont show any other options.. warehouseCode should be hardcoded as "SEA"
						let shippingMethod = shippingMethodData.responseObject;
						// if first time getting called then set order details delivery method
						if (firstTimeCalled) {
							shippingMethod = self.state.createOrderForm.params.deliveryMethod;
						}
						// if EDI Velocity indicator and ADC loc then select adc velocity without checking other things
						else if (resp && self.state.isADC_loc && !isNewAddress) {
							shippingMethod = 'ADC Velocity';
						}
						// If the SA defaults to the ship method ADC Velocity, but the Ship To site Velocity Indicator is N, default to ADC Truckload instead.
						else if (!resp && shippingMethod === 'ADC Velocity') {
							shippingMethod = 'ADC Truckload';
						} else if (shippingMethod === "LTIA-Ocean-Ocean-Full Container") {
							shippingMethodList.forEach((item) => {
								if(shippingMethodData.responseObject === item.value) {
									item.display = true;
								} else {
									item.display = false;
								}
							});
						}
						// if "SHIPPING_METHOD" from SA is "ADC Truckload", offer SDS Will Call (if applicable in territory) and SDS Delivery (if applicable in territory).
						else if (shippingMethod === "ADC Truckload") {
							shippingMethodList.forEach((item) => {
								if(self.state.isSDS_will_call_loc && item.value === 'SDS Will Call' ) {
									item.display = true;
								} else if(!self.state.isSDS_will_call_loc && self.state.isADC_will_call_loc && item.value === 'ADC Will call') {
									item.display = true;
								} else if(self.state.isSDS_LOC && item.value === 'SDS Delivery') {
									item.display = true;
								} else if(!self.state.isSDS_LOC && self.state.isADC_loc && item.value === 'ADC LTL') {
									item.display = true;
								}
							});
						}
						// -> if "SHIPPING_METHOD" is there in SA and "ENFORCE_SHIPPING_METHOD_FLAG": "Y"
						// -> then show that shipping method and disable the drop down... user can't change.....
						if(self.props.state.user.selectedPriceSource && self.props.state.user.selectedPriceSource.ENFORCE_SHIPPING_METHOD_FLAG === 'Y') {
							disabledDeliveryDropdown = true;
						}
						deliveryMethod = shippingMethod;
					} else {
						// If the SA defaults to the ship method ADC Velocity, but the Ship To site Velocity Indicator is N, default to ADC Truckload instead.
						if (!resp && shippingMethodData && shippingMethodData.responseObject === 'ADC Velocity') {
							deliveryMethod = 'ADC Truckload';
						}
						// if "SHIPPING_METHOD" is not there in SA, then default to SDS Delivery if available from shipping service else "ADC Truckload" as the default
						else if(shippingMethodList.find(itm => itm.display && itm.value === "SDS Delivery")) {
							deliveryMethod = "SDS Delivery";
						} else if(shippingMethodList.find(itm => itm.display && itm.value === "ADC Truckload")) {
							deliveryMethod = "ADC Truckload";
						}
					}

					// This is specic for EDIT order functionality
					// if this flag is true it means, delivery method is ADC Velocity, so we have to keep that method selected and disabled the dropdown
					if (self.state.disableDeliveryAndShippingAddressDropdown) {
						deliveryMethod = "ADC Velocity";
						shippingMethodList.forEach((item) => {
							if(item.value === "ADC Velocity") {
								item.display = true;
							} else {
								item.display = false;
							}
						});
					}

					// filter out which we dont have to display
					shippingMethodList = shippingMethodList.filter(itm => itm.display);

					let newState = {
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								deliveryMethod: shippingMethodList.length === 0 ? '' : deliveryMethod,
							},
							errors: {
								...self.state.createOrderForm.errors,
								deliveryMethodError: '',
							}
						},
						shippingMethodList,
						disabledDeliveryDropdown
					}
					// If shipping method needs calendar api call, we clear the dates and let the user select from the datepicker
					if (['ADC', 'SDS'].includes(self.props.getDeliveryCalendarType(deliveryMethod))) {
						newState = {
							...newState,
							date: null,
							date2: null,
							date3: null,
							createOrderForm: {
								...newState.createOrderForm,
								params: {
									...newState.createOrderForm.params,
									requestedDeliveryDate: '',
									requestedDeliveryDate2: '',
									requestedDeliveryDate3: '',
									items: newState.createOrderForm.params.items && self.props.checkGroupShipDateByAvailabilityAndDelivery(newState.createOrderForm.params.items.map(item => {
											const { availability, eta, arrivalDate, groupArrivalDate, groupArrivalDateBkp, shipDate, groupShipDate, groupShipDateBkp, availabilityMessage, ...rest } = item;
											return rest;
										}))
								}
							}
						}
					} else {
						const {
							date,
							date2,
							date3,
							minDate1,
							minDate2,
							minDate3,
							maxDate1,
							maxDate2,
							maxDate3,
							createOrderForm: {
								params: {
									requestedDeliveryDate,
									requestedDeliveryDate2,
									requestedDeliveryDate3,
								}
							}
						} = self.getUpdatedDateAsOrMinDate(deliveryMethod);
						newState = {
							...newState,
							date,
							date2,
							date3,
							minDate1,
							minDate2,
							minDate3,
							maxDate1,
							maxDate2,
							maxDate3,
							createOrderForm: {
								...newState.createOrderForm,
								params: {
									...newState.createOrderForm.params,
									requestedDeliveryDate,
									requestedDeliveryDate2,
									requestedDeliveryDate3,
								}
							}
						};
					}
					
					self.setState(newState, () => {
						self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), () => {
							self.setState({
								isSDS_LOC: self.checkLocTypeAvailableEditOrderFlow('sds_loc'),
								isSDS_will_call_loc: self.checkLocTypeAvailableEditOrderFlow('sds_will_call_loc'),
								isADC_will_call_loc: self.checkLocTypeAvailableEditOrderFlow('adc_will_call_loc'),
								isADC_loc: self.checkLocTypeAvailableEditOrderFlow('adc_loc'),
								isCurrentLocTypeAvailable: self.checkLocTypeAvailableEditOrderFlow(self.getLocTypeAccordingToDeliveryMethod()),
							}, () => {
								let defaultLocType = self.getLocTypeAccordingToDeliveryMethod();
								if (!self.state.isCurrentLocTypeAvailable) {
									if (self.state.isSDS_LOC) {
										defaultLocType = 'sds_loc';
									} else if (self.state.isSDS_will_call_loc) {
										defaultLocType = 'sds_will_call_loc';
									} else if (self.state.isADC_will_call_loc) {
										defaultLocType = 'adc_will_call_loc';
									} else if (self.state.isADC_loc) {
										defaultLocType = 'adc_loc';
									}
								}
								self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, defaultLocType, resp => {
									if (self.checkIfStateIsAk()) {
										resp = {
											agentid: "SEA",
											dockcity: "SEATTLE"
										};
									}
									if (resp && resp.agentid) {
										const { deliveryMethod } = self.state.createOrderForm.params;
										self.setState({
											createOrderForm: {
												...self.state.createOrderForm,
												params: {
													...self.state.createOrderForm.params,
													alternateADC: (deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') ? resp.agentid : '',
													defaultAlternateADC: (deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') ? resp.agentid : '',
													defaultWarehouseDetails: {
														warehouseCode: resp.agentid,
														warehouseName: resp.dockname,
														warehouseCodeCity: resp.dockcity,
														warehouseLoctype: resp.loctype,
													},
													warehouseCode: resp.agentid,
													warehouseName: resp.dockname,
													warehouseCodeCity: resp.dockcity,
													warehouseLoctype: resp.loctype,
												}
											}
										}, () => {
											if(shippingMethodList.length === 0) {
												self.handleDialog('DoNotDeliverySelectedAddressOverlayDialog', true, null);
											}
											self.checkIfNeedToAddOrRemoveM038();
											callback && callback();
										});
									}
								}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
							});
						}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
					});
				});
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
		}, self.getSiteNumberOfSelectedShippingAddress());
	}

	checkLocTypeAvailable(loctype) {
		const self = this;
		let shippingAddressDetail = _.find(self.props.state.user.shippingAddressDetailsListWithZipCode, {zipCode: self.getShippingAddressZipCode()});
		let data = shippingAddressDetail && _.find(shippingAddressDetail.details, ["loctype", loctype]);
		if(data && data.agentid && data.agentid !== "NA") {
			return true;
		} else {
			return false;
		}
	}

	checkLocTypeAvailableEditOrderFlow(loctype) {
		const self = this;
		let shippingAddressDetailsListWithZipCodeFiltered= self.props.state.user.shippingAddressDetailsListWithZipCode.filter((el)=>el.state == self.getShippingAddressState())
		let shippingAddressDetail = _.find(shippingAddressDetailsListWithZipCodeFiltered, {zipCode: self.getShippingAddressZipCode()});
		let data = shippingAddressDetail && _.find(shippingAddressDetail.details, ["loctype", loctype]);
		if(data && data.agentid && data.agentid !== "NA") {
			return true;
		} else {
			return false;
		}
	}

	handleBlurOfRootLevelPO(event) {
		const self = this;
		const { blurCountOfRootLevelPO } = self.state;
		const value = event.target.value ? event.target.value.trim() : event.target.value;
		self.setState({
			headerLevelPO: value,
			genericDialogHeading: "Action",
			genericDialogText: 'Do you want to update the PO on ALL lines?',
			modalButtons: 'yes,no',
			blurCountOfRootLevelPO: blurCountOfRootLevelPO + 1
		}, () => {
			if (blurCountOfRootLevelPO === 0) {
				self.updatePoNumberAtLineLevel(true, event);
			} else {
				self.handleDialog("KeepOriginalPOGenericOverlayDialog", true);
			}
		});
	}
	updatePoNumberAtLineLevel(checkBlank, e) {
		e.preventDefault();
		const self = this;
		const value = self.state.headerLevelPO;
		let { items } = self.state.createOrderForm.params;
		items.forEach(item => {
			// if back order avail items
			if(item.originalOrderNumber) {
				// update only if keep original po is not Y
				if (item.keepOriginalPO !== 'Y') {
					item.poNumber = value;
				}
			} else if (checkBlank && !item.poNumber) {
				item.poNumber = value;
			} else if (!checkBlank) {
				item.poNumber = value;
			}
		});
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			}
		}, () => {
			self.handleDialog("KeepOriginalPOGenericOverlayDialog", false);
		});
	}

	getUpdatedDateAsOrMinDate(deliveryMethod) {
		const self = this;
		let minDate1 = moment().add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		let minDate2 = moment().add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		let minDate3 = moment().add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		let { date, date2, date3 } = self.state;
		let { requestedDeliveryDate, requestedDeliveryDate2, requestedDeliveryDate3 } = self.state.createOrderForm.params;
		if(deliveryMethod === 'ADC Will Call') {
			minDate1 = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
			minDate2 = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
			minDate3 = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
		}
		if(date && date.isBefore(minDate1)) {
			date = null;
			requestedDeliveryDate = '';
		}
		if(date2 && date2.isBefore(minDate2)) {
			date2 = null;
			requestedDeliveryDate2 = '';
		}
		if(date3 && date3.isBefore(minDate3)) {
			date3 = null;
			requestedDeliveryDate3 = '';
		}
		let maxDate1 = null;
		let maxDate2 = null;
		let maxDate3 = null;
		if (self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery1' && item.originalOrderNumber)) {
			maxDate1 = moment(minDate1).add(7, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		}
		if (self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery2' && item.originalOrderNumber)) {
			maxDate2 = moment(minDate2).add(7, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		}
		if (self.state.createOrderForm.params.items.find(item => item.requestedDeliveryDateBackUp === 'delivery3' && item.originalOrderNumber)) {
			maxDate3 = moment(minDate3).add(7, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
		}
		return {
			minDate1,
			minDate2,
			minDate3,
			maxDate1,
			maxDate2,
			maxDate3,
			date,
			date2,
			date3,
			createOrderForm: {
				params: {
					requestedDeliveryDate,
					requestedDeliveryDate2,
					requestedDeliveryDate3
				}
			}
		};
	}

	onChangeUpdateParam(event) {
        const self = this;
		const paramName = event.target.name;
		const value = paramName === 'poNumber' ? event.target.value.toUpperCase() : event.target.value;
		if (paramName === 'deliveryMethod') {
			self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(paramName === 'deliveryMethod' ? value : null), resp => {
				self.subUpdateParamFunction(value, paramName, resp);
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
		} else {
			self.subUpdateParamFunction(value, paramName, null);
		}
    }

	isDataSufficientForAvailabilityCheck = () => {
		const { createOrderForm: { params: { deliveryMethod, items }}, date, date2, date3 } = this.state;
		let isDataSufficientForAvailabilityCheck = false;
		if (deliveryMethod) {
			for (const item of items) {
				if (!item.originalOrderNumber) {
					switch(item.requestedDeliveryDate) {
						case 'delivery1':
							if (date) {
								return true;
							}
						case 'delivery2':
							if (date2) {
								return true;
							}
						case 'delivery3':
							if (date3) {
								return true;
							}
					}
				}
			}
		}
		return isDataSufficientForAvailabilityCheck;
	}

	subUpdateParamFunction(value, paramName, resp) {
		const self = this;
		let { errors } = self.state.createOrderForm,
			{ items } = self.state.createOrderForm.params;
		let isShipsetChanged = false;
		if(paramName === 'deliveryMode') {
			if(value === 'single') {
				delete errors.requestedDeliveryDate2Error;
				delete errors.requestedDeliveryDate3Error;
				items.forEach(itm => {
					// If an item which is not avail backorder and currently set to delivery2 or delivery3, we need to call orderAvailability again with changed shipset and deliverydate
					if (!itm.originalOrderNumber && itm.requestedDeliveryDate !== 'delivery1') {
						isShipsetChanged = true;
					}
					itm.requestedDeliveryDate = 'delivery1';
					itm.requestedDeliveryDateBackUp = 'delivery1';
				});
				items = self.props.checkGroupShipDateByAvailabilityAndDelivery(items);
			} else {
				errors = {
					...errors,
					requestedDeliveryDate2Error: '',
					requestedDeliveryDate3Error: '',
				};
				items.forEach(itm => {
					itm.requestedDeliveryDate = '';
				});
			}
		}
		if(paramName === 'deliveryMethod' && value === 'SDS Delivery Next Day') {
			items.forEach(itm => {
				delete itm.onForce;
			});
		}
		if(paramName === 'deliveryMethod') {
			if(!(value === "SDS Delivery" || value === 'SDS Delivery Next Day')) {
				items.forEach(itm => {
					itm.uncrateInd = 'N';
				});
			} else if (value === "SDS Delivery") {
				items.forEach(itm => {
					if (self.props.getAttributeBySalesAgreement(itm.agreementNumber, itm.geego_uncrateind) === 'Y') {
						itm.uncrateInd = 'Y';
					}
				});
			}
		}
		// Only in case of employee this needs to be updated
		let alternateADC = self.state.createOrderForm.params.alternateADC;
		let defaultAlternateADC = self.state.createOrderForm.params.defaultAlternateADC;
		if (paramName === 'deliveryMethod') {
			if(self.props.state.user.userDetails.typeOfUser === 'employee') {
				if (value === 'ADC Truckload' || value === 'ADC LTL') {
					alternateADC = resp.agentid ? resp.agentid:self.props.state.user.selectedADC;
					defaultAlternateADC = resp.agentid ? resp.agentid:self.props.state.user.selectedADC;
				} else {
					alternateADC = '';
					defaultAlternateADC = '';
				}
			} else {
				alternateADC = '';
				defaultAlternateADC = '';
			}
		}
		const {
			date,
			date2,
			date3,
			minDate1,
			minDate2,
			minDate3,
			createOrderForm: {
				params: {
					requestedDeliveryDate,
					requestedDeliveryDate2,
					requestedDeliveryDate3,
				}
			}
		} = (paramName === 'deliveryMethod' ? self.getUpdatedDateAsOrMinDate(value) : self.state);
		let checkAvailabilityOfAddedServices = false;
		// 1. update availability if alternateADC dropdown value change OR
		// 2. Existing delivery method is not ADC Truckload & ADC LTL but new value is either ADC Truckload or ADC LTL
		// 3. Existing delivery method is ADC Truckload & ADC LTL but new value is not ADC Truckload or ADC LTL
		const existingDeliveryMethod = self.state.createOrderForm.params.deliveryMethod;
		if(paramName === 'alternateADC' ||
			(
				self.props.state.user.userDetails.typeOfUser === 'employee' && paramName === 'deliveryMethod' &&
					((!(existingDeliveryMethod === 'ADC Truckload' || existingDeliveryMethod === 'ADC LTL') && (value === 'ADC Truckload' || value === 'ADC LTL')) ||
					(!(value === 'ADC Truckload' || value === 'ADC LTL') && (existingDeliveryMethod === 'ADC Truckload' || existingDeliveryMethod === 'ADC LTL')))
			)
		) {
			checkAvailabilityOfAddedServices = true;
		}
		const { deliveryMethod } = self.state.createOrderForm.params;
		if(self.props.state.user.userDetails.typeOfUser === 'employee' &&
			paramName === 'alternateADC' &&
			(deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') &&
			defaultAlternateADC !== value
		) {
			items.forEach(itm => {
				delete itm.onHold;
			});
		}
		self.setState({
			date,
			date2,
			date3,
			minDate1,
			minDate2,
			minDate3,
			invalidPONumberRootLevel: paramName === 'poNumber' ? '' : self.state.invalidPONumberRootLevel,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					requestedDeliveryDate,
					requestedDeliveryDate2,
					requestedDeliveryDate3,
					alternateADC,
					defaultAlternateADC,
					[paramName]: value,
					items,
				},
				errors
			}
		}, () => {
			if (isShipsetChanged && self.isDataSufficientForAvailabilityCheck()) {
				self.updateAvailability();
			}
			// if param name is alternateADC then update service availability
			if(checkAvailabilityOfAddedServices) {
				self.checkAvailabilityOfAddedServices(self.state.createOrderForm.params.shippingAddress.zip.split('-')[0]);
			}
			if(paramName === "deliveryMethod" || paramName === "shippingAddress") {
				self.checkAvailabilityOfAddedServices(self.getShippingAddressZipCode());
			}
			let { items } = self.state.createOrderForm.params;
			if(paramName === "deliveryMethod") {
				self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
					if(value === "SDS Delivery Next Day") {
						let nextBusinessDay = moment().add(1, 'day');
						if(nextBusinessDay.day() === 6) {
							nextBusinessDay = moment().add(3, 'day');
						} else if(nextBusinessDay.day() === 7) {
							nextBusinessDay = moment().add(2, 'day');
						}
						let { errors, params } = self.state.createOrderForm;
						if(params.deliveryMode === 'single') {
							delete errors.requestedDeliveryDate2Error;
							delete errors.requestedDeliveryDate3Error;
						} else {
							errors = {
								...errors,
								requestedDeliveryDate2Error: '',
								requestedDeliveryDate3Error: '',
							};
						}
						self.setState({
							date: nextBusinessDay,
							date2: params.deliveryMode === 'multiple' ? nextBusinessDay : null,
							date3: params.deliveryMode === 'multiple' ? nextBusinessDay : null,
							createOrderForm: {
								...self.state.createOrderForm,
								params: {
									...self.state.createOrderForm.params,
									requestedDeliveryDate: nextBusinessDay.format('MM/DD/YYYY'),
									requestedDeliveryDate2: params.deliveryMode === 'multiple' ? nextBusinessDay.format('MM/DD/YYYY') : '',
									requestedDeliveryDate3: params.deliveryMode === 'multiple' ? nextBusinessDay.format('MM/DD/YYYY') : '',
									defaultWarehouseDetails: {
										warehouseCode: resp.agentid,
										warehouseName: resp.dockname,
										warehouseCodeCity: resp.dockcity,
										warehouseLoctype: resp.loctype,
									},
									warehouseCode: resp.agentid,
									warehouseName: resp.dockname,
									warehouseCodeCity: resp.dockcity,
									warehouseLoctype: resp.loctype,
								},
								errors: {
									...errors,
									requestedDeliveryDateError: "",
								}
							}
						}, () => {
							self.updateMinimumDeliveryDateByDelivery(() => {
								self.addM038ServiceItem();
							});
						});
					} else {
						let { errors, params } = self.state.createOrderForm;
						if(params.deliveryMode === 'single') {
							delete errors.requestedDeliveryDate2Error;
							delete errors.requestedDeliveryDate3Error;
						} else {
							errors = {
								...errors,
								requestedDeliveryDate2Error: '',
								requestedDeliveryDate3Error: '',
							};
						}
						items = items && self.props.checkGroupShipDateByAvailabilityAndDelivery(items.map(item => {
									const { availability, eta, arrivalDate, groupArrivalDate, groupArrivalDateBkp, shipDate, groupShipDate, groupShipDateBkp, availabilityMessage, ...rest } = item;
									return rest;
								}));
						self.setState({
							date: null,
							date2: null,
							date3: null,
							createOrderForm: {
								...self.state.createOrderForm,
								params: {
									...self.state.createOrderForm.params,
									requestedDeliveryDate: '',
									requestedDeliveryDate2: '',
									requestedDeliveryDate3: '',
									defaultWarehouseDetails: {
										warehouseCode: resp.agentid,
										warehouseName: resp.dockname,
										warehouseCodeCity: resp.dockcity,
										warehouseLoctype: resp.loctype,
									},
									items,
									warehouseCode: resp.agentid,
									warehouseName: resp.dockname,
									warehouseCodeCity: resp.dockcity,
									warehouseLoctype: resp.loctype,
								}
							}
						}, () => {
							self.updateMinimumDeliveryDateByDelivery(() => {
								self.removeM038ServiceItem();
							});
						});
					}
				}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
			}
			if(self.props.state.user.userDetails.typeOfUser === 'employee' && paramName === 'alternateADC' && (deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') &&
				alternateADC !== value){
					const adcDetails = self.props.state.user.adcList.find(itm => itm.label === value);
					const warehouseNameAdc =adcDetails? adcDetails.name:'';
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								alternateADC: value,
								warehouseCode:value,
								warehouseName: warehouseNameAdc,
							}
						}});

			}
			if(paramName === "deliveryMode" && value === 'multiple') {
				items.forEach(item => {
					item.requestedDeliveryDate = 'delivery1';
					item.requestedDeliveryDateBackUp = 'delivery1';
				});
			}
			setTimeout(() => {
				self.setState({
					createOrderForm: {
						...self.state.createOrderForm,
						params: {
							...self.state.createOrderForm.params,
							items
						}
					}
				}, () => {
					if(self.state.createOrderForm.errors[paramName + 'Error']) {
						self.setState({
							createOrderForm: {
								...self.state.createOrderForm,
								errors: {
									...self.state.createOrderForm.errors,
									[paramName+"Error"]: ""
								}
							}
						});
					}
				});
			}, 100);
		});
	}

	checkIfNeedToAddOrRemoveM038() {
		const self = this;
		if(self.state.createOrderForm.params.deliveryMethod === "SDS Delivery Next Day") {
			self.addM038ServiceItem();
		} else {
			self.removeM038ServiceItem();
		}
	}

	removeM038ServiceItem() {
		const items = _.pullAllBy(this.state.createOrderForm.params.items, [{item: 'M038'}], 'item');
		this.setState({
			disableCalendar: false,
			createOrderForm: {
				...this.state.createOrderForm,
				params: {
					...this.state.createOrderForm.params,
					items
				}
			}
		})
	}

	checkIfStateIsAk() {
		const self = this;
		const { shippingAddress } = self.state.createOrderForm.params;
		let flag = false;
		if((shippingAddress && shippingAddress.state === 'AK') || self.getDeliveryMethod().indexOf('Ocean') !== -1) {
			flag = true;
		}
		return flag;
	}

	addM038ServiceItem() {
		const self = this;
		const { defaultShippingAddress } = self.state;
		// make service call to get warehouseCode and then make pricing service call
		const { shippingAddress } = self.state.createOrderForm.params;
		self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
			if(self.checkIfStateIsAk()) {
				resp = {
					agentid: "SEA",
					dockcity: "SEATTLE"
				}
			}
			if(resp && resp.agentid) {
				const { selectedAccount, selectedPriceSource } = self.props.state.user;
				const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
				const servicesPayload = [{
					pricingEffectiveDate: moment().format('YYYYMMDD'),
					accountNumber,
					state: shippingAddress ? shippingAddress.state : defaultShippingAddress.state,
					whse: resp.agentid,
					zone: resp.sdsApZone,
					salesAgreementNumber,
					itemNumber: "M038"
				}];
				// Get all orderable services prices list
				self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
					if(resp.status) {
						// TO DO : Temporary conversion from json string to json
						resp.responseObject = JSON.parse(resp.responseObject);
						// Add logic to add service in to item
						const items = self.state.createOrderForm.params.items;
						resp.responseObject.items[0].unitPrice && items.push({
							item: "M038",
							itemDescription: "",
							itemType: "S",
							quantity: 1,
							price: resp.responseObject.items[0].unitPrice,
							extendedPrice: resp.responseObject.items[0].unitPrice,
							agreementNumber: self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER,
							requestedDeliveryDate: 'delivery1',
							requestedDeliveryDateBackUp: 'delivery1',
						});
						self.setState({
							disableCalendar: true,
							createOrderForm: {
								...self.state.createOrderForm,
								params: {
									...self.state.createOrderForm.params,
									items
								}
							}
						})
					}
				});
			}
		}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
	}

	onBlurUpdateQuantity(indx, sku, event) {
		if (event.target.value === '') {
			const self = this;
			self.onChangeUpdateItems(indx, sku, { target: { value: 1, name: event.target.name } });
		}
	}

	onChangeUpdateItems(indx, sku, event) {
        const self = this;
		let items = self.state.createOrderForm.params.items;
		let errors = self.state.createOrderForm.errors;
		let value = event.target.value;
		let itemDetails;
		items.forEach((item, index) => {
			if(indx === index) {
				if(event.target.name === "quantity") {
					itemDetails = item;
					value = value === "0" ? 1 : value;
					item[event.target.name+"Error"] = "";
					if(item.actionError) {
						item.actionError = "";
					}
					delete item.onHold;
					delete item.onForce;
					if(value) {
						item.pointValue = item.perItemPointValue * value;
						item.weight = item.perItemWeight * value;
					}
				}
				if(event.target.name === "requestedDeliveryDate") {
					itemDetails = item;
					item[event.target.name+"Error"] = "";
					item.originalDelivery = value;

					if(value === 'delivery1' && !(errors.requestedDeliveryDateError || errors.requestedDeliveryDateError === '')) {
						errors.requestedDeliveryDateError = '';
					}
					if(value === 'delivery2' && !(errors.requestedDeliveryDate2Error || errors.requestedDeliveryDate2Error === '')) {
						errors.requestedDeliveryDate2Error = '';
					}
					if(value === 'delivery3' && !(errors.requestedDeliveryDate3Error || errors.requestedDeliveryDate3Error === '')) {
						errors.requestedDeliveryDate3Error = '';
					}
					item["requestedDeliveryDateBackUp"] = value;
					if(this.isBackOrderEligible(item,null)){
						item.actionError = "";
					}
				}
				if(event.target.name === 'poNumber') {
					item.invalidPONumberItemLevel = false;
				}
				item[event.target.name] = value;
			}
		});
		items = self.props.checkGroupShipDateByAvailabilityAndDelivery(items);
		const formElementName = event.target.name;
        self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			}
        }, () => {
			self.updateOrderPoints();
			if(formElementName === "quantity" && value) {
				self.setState({
					isRequiredToMakeRecursiveAvailabilityCall: true,
					currentIndex: indx,
				}, () => {
					self.isDataSufficientForAvailabilityCheck() && self.updateAvailability();
				});
			}
			if(formElementName === 'requestedDeliveryDate') {
				if (!itemDetails.originalOrderNumber) {
					self.isDataSufficientForAvailabilityCheck() && self.updateAvailability(() => {
						self.updateMinimumDeliveryDateByDelivery();
					});
				}
			}
		});
    }

	handleInvoicePreferencesChange(ind, event) {
		let billingReference = this.state.createOrderForm.params.billingReference;
		billingReference.forEach((item, index) => {
			if(index === ind) {
				item.value = event.target.value;
				item.error = '';
			}
		});
		this.setState({
			createOrderForm: {
				...this.state.createOrderForm,
				params: {
					...this.state.createOrderForm.params,
					billingReference: billingReference
				}
			}
		})
	}

	updatePerItemPointValueByTopLoadIndicator() {
		const self = this;
		let attributeName = "geego_top_load";
		if(self.isNewAddressSelected()) {
			const items = JSON.parse(JSON.stringify(self.state.createOrderForm.params.items));
			items.forEach(itm => {
				itm.perItemPointValue = itm.perItemPointValueTopLoad;
			});
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						items
					}
				}
			}, () => {
				self.updateOrderPoints();
			});
		} else {
			self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
				if(!resp) {
					attributeName = "geego_no_top_load";
				};
				const items = JSON.parse(JSON.stringify(self.state.createOrderForm.params.items));
				items.forEach(itm => {
					if(attributeName === "geego_no_top_load") {
						itm.perItemPointValue = itm.perItemPointValueNoTopLoad;
					} else {
						itm.perItemPointValue = itm.perItemPointValueTopLoad;
					}
				});
				self.setState({
					createOrderForm: {
						...self.state.createOrderForm,
						params: {
							...self.state.createOrderForm.params,
							items
						}
					}
				}, () => {
					self.updateOrderPoints();
				});
			}, self.getSiteNumberOfSelectedShippingAddress());
		}
	}

	handleUpdateShippingAddress(event) {
		const self = this;
		const shippingAddressList = self.state.shippingAddressList;
		let updatedShippingAddress = {};
		shippingAddressList.map((item, index) => {
			if(item.ADDRESS1.toString() === event.target.value) {
				updatedShippingAddress = Object.assign(JSON.parse(JSON.stringify(item)));
			}
			return null;
		});
		// Reseting onhold and onforce on change of address as it may happen previously it is set
		const items = self.state.createOrderForm.params.items;
		items.forEach((item, index) => {
			delete item.actionError;
			delete item.onHold;
			delete item.onForce;
		});
		const previousZipCode = self.state.createOrderForm.params.shippingAddress && self.state.createOrderForm.params.shippingAddress.zip;
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items,
					shippingAddress: {
						...self.state.createOrderForm.params.shippingAddress,
						address1: updatedShippingAddress && updatedShippingAddress.ADDRESS1,
						address2: updatedShippingAddress && updatedShippingAddress.ADDRESS2 ? updatedShippingAddress.ADDRESS2 : "",
						address3: updatedShippingAddress && updatedShippingAddress.ADDRESS3 ? updatedShippingAddress.ADDRESS3 : "",
						address4: updatedShippingAddress && updatedShippingAddress.ADDRESS4 ? updatedShippingAddress.ADDRESS4 : "",
						city: updatedShippingAddress && updatedShippingAddress.CITY,
						state: updatedShippingAddress && (updatedShippingAddress.COUNTRY === 'US' ? updatedShippingAddress.STATE : (updatedShippingAddress.STATE || updatedShippingAddress.PROVINCE)),
						zip: updatedShippingAddress && updatedShippingAddress.POSTALCODE,
						addressId: updatedShippingAddress && updatedShippingAddress.SITE_USE_ID,
						county: updatedShippingAddress && updatedShippingAddress.COUNTY,
						SITEID: updatedShippingAddress && updatedShippingAddress.SITEID,
						newAddress: updatedShippingAddress && updatedShippingAddress.NEWADDRESS,
					}
				},
				errors: {
					...self.state.createOrderForm.errors,
					shippingAddressError: '',
				}
			}
		}, () => {
			const existingDeliveryMethod = self.state.createOrderForm.params.deliveryMethod;
			self.updateDeliveryMethodDropdown(() => {
				self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
					if(self.checkIfStateIsAk()) {
						resp = {
							agentid: "SEA",
							dockcity: "SEATTLE"
						}
					}
					const deliveryMethod = self.state.createOrderForm.params.deliveryMethod;
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								alternateADC: (deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') ? resp.agentid : '',
								defaultAlternateADC: (deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') ? resp.agentid : '',
								defaultWarehouseDetails: {
									warehouseCode: resp.agentid,
									warehouseName: resp.dockname,
									warehouseCodeCity: resp.dockcity,
									warehouseLoctype: resp.loctype,
								},
								warehouseCode: resp.agentid,
								warehouseName: resp.dockname,
								warehouseCodeCity: resp.dockcity,
								warehouseLoctype: resp.loctype,
							}
						}
					}, () => {
						self.updatePerItemPointValueByTopLoadIndicator();
						const deliveryMethod = self.state.createOrderForm.params.deliveryMethod;
						if(self.props.state.user.userDetails.typeOfUser === 'employee') {
							// 1. Existing delivery method is not ADC Truckload & ADC LTL but new value is either ADC Truckload or ADC LTL
							// 2. Existing delivery method is ADC Truckload & ADC LTL but new value is not ADC Truckload or ADC LTL
							if(
								(!(existingDeliveryMethod === 'ADC Truckload' || existingDeliveryMethod === 'ADC LTL') && (deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL')) ||
								(!(deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL') && (existingDeliveryMethod === 'ADC Truckload' || existingDeliveryMethod === 'ADC LTL'))
							) {
								self.setState({
									isRequiredToMakeRecursiveAvailabilityCall: false,
								}, () => {
									self.isDataSufficientForAvailabilityCheck() && self.updateAvailability();
								});
								self.checkAvailabilityOfAddedServices(updatedShippingAddress.POSTALCODE.split('-')[0]);
							} else if(updatedShippingAddress && previousZipCode !== updatedShippingAddress.POSTALCODE && self.state.shippingMethodList.length > 0) {
								self.setState({
									isRequiredToMakeRecursiveAvailabilityCall: false,
								}, () => {
									self.isDataSufficientForAvailabilityCheck() && self.updateAvailability();
								});
								self.checkAvailabilityOfAddedServices(updatedShippingAddress.POSTALCODE.split('-')[0]);
							}
						} else if(updatedShippingAddress && previousZipCode !== updatedShippingAddress.POSTALCODE && self.state.shippingMethodList.length > 0) {
							self.setState({
								isRequiredToMakeRecursiveAvailabilityCall: false,
							}, () => {
								self.isDataSufficientForAvailabilityCheck() && self.updateAvailability();
							});
							self.checkAvailabilityOfAddedServices(updatedShippingAddress.POSTALCODE.split('-')[0]);
						}
					});
				}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
			});
		});
	}

	checkAvailabilityOfProducts(zipCode, state) {
		const self = this;
		const { params } = self.state.createOrderForm,
			skuList = [];
		params.items.forEach(item => {
			skuList.push({ sku: item.item, demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '') });
		});
		zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
			if(resp && resp.agentid) {
				// Make availability call
				// pass warehouseCode as alternateADC if it is set else pass it from selected shipping address zipcode's agentid
				self.props.checkAvailabilityGroupByDemandClass(skuList, `accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${zipCode}&warehouseCode=${self.state.createOrderForm.params.alternateADC || resp.agentid}`, true, self.getSelectedAddressParams(), '', true, response => {
					const availabilityData = response.responseObject;
					if(availabilityData.length > 0) {
						const { items } = self.state.createOrderForm.params;
						items.forEach(itm => {
							const availability = availabilityData.find(it => itm.item === it.sku);
							if (availability) {
								itm.availability = availability.availableQty;
								itm.eta = availability.etaDate;
							}
						});
						self.setState({
							createOrderForm: {
								...self.state.createOrderForm,
								params: {
									...self.state.createOrderForm.params,
									items
								}
							}
						})
					}
				});
			}
		}, true, state, self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
	}

	checkAvailabilityOfAddedServices(zipCode) {
		// Check if any services are added for any product
		const self = this,
			itemnumbers = [],
			{ params } = self.state.createOrderForm;
		params.items.forEach(item => {
			const services = item.relatedServices && item.relatedServices.filter(itm => itm.type !== 'BAG' && !itm.isCustomService);
			if(services && services.length > 0) {
				itemnumbers.push(item.item);
			}
		});
		if(itemnumbers.length > 0) {
			// make service call to get warehouseCode and then make pricing service call
			zipCode && self.props.getShippingAddressesDetails(zipCode, false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
				if(self.checkIfStateIsAk()) {
					resp = {
						agentid: "SEA",
						dockcity: "SEATTLE"
					}
				}
				if(resp && resp.agentid) {
					const { deliveryMethod } = params;
					// Get all orderable services list
					self.props.getOrderableServices({
						OrderabilityRequest: {
							inventoryorg: resp.agentid,
							zipcode: zipCode,
							shipmethod: deliveryMethod,
							itemnumbers: _.uniq(itemnumbers)
						}
					}, "requestType=getOrderableServices", response => {
						if(response.status) {
							// Remove all services which are not available for current location
							let { items } = self.state.createOrderForm.params;
							const servicesPayload = [];
							const { selectedAccount, selectedPriceSource } = self.props.state.user;
							const { shippingAddress } = self.state.createOrderForm.params;
							const { defaultShippingAddress } = self.state;
							self.state.createOrderForm.params.items.forEach((item, index) => {
								if(item.relatedServices && item.relatedServices.length > 0) {
									const availableServices = _.filter(response.responseObject.OrderabilityResponse.orderability, {itemnumber: item.item});
									const finalServices = [];
									item.relatedServices.forEach(itm => {
										if(
											(!(itm.type && itm.type === 'BAG') && _.find(availableServices, {service: itm.serviceId})) ||
											itm.isCustomService
										) {
											finalServices.push(itm);
											const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
											servicesPayload.push({
												pricingEffectiveDate: moment().format('YYYYMMDD'),
												accountNumber,
								                state: shippingAddress ? shippingAddress.state : defaultShippingAddress.state,
												whse: resp.agentid,
								                zone: resp.sdsApZone,
												salesAgreementNumber,
												itemNumber: itm.serviceId
											});
										}
									});
									items[index] = {
										...items[index],
										relatedServices: finalServices
									}
								}
							});
							self.setState({
								createOrderForm: {
									...self.state.createOrderForm,
									params: {
										...self.state.createOrderForm.params,
										items
									}
								}
							}, () => {
								if(servicesPayload.length > 0) {
									// Get all orderable services prices list
									self.props.resetServicesPricesToCart([]);
									self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
										if(resp.status) {
											// let orderableServices = self.props.state.order.orderableServices;
											// TO DO : Temporary conversion from json string to json
											resp.responseObject = JSON.parse(resp.responseObject);
											if (resp.responseObject && resp.responseObject.items && resp.responseObject.items.length) {
												let { items } = self.state.createOrderForm.params;
												self.state.createOrderForm.params.items.forEach((item, index) => {
													if(item.relatedServices && item.relatedServices.length > 0) {
														const finalServices = [];
														item.relatedServices.forEach(itm => {
															if(!(itm.type && itm.type === 'BAG')) {
																const pricingData = _.find(resp.responseObject.items, {itemNumber: itm.serviceId});
																if (pricingData) {
																	finalServices.push({
																		...itm,
																		price: pricingData.unitPrice,
																		extendedPrice: pricingData.unitPrice
																	});
																}
															}
														});
														items[index] = {
															...items[index],
															relatedServices: finalServices
														}
													}
												});
												self.setState({
													createOrderForm: {
														...self.state.createOrderForm,
														params: {
															...self.state.createOrderForm.params,
															items
														}
													}
												});
											}
										}
									});
								}
							});
						}
					});
				}
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
		}
	}

	handlePriceSourceDialog(selectedPriceSource, dialog, flag, selectedItem, event) {
		event && event.preventDefault();
		this.setState({
			selectedPriceSource,
			selectedItem
		}, () => {
			this.handleDialog(dialog, flag, event);
		});
	}

	changeSelectedPriceSource(changedPriceSource) {
		const self = this;
		let anyChange = false;
		let items = self.state.createOrderForm.params.items;
		items.forEach((item, index) => {
			if(index === self.state.selectedSKUIndex && item.agreementNumber.toString() !== changedPriceSource.toString()) {
				anyChange = true;
				item.agreementNumber = changedPriceSource
			}
		})

		anyChange && self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			}
		}, () => {
			self.updatePricing(() => {
				self.updateCartWithLatestUpdatedItems();
			});
		});
	}

	handleSelectAction(index, item, fddItem, event) {
		const self = this,
			action = event.target.value;
		let items = [];
		// First delete action of current product first in order to keep it latest
		// It will get updated accordingly below
		const { deletedItems } = self.props.state.order;
		let isHoldSelected = null;
		self.state.createOrderForm.params.items.forEach((itm, indx) => {
			if(index === indx && item.alreadyAdded) {
				if(action === "D") {
					deletedItems.push(JSON.parse(JSON.stringify({
						...itm,
						action: 'delete'
					})));
				} else {
					const tmpItm = JSON.parse(JSON.stringify(itm));
					delete tmpItm.action;
					isHoldSelected = itm.onHold;
					delete tmpItm.onHold;
					delete tmpItm.onForce;
					items.push(tmpItm);
				}
			} else {
				items.push(JSON.parse(JSON.stringify(itm)));
			}
		});
		self.props.saveDeletedItems(deletedItems);
		if(action === "D" && !item.alreadyAdded) {
			items = _.filter(items, (item, indx) => indx !== index );
			if(items.length === 0) {
				browserHistory.push('/cart');
			}
		} else if(action === "P") {
			self.setState({
				selectedSKU: item.item,
				selectedSKUIndex: index,
				selectedPriceSource: item.agreementNumber,
			}, () => {
				self.handleDialog('SelectPriceSourceOverlayDialog', true, null);
			});
		} else if(action === "R"){
			self.setState({
				showReplaceProductOverlayDialog: false,
				selectedSKU: item.item,
				selectedSKUIndex: index,
				replacementSKUData: null
			}, () => {
				const skuList = item.replacementSKUs.map(itm => ({sku: itm, itemType: 'M', demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '') }));
				if(skuList.length > 0) {
					self.getAllProductsData(action, skuList, item.quantity, item.item, item.agreementNumber, () => {
						const { availabilityData, pricingData, pimData } = self.state;
						if(availabilityData.length > 0) {
							const availability = availabilityData[0];
							let salesPriceData = _.find(pricingData, itm => {
								return itm.sku === availability.sku && itm.originalPrice
							});
							const pimItemData = _.find(pimData, {item_number: availability.sku});
							if(availability && salesPriceData && pimItemData) {
								const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
								const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
								const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
								const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
								const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
								const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
								const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
								let uncrateInd = "N";
								if(pimItemData.geego_uncrateind) {
									let geego_uncrateind = pimItemData.geego_uncrateind;
									const { selectedAccountsAllPriceSources, selectedPriceSource } = self.props.state.user;
									const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
									if(record) {
										uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
									}
								}
								let attributeName = "geego_top_load";
								self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
									if(!resp && !self.isNewAddressSelected()) {
										attributeName = "geego_no_top_load";
									}
									let replacingBy = {
										item: availability.sku,
										itemDescription: pimItemData.item_description,
										availability: availability.availableQty,
										itemType: "M",
										eta: availability.etaDate,
										price: salesPriceData.originalPrice,
										originalPrice: salesPriceData.originalPrice,
										relatedServices: self.props.prepareBagItems(salesPriceData),
										pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * 1) : 0.00,
										perItemPointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00,
										// Top load indicator value for backup
										perItemPointValueTopLoad: pimItemData['geego_top_load'] && pimItemData['geego_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_top_load']) : 0.00,
										// No top load indicator value for backup
										perItemPointValueNoTopLoad: pimItemData['geego_no_top_load'] && pimItemData['geego_no_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_no_top_load']) : 0.00,
										brand: pimItemData['geego_brand'],
										category: pimItemData['item_catalog_group'],

										geego_final_production_date: pimItemData['geego_final_production_date'],
										geego_distribution_start_date: pimItemData['geego_distribution_start_date'],
										geego_uncrateind: pimItemData.geego_uncrateind,
										weight: self.props.getOrderWeightFromPimData(pimItemData, 1),
										perItemWeight: self.props.getOrderWeightFromPimData(pimItemData, 1),
										hasReplacement,
										hasSubstitute,
										hasUpgrade,
										replacementSKUs,
										substituteSKUs,
										upgradeSKUs,
										isFedexable,
										uncrateInd
									};
									self.setState({
										showReplaceProductOverlayDialog: true,
										replacementSKUData: {
											replacingTo: item,
											replacingBy
										}
									});
								}, self.getSiteNumberOfSelectedShippingAddress());
							} else {
								self.setState({
									showReplaceProductOverlayDialog: true,
									replacementSKUData: {
										replacingTo: item,
										replacingBy: null
									}
								});
							}
						} else {
							self.setState({
								showReplaceProductOverlayDialog: true,
								replacementSKUData: {
									replacingTo: item,
									replacingBy: null
								}
							});
						}
					})
				} else {
					self.setState({
						showReplaceProductOverlayDialog: true,
						replacementSKUData: {
							replacingTo: item,
							replacingBy: null
						}
					});
				}
			})
		} else if(action === "S"){
			self.setState({
				showSubstituteProductOverlayDialog: false,
				selectedSKU: item.item,
				selectedSKUIndex: index,
				substituteSKUData: null,
				selectedRDD: self.getRDDByDelivery(item),
				substituteLevel: 1
			}, () => {
				let currentItem = item;
				const recursiveSubstituteCheck = () => {
					const skuList = currentItem.substituteSKUs.map(sku => ({sku: sku, itemType: 'M', demandClass: self.props.getSalesAgreementParamForAvailability(currentItem.agreementNumber ? currentItem.agreementNumber.toString() : '')}));
					if(skuList.length > 0) {
						self.getAllProductsData(action, skuList, currentItem.quantity, currentItem.item, currentItem.agreementNumber, data => {
							const { availabilityData, pimData } = self.state;
							// Check if substituted item is avaiable with availableQty > 0
							if(availabilityData.length > 0) {
								const substituteSKUData = [];
								let attributeName = "geego_top_load";
								self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
									if(!resp && !self.isNewAddressSelected()) {
										attributeName = "geego_no_top_load";
									}
									availabilityData.forEach(item => {
										const availability = item;
										const pimItemData = _.find(pimData, {item_number: availability.sku});
										if(availability && pimItemData) {
											const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
											const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
											const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
											const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
											const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
											const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
											const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
											let uncrateInd = "N";
											if(pimItemData.geego_uncrateind) {
												let geego_uncrateind = pimItemData.geego_uncrateind;
												const { selectedAccountsAllPriceSources, selectedPriceSource } = self.props.state.user;
												const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
												if(record) {
													uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
												}
											}
											substituteSKUData.push({
												item: availability.sku,
												itemDescription: pimItemData.item_description,
												availability: availability.availableQty,
												itemType: "M",
												eta: availability.etaDate,
												price: null,
												originalPrice: null,
												relatedServices: null,
												pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * 1) : 0.00,
												perItemPointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00,
												// Top load indicator value for backup
												perItemPointValueTopLoad: pimItemData['geego_top_load'] && pimItemData['geego_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_top_load']) : 0.00,
												// No top load indicator value for backup
												perItemPointValueNoTopLoad: pimItemData['geego_no_top_load'] && pimItemData['geego_no_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_no_top_load']) : 0.00,
												brand: pimItemData['geego_brand'],
												category: pimItemData['item_catalog_group'],
												geego_final_production_date: pimItemData['geego_final_production_date'],
												geego_distribution_start_date: pimItemData['geego_distribution_start_date'],
												geego_uncrateind: pimItemData.geego_uncrateind,
												weight: self.props.getOrderWeightFromPimData(pimItemData, 1),
												perItemWeight: self.props.getOrderWeightFromPimData(pimItemData, 1),
												hasReplacement,
												hasSubstitute,
												hasUpgrade,
												replacementSKUs,
												substituteSKUs,
												upgradeSKUs,
												isFedexable,
												uncrateInd,
												substituteLevel: self.state.substituteLevel
											});
										}
									});
									if(substituteSKUData.length > 0) {
										self.setState({
											showSubstituteProductOverlayDialog: true,
											substituteSKUData
										});
									} else {
										self.setState({
											showSubstituteProductOverlayDialog: true,
											substituteSKUData: []
										});
									}
								}, self.getSiteNumberOfSelectedShippingAddress());
							} else {
								// WCP-7491: roll back
								// // check if this substituted item has further substitute or not
								// const pimItemData = _.find(pimData, {item_number: currentItem.substituteSKUs[0]});
								// const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
								// const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
								// // update currentItem here so in next recursive call it will use the latest details
								// if (hasSubstitute) {
								// 	currentItem = {
								// 		...currentItem,
								// 		hasSubstitute,
								// 		substituteSKUs
								// 	};
								// 	self.setState({
								// 		substituteLevel: self.state.substituteLevel + 1,
								// 	}, () => {
								// 		// if substitute item is available for current substituted which is not available then
								// 		// process continues to make call of availability and pim data
								// 		recursiveSubstituteCheck();
								// 	});
								// } else {
									// if no availability and substitute then dialog will be visible with no substitute msg in that
									self.setState({
										showSubstituteProductOverlayDialog: true,
										substituteSKUData: []
									});
								// }
							}
						});
					} else {
						self.setState({
							showSubstituteProductOverlayDialog: true,
							substituteSKUData: []
						});
					}
				};
				recursiveSubstituteCheck();
			})
		} else if(action === "U") {
			self.setState({
				showUpgradeProductOverlayDialog: false,
				selectedSKU: item.item,
				selectedSKUIndex: index,
				upgradeSKUData: null
			}, () => {
				const skuList = item.upgradeSKUs.map(item => ({sku: item, itemType: 'M', demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '') }));
				if(skuList.length > 0) {
					self.getAllProductsData(action, skuList, item.quantity, item.item, item.agreementNumber, data => {
						const { availabilityData, pricingData, pimData } = self.state;
						if(availabilityData.length > 0) {
							const upgradeSKUData = [];
							let attributeName = "geego_top_load";
							self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
								if(!resp && !self.isNewAddressSelected()) {
									attributeName = "geego_no_top_load";
								}
								availabilityData.forEach(item => {
									const availability = item;
									let salesPriceData = _.find(pricingData, itm => {
										return itm.sku === availability.sku && itm.originalPrice
									});
									const pimItemData = _.find(pimData, {item_number: availability.sku});
									if(availability && salesPriceData && pimItemData) {
										const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
										const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
										const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
										const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
										const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
										const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
										const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
										let uncrateInd = "N";
										if(pimItemData.geego_uncrateind) {
											let geego_uncrateind = pimItemData.geego_uncrateind;
											const { selectedAccountsAllPriceSources, selectedPriceSource } = self.props.state.user;
											const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
											if(record) {
												uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
											}
										}
										upgradeSKUData.push({
											item: availability.sku,
											itemDescription: pimItemData.item_description,
											availability: availability.availableQty,
											itemType: "M",
											eta: availability.etaDate,
											price: salesPriceData.originalPrice,
											originalPrice: salesPriceData.originalPrice,
											relatedServices: self.props.prepareBagItems(salesPriceData),
											pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * 1) : 0.00,
											perItemPointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00,
											// Top load indicator value for backup
											perItemPointValueTopLoad: pimItemData['geego_top_load'] && pimItemData['geego_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_top_load']) : 0.00,
											// No top load indicator value for backup
											perItemPointValueNoTopLoad: pimItemData['geego_no_top_load'] && pimItemData['geego_no_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_no_top_load']) : 0.00,
											brand: pimItemData['geego_brand'],
											category: pimItemData['item_catalog_group'],
											geego_final_production_date: pimItemData['geego_final_production_date'],
											geego_distribution_start_date: pimItemData['geego_distribution_start_date'],
											geego_uncrateind: pimItemData.geego_uncrateind,
											weight: self.props.getOrderWeightFromPimData(pimItemData, 1),
											perItemWeight: self.props.getOrderWeightFromPimData(pimItemData, 1),
											hasReplacement,
											hasSubstitute,
											hasUpgrade,
											replacementSKUs,
											substituteSKUs,
											upgradeSKUs,
											isFedexable,
											uncrateInd
										});
									}
								});
								if(upgradeSKUData.length > 0) {
									self.setState({
										showUpgradeProductOverlayDialog: true,
										upgradeSKUData
									});
								} else {
									self.setState({
										showUpgradeProductOverlayDialog: true,
										upgradeSKUData: []
									});
								}
							}, self.getSiteNumberOfSelectedShippingAddress());
						} else {
							self.setState({
								showUpgradeProductOverlayDialog: true,
								upgradeSKUData: []
							});
						}
					})
				} else {
					self.setState({
						showUpgradeProductOverlayDialog: true,
						upgradeSKUData: []
					});
				}
			})
		} else if(action === "F") {
			items.forEach((itm, indx) => {
				if(index === indx) {
					itm.onForce = "Y";
				}
			});
		} else if(action === "H") {
			items.forEach((itm, indx) => {
				if(index === indx) {
					itm.onHold = "Y";
					itm.uncrateInd = 'N';
					if (itm.relatedServices) {
						itm.relatedServices =  itm.relatedServices.filter(it => {
							const itemName = it.serviceId.toLowerCase();
							return !(itemName.length === 4 && itemName.indexOf("m") === 0);
						});
					}
				}
			});
		}
		items = self.props.checkGroupShipDateByAvailabilityAndDelivery(items);
		// update items after operation is completed
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			},
			isRequiredToMakeRecursiveAvailabilityCall: false,
		}, () => {
			self.updateOrderPoints();
			if(action === "D") {
				self.isDataSufficientForAvailabilityCheck() && self.updateAvailability(() => {
					self.updateMinimumDeliveryDateByDelivery();
				});
			} else if(action === "H" || isHoldSelected === 'Y') {
				self.isDataSufficientForAvailabilityCheck() && self.updateAvailability(() => {
					self.updateMinimumDeliveryDateByDelivery(() => {
						if(fddItem === 'NEW') {
							let {
								date,
								date2,
								date3,
								createOrderForm: {
									params: {
										requestedDeliveryDate,
										requestedDeliveryDate2,
										requestedDeliveryDate3,
									}
								}
							} = self.state;
							if(item.requestedDeliveryDateBackUp === 'delivery1') {
								date = null;
								requestedDeliveryDate = '';
							} else if(item.requestedDeliveryDateBackUp === 'delivery2') {
								date2 = null;
								requestedDeliveryDate2 = '';
							} else if(item.requestedDeliveryDateBackUp === 'delivery3') {
								date3 = null;
								requestedDeliveryDate3 = '';
							}
							self.setState({
								date,
								date2,
								date3,
								createOrderForm: {
									...self.state.createOrderForm,
									params: {
										...self.state.createOrderForm.params,
										requestedDeliveryDate,
										requestedDeliveryDate2,
										requestedDeliveryDate3,
									}
								}
							});
						}
					});
				});
			}
		});
		event.target.value = (action === "F" || action === "H")?event.target.value: "";
	}

	callBackAfterGettingAllProductsData(callback) {
		const self = this;
		const { isAvailabilityCallCompleted, isPricingCallCompleted, isPimCallCompleted, isOrderabilityCallCompleted, itemOrderabilityData, availabilityData } = self.state;
		if(isAvailabilityCallCompleted && isPricingCallCompleted && isPimCallCompleted && isOrderabilityCallCompleted) {
			const updatedAvailabilityData = [];
			availabilityData.forEach(item => {
				if (itemOrderabilityData.find(itm => itm.ITEM === item.sku && itm.ITEM_ORDERABILITY_FLAG === 'Y')) {
					updatedAvailabilityData.push(item);
				}
			})
			self.setState({
				availabilityData: updatedAvailabilityData
			}, () => {
				callback && callback();
			});
		}
	}

	getZipCode() {
		const self = this;
		const {
			createOrderForm: {
				params: {
					shippingAddress
				}
			}
		} = self.state;
		if(shippingAddress && shippingAddress.zip) {
			return shippingAddress.zip.split("-")[0]
		}
		return self.props.getZipCode();
	}

	getAllProductsData(action, skuList, quantity, currentSKU, agreementNumber, callback) {
		const self = this;
		const operatedSKU = skuList;
		const { selectedAccount } = self.props.state.user,
			skuListForPim = skuList.map(item => item.sku);
		// Make availability call
		const accountNumber = selectedAccount.ACCOUNTNUMBER;
		self.setState({
			isAvailabilityCallCompleted: false,
			isOrderAvailabilityResponse: false,
			isPricingCallCompleted: false,
			isPimCallCompleted: false
		}, () => {
			const dataAdd = self.state.createOrderForm.params.shippingAddress;
			const zipCode = dataAdd ? dataAdd.zip.split('-')[0] : '';
			const state = dataAdd ? dataAdd.state : '';
			zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					const itemsForItemOrderability = skuList.map(item => `'${item.sku}'`);
					self.props.checkItemOrderabilityInBatches(itemsForItemOrderability, self.getSelectedAddressParams(), '', true, (response) => {
						self.setState({
							isOrderabilityCallCompleted: true,
							itemOrderabilityData: response
						}, () => {
							self.callBackAfterGettingAllProductsData(callback);
						});
					});
					// new availability call
					const items = skuList.map((itm, indx) => ({
						itemNumber: itm.sku,
						identifier: indx + 1,
						qty: 1,
						shipSet: 1,
						shipMethod: 'ADC Truckload',
						arrivalSetName: '',
						itemType: '',
						demandClass: self.props.getSalesAgreementParamForAvailability(itm.agreementNumber ? itm.agreementNumber.toString() : '').split("=")[1],
						overrideFlag: 'N',
						quantityUOM: 'EA',
						finalProductionDate: '',
						agreementNumber
					}));
					const payload = {
						accountNumber: self.props.getSelectedAccountNumber(),
						warehouseCode: self.state.createOrderForm.params.alternateADC || resp.agentid,
						customerSiteId: dataAdd.addressId,
						requestedDeliveryDate: moment().format('MM/DD/YYYY'),// As of now passing the current date as part of WCP-8097
						orderSource: '',
						zipCode: zipCode,
						state: dataAdd.STATE || "",
						country: dataAdd.COUNTRY,
						tradingPartnerId:'',
						dateType:'SHIP',
						items
					};
					self.props.checkAvailabilityForOrder(payload, response => {
						// if orderAvailability is down then make normal availability call
						if (response.length === 0) {
							self.props.checkAvailabilityGenericInBatches(skuList.map(item => ({sku: item.sku})), `accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${zipCode}&warehouseCode=${resp.agentid}${self.props.getSalesAgreementParamForAvailability()}`, '', true, (resp) => {
								if (resp.length > 0) {
									self.setState({
										isAvailabilityCallCompleted: true,
										availabilityData: resp[0].responseObject,
										isOrderAvailabilityResponse: false,
									}, () => {
										self.callBackAfterGettingAllProductsData(callback);
									});
								}
							});
						} else {
							const updatedData = [];
							response.forEach(item => {
								updatedData.push({
									sku: item.itemNumber,
									availableQty: item.requestedDateQuantity,
									etaDate: self.props.pickTheDateFromString(item.shipDate),
								});
							})
							self.setState({
								isAvailabilityCallCompleted: true,
								availabilityData: updatedData,
								isOrderAvailabilityResponse: true,
							}, () => {
								self.callBackAfterGettingAllProductsData(callback);
							});
						}
					});
					// // pass warehouseCode as alternateADC if it is set else pass it from selected shipping address zipcode's agentid
					// self.props.checkAvailabilityGroupByDemandClass(skuList, `accountNumber=${accountNumber}&zipCode=${self.props.getZipCode()}&warehouseCode=${self.state.createOrderForm.params.alternateADC || resp.agentid}`, true, self.getSelectedAddressParams(), '', false, response => {
					// 	self.setState({
					// 		isAvailabilityCallCompleted: true,
					// 		availabilityData: response.responseObject
					// 	}, () => {
					// 		self.callBackAfterGettingAllProductsData(callback);
					// 	});
					// });
				}
			}, true, state, self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);

			if (action === 'S') {
				self.setState({
					isPricingCallCompleted: true,
					pricingData: null
				}, () => {
					self.callBackAfterGettingAllProductsData(callback);
				});
			} else {
				// make service call to get warehouseCode and then make pricing service call
				const data = self.props.getAddressByCategory('SHIP_TO');
				let zipCode1 = data ? data.POSTALCODE.split('-')[0] : '';
				zipCode1 && self.props.getShippingAddressesDetails(zipCode1, false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
					if(self.checkIfStateIsAk()) {
						resp = {
							agentid: "SEA",
							dockcity: "SEATTLE"
						}
					}
					if(resp && resp.agentid) {
						// now for quick order page first make product pricing service call to calculate total cost
						const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
						self.props.checkPricesForSearchResult({
							account_number: accountNumber,
							pricing_effective_date: pricingEffectiveDate,
							sa_number: agreementNumber,
							item_numbers: skuListForPim
						}, true, false, response => {
							if(response.status) {
								response = self.props.processPricingResponse(response);
								operatedSKU.forEach((item, index) => {
									if(!item.sku) return null;
									let price = 0;
									price = _.find(response.responseObject.items, { item_number: item.sku });
									if(price && price.records && price.records.length > 0)
										price = price.records[0].adjusted_unit_price || price.records[0].unit_price
									else {
										price = 0;
									}
									// totalCartCost += price * quantity;
									item.originalPrice = price;
									return null
								});
								self.setState({
									isPricingCallCompleted: true,
									pricingData: operatedSKU
								}, () => {
									self.callBackAfterGettingAllProductsData(callback);
								});
							} else {
								browserHistory.push("/error");
							}
						});
					} else {
						self.setState({
							isPricingCallCompleted: true
						}, () => {
							self.callBackAfterGettingAllProductsData(callback);
						});
					}
				}, true, data.STATE, self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
			}

			// make service call to get pim details
			self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
				if(response.status) {
					const responseObject = response.responseObject ? response.responseObject : null;
					self.setState({
						isPimCallCompleted: true,
						pimData: responseObject
					}, () => {
						self.callBackAfterGettingAllProductsData(callback);
					});
				}
			})
		});
	}

	getLocTypeAccordingToDeliveryMethod(deliveryMethod) {
		const record = _.find(this.props.state.order.pickAgentId, {deliveryMethod: deliveryMethod || this.getDeliveryMethod()});
		return record && record.loctype ? record.loctype : null;
	}

	getDeliveryMethod() {
		const self = this;
		const { deliveryMethod } = self.state.createOrderForm.params;
		return deliveryMethod || self.state.defaultDeliveryMethod;
	}

	updatePricing(callback) {
		const self = this;
		// Make pricing parallel service call
		const items = self.state.createOrderForm.params.items.filter((item, index) => {
			return index === self.state.selectedSKUIndex
		});
		let pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
		let canWeMakeAnotheCall = false;
		// if keepOriginalPrice is 'Y' then we need to pass that date else we need to pass today's date
		if (items[0].keepOriginalPrice === 'Y') {
			pricingEffectiveDate = moment(items[0].pricingDate).format('YYYYMMDD');
			canWeMakeAnotheCall = true;
		}
		self.props.makeParallelCallsForCartPrices(
			items,
			true,
			true,
			'order',
			pricingEffectiveDate,
			() => {
				const { prices } = self.props.state.order;
				const flag = self.props.isPricingAvailable({responseObject: {items: prices}});
				if(flag) {
					self.afterCallUpdateItemsWithPrices(false, callback);
				}
				// if pricing is not available then if we can make second call then make it with today's date
				else if(canWeMakeAnotheCall) {
					pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
					self.props.makeParallelCallsForCartPrices(
						items,
						true,
						true,
						'order',
						pricingEffectiveDate,
						() => {
							const { prices } = self.props.state.order;
							const flag = self.props.isPricingAvailable({responseObject: {items: prices}});
							self.afterCallUpdateItemsWithPrices(flag, callback);
						}
					);
				} else {
					browserHistory.push("/error");
				}
			}
		);
	}

	afterCallUpdateItemsWithPrices(removeKeepUpdatePricing, callback) {
		const self = this;
		const { createOrderForm, selectedSKUIndex } = self.state;
		const { prices } = self.props.state.order;
		let price = 0;
		const { items } = createOrderForm.params;
		if(prices && prices.length > 0) {
			price = _.find(prices, { item_number: items[self.state.selectedSKUIndex].item });
			if(price && price.records && price.records.length > 0) {
				price = price.records[0].adjusted_unit_price || price.records[0].unit_price
			} else {
				price = 0;
			}
		}
		items[selectedSKUIndex].price = price;
		if (removeKeepUpdatePricing) {
			delete items[selectedSKUIndex].keepOriginalPrice;
			items[selectedSKUIndex].pricingDate = moment().tz('America/New_York').format('MM/DD/YYYY');
		}
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			}
		}, () => {
			self.resetSelectedSKU();
			callback && callback();
		});
	}

	handleSelectActionAddedProducts(index, event) {
		const self = this,
			action = event.target.value;
		let items = JSON.parse(JSON.stringify(self.state.products));
		if(action === "D") {
			const finalObject = [];
			items.forEach((item, indx) => {
				if(indx === index)
					finalObject.push(null);
				else
					finalObject.push(item);
			})
			// update items after operation is completed
			self.setState({
				products: finalObject
			});
		}
		event.target.value = "";
	}

	isDeliveryMethodSelected(deliveryMethod) {
		const self = this,
			{ items } = self.state.createOrderForm.params;
		if(items.find(itm => itm.requestedDeliveryDateBackUp === deliveryMethod)) {
			return true;
		}
		return false;
	}

	getPoints(items) {
		let pointValue = 0.00;
		items.forEach(item => {
			if(item.onHold !== 'Y' && item.quantity) {
				pointValue += (item.quantity * item.perItemPointValue);
			}
		});
		pointValue = parseFloat(pointValue).toFixed(2);
		return parseFloat(pointValue);
	}

	getWeights(items) {
		let weightValue = 0.00;
		items.forEach(item => {
			if(item.onHold !== 'Y' && item.quantity) {
				weightValue += (item.quantity * item.perItemWeight);
			}
		});
		weightValue = parseFloat(weightValue).toFixed(2);
		return parseFloat(weightValue);
	}

	getPointValueByDelivery(allItems) {
		const self = this;
		const finalGroup = [];
		// Exclude all hold back order items and then prepare group
		const items = JSON.parse(JSON.stringify(allItems)).filter(item => item.onHold !== 'Y');

		const delivery1Items = items.filter(item => item.requestedDeliveryDateBackUp === 'delivery1');
		const delivery2Items = items.filter(item => item.requestedDeliveryDateBackUp === 'delivery2');
		const delivery3Items = items.filter(item => item.requestedDeliveryDateBackUp === 'delivery3');

		if(delivery1Items.length > 0) {
			finalGroup.push({
				delivery: 'delivery1',
				items: delivery1Items,
				pointValue: self.getPoints(delivery1Items),
				orderWeight: self.getWeights(delivery1Items),
				deliveryNumber: 1,
				quantityExcludingAccessories: _.sumBy(delivery1Items, itm => itm.itemType === 'M' ? parseInt(itm.quantity, 10) : 0)
			});
		}
		if(delivery2Items.length > 0) {
			finalGroup.push({
				delivery: 'delivery2',
				items: delivery2Items,
				pointValue: self.getPoints(delivery2Items),
				orderWeight: self.getWeights(delivery2Items),
				deliveryNumber: 2,
				quantityExcludingAccessories: _.sumBy(delivery2Items, itm => itm.itemType === 'M' ? parseInt(itm.quantity, 10) : 0)
			});
		}
		if(delivery3Items.length > 0) {
			finalGroup.push({
				delivery: 'delivery3',
				items: delivery3Items,
				pointValue: self.getPoints(delivery3Items),
				orderWeight: self.getWeights(delivery3Items),
				deliveryNumber: 3,
				quantityExcludingAccessories: _.sumBy(delivery3Items, itm => itm.itemType === 'M' ? parseInt(itm.quantity, 10) : 0)
			});
		}
		return finalGroup;
	}

	checkIfAnyInvalidSalesAgreement(callback) {
		const self = this;
		self.props.getPriceSources(self.props.getSelectedAccountNumber(), false, selectedAccountsAllPriceSources => {
			let flag = false;
			const { items } = self.state.createOrderForm.params;
			const invalidSAItems = [];
			items.forEach(item => {
				if (item.agreementNumber && !selectedAccountsAllPriceSources.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber.toString())) {
					flag = true;
					invalidSAItems.push(item);
				}
			});
			self.setState({
				invalidSAItems
			}, () => {
				invalidSAItems.length && self.handleDialog("InvalidSalesAgreementOverlayDialog", true);
			});
			callback(flag);
		});
	}

	checkIfSelectedItemIsAuthorizedForSaleForItems(callback) {
		const self = this;
		let skuList = [];
		const { items } = self.state.createOrderForm.params;
		items.forEach((item, i) => {
			if (item.itemType === 'M' || item.itemType === 'A') {
				skuList.push(item.item);
			}
		});
		skuList = _.uniq(skuList);
		if(skuList.length) {
			const itemsForItemOrderability = skuList.map(item => `'${item}'`);
			self.props.checkItemOrderabilityInBatches(itemsForItemOrderability, self.getSelectedAddressParams(), '', true, (response) => {
				let flag = true;
				if (response.length > 0 && response.find(itm => itm.ITEM)) {
					items.forEach((item, i) => {
						if ((item.itemType === 'M' || item.itemType === 'A') && !response.find(itm => itm.ITEM === item.item && itm.ITEM_ORDERABILITY_FLAG === 'Y')) {
							flag = false;
							item.actionError = 'error';
						} else {
							item.actionError = '';
						}
					});
				}
				if (flag) {
					callback && callback(flag);
				} else {
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								items,
							}
						},
						genericDialogHeading: "Action",
						genericDialogText: `Model highlighted is not authorized for sale in ${self.state.createOrderForm.params.shippingAddress.state}. Please delete from this order.`,
						modalButtons: 'ok'
					}, () => {
						self.handleDialog("GenericOverlayDialog", true);
					});
				}
			});
		} else {
			callback && callback(true);
		}
	}

	checkIfETAIsAfterMaxDateForAnyBackOrderDelivery() {
		// If they select Force Backorder and the ETA for the delivery is NOT LATER than the first request date that we offer (based on ship method) + 7 days, they may proceed with the order.
		const self = this;
		const { items } = self.state.createOrderForm.params;
		const {selectedPriceSource } = self.props.state.user;
		let flag = false;
		const {
			maxDate1,
			maxDate2,
			maxDate3
		} = self.state;
		if(this.state.createOrderForm && this.state.createOrderForm.params &&  this.state.createOrderForm.params.deliveryMethod != 'ADC Velocity'  && selectedPriceSource.AGREEMENT_TYPE != "Inventory Financing"){
		items.forEach((item) => {
			if (item.onForce === 'Y') {
				const {
					requestedDeliveryDateBackUp,
					eta,
				} = item;
				const currentDeliveryMaxDate = requestedDeliveryDateBackUp === 'delivery1'
					? maxDate1
					: (requestedDeliveryDateBackUp === 'delivery2'
						? maxDate2
						: (requestedDeliveryDateBackUp === 'delivery3'
							? maxDate3
							: null
						)
					);
				// If the order includes Available Backorders, and the user also chooses to Force Backorder unavailable models,
				// check that the ETA for the delivery is not LATER than first request date that we offer (based on ship method) + 7 days.
				// If the ETA is later, provide pop-up with msg
				// Here we only need to check if maxDate is available for that delivery as it will only get set whenever if there is any originalOrderNumber available for that delivery
				// 	if maxDate is available and if eta is after that maxdate then need to show that popup
				if (!flag && eta && eta !== 'FP' && currentDeliveryMaxDate && moment(eta).isAfter(currentDeliveryMaxDate)) {
					flag = true;
					self.setState({
						genericDialogHeading: "Action",
						genericDialogText: "Available backorders cannot be included on a Ship Complete order with this ETA.  Please delete the unavailable product or select Hold Backorder to continue.",
						modalButtons: 'ok'
					}, () => {
						self.handleDialog("GenericOverlayDialog", true);
					});
				}
			}
		});
	}
		return flag;
	}

	checkIfWarehouseCodeForBackOrBulkOrderIsADCLOC(callback) {
		const self = this;
		let flag = true;
		const { items, defaultAlternateADC, alternateADC, warehouseLoctype } = self.state.createOrderForm.params;
		let loctype = 'adc_loc';
		// if user has changed any type from adc dropdown then we have to pass loctype for checking warehousecode
		if (defaultAlternateADC && alternateADC && defaultAlternateADC !== alternateADC) {
			loctype = warehouseLoctype;
		}
		items.forEach(item => {
			if (item.originalOrderNumber) {
				const displayedWarehouseCode = self.props.getWarehouseCodeDetailsFromBackOrBulkOrder(item.originalOrderNumber).replace('Avail - ', '');
				self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, loctype, resp => {
					if(self.checkIfStateIsAk()) {
						resp = {
							agentid: "SEA",
							dockcity: "SEATTLE"
						}
					}
					// if user has selected some custom ADC then we need to check displayed one with that one
					// or if there is not alternateADC and defaultAlternateADC it means its adc_loc loctype
					if (defaultAlternateADC && alternateADC && defaultAlternateADC !== alternateADC) {
						if (alternateADC === displayedWarehouseCode) {
							item.actionError = '';
						} else {
							item.actionError = 'error';
							flag = false;
						}
					} else if (displayedWarehouseCode !== resp.agentid) {
						item.actionError = 'error';
						flag = false;
					} else {
						item.actionError = '';
					}
				});
			}
		});

		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			}
		}, () => {
			!flag && self.setState({
				genericDialogHeading: "Action",
				genericDialogText: "Available Backorders must all be held in the shipping warehouse. Please delete backorders held in other warehouses from this order.",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true);
			});
			callback(flag);
		});
	}


	handleReviewForceOrder(event){
		event.preventDefault();
		const reactRoot = document.getElementById('editOrderSubmit');
		const forceIndex = reactRoot.getAttribute('data-forceindex');
		this.actionAllBackOrderLine(JSON.parse(forceIndex), 'onForce');
		setTimeout(this.handleReviewOrder(event),1000);	
		};


	handleReviewOrder(event) {
		event.preventDefault();
		let self = this,
			params = self.state.createOrderForm.params,
			error = self.state.createOrderForm.errors,
			products = self.state.products,
			formError = false;

		let requestedDeliveryDateError = false;
		const items = self.state.createOrderForm.params.items;
		let LocalStorageVar = localStorage.getItem( "RDDate" ) ? JSON.parse( localStorage.getItem( "RDDate" ) ): null;
		items.forEach(itm => {
			if(this.isBackOrderEligible(itm,LocalStorageVar) && itm.onHold == "Y"){
				delete itm.onHold;	
				itm.actionError="";
			}
		})
		if(!self.isDeliveryMethodSelected('delivery1')) {
			delete error.requestedDeliveryDateError;
		} else if (!params.requestedDeliveryDate) {
			requestedDeliveryDateError = true;
		}
		if(!self.isDeliveryMethodSelected('delivery2')) {
			delete error.requestedDeliveryDate2Error;
		} else if (!params.requestedDeliveryDate2) {
			requestedDeliveryDateError = true;
		}
		if(!self.isDeliveryMethodSelected('delivery3')) {
			delete error.requestedDeliveryDate3Error;
		} else if (!params.requestedDeliveryDate3) {
			requestedDeliveryDateError = true;
		}

		//Reset all errors
		for(var key in error) {
            if(!params[key.replace("Error","")]) {
                error[key] = 'error';
                formError = true;
            } else {
				error[key] = '';
			}
        }

		if (params.shippingAddress && Object.keys(params.shippingAddress).length === 0) {
			error.shippingAddressError = 'error';
		}

		// check if valid phone number entered
		if(!self.props.isValidPhoneNumber(this.state.createOrderForm.params.deliveryPhone)) {
			formError = true;
			window.scrollTo(0, self.getElementOffset("requestedDeliveryDate"));
			error.deliveryPhoneError = "error";
		}

		if (requestedDeliveryDateError) {
			formError = true;
			window.scrollTo(0, self.getElementOffset("requestedDeliveryDate"));
		}

		if (!params.poNumber.trim()) {
			formError = true;
			window.scrollTo(0, self.getElementOffset("mainPONumber"));
			error.poNumberError = "error";
		}

		//Check if any quantity field is blank or not
		let actionError = false;
			// pricingError = false;
		let decliningLineNo = 1;
		params.items.map((item, index) => {
			item.decliningLineNo = decliningLineNo++;
			item.poNumber = item.poNumber ? item.poNumber.trim() : item.poNumber;
			if(item.quantity === '' || item.quantity === 0) {
				formError = true;
				window.scrollTo(0, self.getElementOffset("quantity"+index));
			}
			if(!item.requestedDeliveryDate) {
				formError = true;
				window.scrollTo(0, self.getElementOffset("quantity"+index));
			}
			if(item.relatedServices) {
				item.relatedServices.map((itm, indx) => {
					if(self.props.getItemTypeByName(itm.serviceId) === 'S') {
						itm.decliningLineNo = decliningLineNo++;
					}
					if(self.props.getItemType(itm.serviceId,'') === 'S'){
                        itm.quantity = itm.quantity;
                    }
					itm.quantityError = (itm.quantity === '' || itm.quantity === 0)?'error':''
					if(itm.quantity === '') {
						formError = true;
						window.scrollTo(0, self.getElementOffset("quantity"+index));
					}
					return null;
				})
			}
			// if(item.price === '0' || !item.price) {
			// 	pricingError = true;
			// }
			item.quantityError = (item.quantity === '' || item.quantity === 0) ? 'error' : '';
			item.requestedDeliveryDateError = !item.requestedDeliveryDate ? 'error' : '';
			let LocalStorageVar =JSON.parse( localStorage.getItem( "RDDate" ) );
			if(self.checkShowingOrdersCriteria(item) && !item.originalOrderNumber && (item.availability === 0 || (item.quantity && item.quantity > item.availability)) && item.onHold !== 'Y' && item.onForce !== 'Y'&& !this.isBackOrderEligible(item,LocalStorageVar)) {
				actionError = true;
				formError = true;
				item.actionError = "error";
			} else if (!item.originalOrderNumber && (item.availability === 0 || (item.quantity && item.quantity > item.availability)) && item.onHold !== 'Y' && item.onForce !== 'Y' && !this.isBackOrderEligible(item,LocalStorageVar)) {
				actionError = true;
				formError = true;
				item.actionError = "error";
			} else {
				item.actionError = "";
			}
			if(!item.originalOrderNumber && parseInt(item.price, 10) === 0) {
				formError = true;
			}
			return null;
		});
		(actionError) && self.setState({
			genericDialogHeading: "Action",
			// genericDialogText: actionError ? "Please select an action for unavailable products" : "Please select an action for not priced products",
			genericDialogText: "Please select an action for unavailable products",
			modalButtons: 'ok'
		}, () => {
			self.handleDialog("GenericOverlayDialog", true);
		});

		//remove all empty row which is not having product number in "Add" section
		products.map((item, index) => {
			if(item) {
				item.error = (!item.availability)?'error':''
			}
			return null;

		});
		//remove all empty row which is not having product number in "Add" section
		products = _.remove(products, (item) => {
			return item && item.item !== '';
		});

		//Check if user has invoice preferences then need to check required field values
		if(self.state.billingProfile && self.state.billingProfile.status) {
			params.billingReference.map((item, index) => {
				if(item.requiredFlag === 'Y' && item.value === '') {
					formError = true;
					window.scrollTo(0, self.getElementOffset("mainPONumber"));
				}
				item.error = (item.requiredFlag === 'Y' && item.value === '')?'error':''
				return null
			})
		}

		delete params.customerServiceNotesEntered;
		delete params.customerServiceNotesDefault;

		const typeOfAccount = self.props.getSelectedAccountType();
		params.items.forEach((item) => {
			if(item.originalAction) {
				item.action = item.originalAction;
			}
		});
		if(!params.isRDDChanged){
			self.updateWarehouseDetails(moment(params.requestedDeliveryDate).format('MM/DD/YYYY'))
		}
		let splitZip = self.state.createOrderForm.params.shippingAddress.zip.indexOf("-") !== -1 ?self.state.createOrderForm.params.shippingAddress.zip.split("-")[0]:self.state.createOrderForm.params.shippingAddress.zip
		let filteredShippingData = self.props.state.user.shippingAddressDetailsListWithZipCode.filter(item =>{
			return item.zipCode === splitZip && item.state === self.state.createOrderForm.params.shippingAddress.state
		})
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					poNumber: self.state.createOrderForm.params.poNumber.trim(),
					items: params.items.filter(itm => itm.item !== 'CUSTOMER MINIMUM DELIVERY'),
					customerType: typeOfAccount,
					shippingData:self.state.newShippingData?self.state.newShippingData: (filteredShippingData && filteredShippingData.length > 0 && filteredShippingData[0].details),
				},
				errors: error
			},
			products
		}, () => {
			if(!formError && !self.checkIfETAIsAfterMaxDateForAnyBackOrderDelivery() && !self.ifThereIsAnyBackOrderDuplicateItem()) {
				self.anyRestrictedItemsAdded(() => {
					self.checkIfSelectedItemIsAuthorizedForSaleForItems((isAllWell) => {
						// make fresh call to get sales agreement and see if there is any invalid sales agreement
						isAllWell && self.checkIfAnyInvalidSalesAgreement((isThereAnyInvalidSA) => {
							if(!isThereAnyInvalidSA) {
								self.checkIfWarehouseCodeForBackOrBulkOrderIsADCLOC(isCorrect => {
									if(isCorrect) {
										const totalRecordsOfAandM = _.filter(params.items, item => item.itemType === "A" || item.itemType === "M"),
											fedexableItems = params.items.filter(item => item.isFedexable === true),
											uncrateIndItem = params.items.find(item => item.uncrateInd === 'Y'),
											anyServiceAdded = params.items.find(item => item.relatedServices && item.relatedServices.find((itm) => self.isMService(itm.serviceId)));
										let orderTotal = 0.00;
										params.items.forEach(itm => {
											if(itm.quantity && itm.price) {
												orderTotal += parseFloat(itm.quantity * itm.price);
											}
											itm.relatedServices && itm.relatedServices.forEach(itm => {
												orderTotal += parseFloat(itm.extendedPrice);
											});
										});
										if(!anyServiceAdded && !uncrateIndItem && totalRecordsOfAandM.length === fedexableItems.length && orderTotal <= 300) {
											// params.deliveryMethod.indexOf('Will Call') === -1 &&
											self.handleDialog("FedExShipmentConfirmationOverlayDialog", true, null);
										} else {
											self.checkPointsAndDeliveryMethod();
										}
									}
								});
							}
						});
					});
				});
			}
		});
    }

	removeMissingLineNumberItems() {
		const self = this;
		const updatedItems = [];
		self.state.createOrderForm.params.items.forEach((item) => {
			if(item.originalOrderNumber) {
				if(item.lineNo) {
					updatedItems.push(item);
				}
			} else {
				updatedItems.push(item);
			}
		});
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items: updatedItems
				}
			}
		}, () => {
			self.handleDialog("LineNoMissingFromBackOrdersOverlayDialog", false, null);
		});
	}

	ifThereIsAnyBackOrderDuplicateItem() {
		const self = this;
		let flag = false;
		const duplicateItems = [];
		const lineNoMissing = [];
		const normalItems = [];
		self.state.createOrderForm.params.items.forEach(item => {
			if(item.originalOrderNumber) {
				if (!item.lineNo) {
					lineNoMissing.push(item);
					flag = true;
				} else if (normalItems.find(itm => itm.lineNo === item.lineNo && itm.originalOrderNumber === item.originalOrderNumber)) {
					duplicateItems.push(item);
					flag = true;
				} else {
					normalItems.push(item);
				}
			}
		});
		self.setState({
			duplicateItems,
			lineNoMissing,
		}, () => {
			if (lineNoMissing.length) {
				self.handleDialog("LineNoMissingFromBackOrdersOverlayDialog", true, null);
			} else if (duplicateItems.length) {
				self.handleDialog("NoDuplicateFromBackOrdersOverlayDialog", true, null);
			}
		});
		return flag;
	}

	checkPointsAndDeliveryMethod() {
		const self = this;
		const { params } = self.state.createOrderForm,
			{ shippingAddress } = params;
		const pointValueByDelivery = self.getPointValueByDelivery(params.items);
		// in case of multiple delivery need to check SDS type of delivery and having > 26 points
		if(pointValueByDelivery.length > 1 && (params.deliveryMethod === 'SDS Delivery' || params.deliveryMethod === 'SDS Will Call' || params.deliveryMethod === 'SDS Delivery Next Day') && pointValueByDelivery.find(itm => itm.pointValue > 26)) {
			self.setState({
				doesNotMatchedPointCriteria: pointValueByDelivery.filter(itm => itm.pointValue > 26)
			}, () => {
				self.handleDialog("MultipleDeliveryPointCriteriaNotMatchedOverlayDialog", true, null);
			});
		}
		// in case of multiple delivery need to check ADC Truckload delivery and having < 24 points and quantity excluding hold back order and accessory is < 24
		else if(pointValueByDelivery.length > 1 && params.deliveryMethod === 'ADC Truckload' && pointValueByDelivery.find(itm => itm.pointValue < 22 && itm.quantityExcludingAccessories < 24)) {
			self.setState({
				doesNotMatchedPointCriteria: pointValueByDelivery.filter(itm => itm.pointValue < 22 && itm.quantityExcludingAccessories < 24)
			}, () => {
				self.handleDialog("MultipleDeliveryPointCriteriaNotMatchedOverlayDialog", true, null);
			});
		}
		// in case of multiple delivery need to check ADC LTL delivery and having > 38 points
		else if(pointValueByDelivery.length > 1 && params.deliveryMethod === 'ADC LTL' && pointValueByDelivery.find(itm => itm.pointValue > 38 || itm.orderWeight > 12000)) {
			self.setState({
				doesNotMatchedPointCriteria: pointValueByDelivery.filter(itm => itm.pointValue > 38 || itm.orderWeight > 12000)
			}, () => {
				self.handleDialog("MultipleDeliveryPointCriteriaNotMatchedOverlayDialog", true, null);
			});
		}
		// in case of single delivery only need to check SDS type of delivery and having > 26 points
		else if(pointValueByDelivery.length === 1 && (params.deliveryMethod === 'SDS Delivery' || params.deliveryMethod === 'SDS Will Call' || params.deliveryMethod === 'SDS Delivery Next Day') &&
			pointValueByDelivery.find(itm => itm.pointValue > 26)
		) {
			self.handleDialog("ChangeDeliveryMethodNOOverlayDialog", true, null);
		}
		// if user is employee and
		// if method is ADC Truckload and order points is less then 22 and quantity excluding hold back order and accessory is < 24
		// Need to exclude velocity customers
		else if(self.props.state.user.userDetails.typeOfUser === 'employee' && params.deliveryMethod === 'ADC Truckload' && params.defaultAlternateADC !== params.alternateADC && pointValueByDelivery.find(itm => itm.pointValue < 22 && itm.quantityExcludingAccessories < 24)) {
			if(self.props.isVelocityCustomer) {
				self.checkIfDuplicatePOOrNot();
			} else {
				self.handleDialog("ChangeDeliveryMethodYESForAlternateADCOverlayDialog", true, null);
			}
		} else if (params.deliveryMethod === 'ADC Truckload' &&
			pointValueByDelivery.find(itm =>
				(itm.pointValue >= 22 && itm.pointValue < 26) ||
				(itm.pointValue < 26 && itm.quantityExcludingAccessories >= 24)
			)
			&& !self.props.isVelocityCustomer
		) {
			self.handleDialog("ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog", true, null);
		}
		// if method is ADC Truckload and order points is less then 22 and quantity excluding hold back order and accessory is < 24
		// Need to exclude velocity customers
		else if(pointValueByDelivery.length === 1 && params.deliveryMethod === 'ADC Truckload' && pointValueByDelivery.find(itm => itm.pointValue < 22 && itm.quantityExcludingAccessories < 24)) {
			if(self.props.isVelocityCustomer) {
				self.checkIfDuplicatePOOrNot();
			} else {
				// check if user has access to SDS delivery or not
				// if (self.state.isSDS_LOC) {
					self.handleDialog("ChangeDeliveryMethodYESOverlayDialog", true, null);
				// } else {
				// 	self.handleDialog("NotHavingEnoughPointsOverlayDialog", true, null);
				// }
			}
		}
		// if method is ADC Truckload and order points > 126.5
		// Need to exclude velocity customers
		else if(params.deliveryMethod === 'ADC Truckload' && pointValueByDelivery.find(itm => itm.pointValue > 126.5)) {
			self.checkVelocityCustomerAndAction();
		} else if(params.deliveryMethod === 'ADC LTL' && pointValueByDelivery.find(itm => itm.pointValue > 26)) {
			self.handleDialog("ChangeDeliveryMethodForADCLTLOverlayDialog", true, null);
		} else if(params.deliveryMethod === 'MATU-Ocean-Ocean-Full Container' && params.pointValue > 98) {
			self.setState({
				genericDialogHeading: "Action",
				genericDialogText: "Please remove some items so this order does not exceed 98 points.",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true, null);
			});
		} else if(params.deliveryMethod === 'MATU-Ocean-Ocean-Full Container' && !(shippingAddress && shippingAddress.state === 'AK')) {
			self.setState({
				genericDialogHeading: "Action",
				genericDialogText: "Please select the correct Shipping Method and Address for an Alaska shipment.",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true, null);
			});
		} else if(params.deliveryMethod === 'LTIA-Ocean-Ocean-Full Container' && params.pointValue > 57) {
			self.setState({
				genericDialogHeading: "Action",
				genericDialogText: "Please remove some items so this order does not exceed 57 points.",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true, null);
			});
		} else if(params.deliveryMethod === 'LTIA-Ocean-Ocean-Full Container' && params.pointValue < 26) {
			self.handleDialog("ChangeDeliveryMethodMATUOrLTIAOverlayDialog", true, null);
		} else {
			self.checkIfDuplicatePOOrNot();
		}
	}

	getElementOffset(elementId) {
		var bodyRect = document.body.getBoundingClientRect(),
			el2 = document.getElementById(elementId).getBoundingClientRect(),
			offset   = el2.top - bodyRect.top;
		return offset;
	}

	handleAddServices(index, item, itemLevelDisableUncrateDropdown, event) {
		event.preventDefault();
		const self = this,
			{ params } = self.state.createOrderForm;
		self.setState({
			itemLevelDisableUncrateDropdown,
			selectedSKU: item,
			selectedSKUIndex: index,
		}, () => {
			// make service call to get warehouseCode and then make pricing service call
			self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
				if(self.checkIfStateIsAk()) {
					resp = {
						agentid: "SEA",
						dockcity: "SEATTLE"
					}
				}
				if(resp && resp.agentid) {
					const record = _.find(self.props.state.order.orderableServices, {sku: item, zipCode: self.getShippingAddressZipCode()});
					if(record) {
						self.manageAvailableServices(self.props.state.order.orderableServices, item, self.getShippingAddressZipCode());
					} else {
						const { deliveryMethod } = params;
						const itemnumbers = self.state.createOrderForm.params.items.filter(item => (item.itemType === 'M' || item.itemType === 'A') && item.item === self.state.selectedSKU).map(item => item.item);
						// Get all orderable services list
						self.props.getOrderableServices({
							OrderabilityRequest: {
								inventoryorg: resp.agentid,
								zipcode: self.getShippingAddressZipCode(),
								shipmethod: deliveryMethod,
								itemnumbers: _.uniq(itemnumbers)
							}
						}, "requestType=getOrderableServices", response => {
							if(response.status) {
								const orderableServices = JSON.parse(JSON.stringify(response));
								const { selectedAccount, selectedPriceSource } = self.props.state.user;
								const servicesPayload = [];
								const { shippingAddress } = self.state.createOrderForm.params;
								const { defaultShippingAddress } = self.state;
								const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
								response.responseObject && response.responseObject.OrderabilityResponse.orderability.forEach(item => {
									if(item.service.length === 4 && item.service.indexOf("M") === 0) {
										servicesPayload.push({
											pricingEffectiveDate: moment().format('YYYYMMDD'),
											accountNumber,
											state: shippingAddress ? shippingAddress.state : defaultShippingAddress.state,
											whse: resp.agentid,
											zone: resp.sdsApZone,
											salesAgreementNumber,
											itemNumber: item.service
										});
									}
								});
								self.setState({
									requiredPayloadForServicePricing: {
										pricingEffectiveDate: moment().format('YYYYMMDD'),
										accountNumber,
										state: shippingAddress ? shippingAddress.state : defaultShippingAddress.state,
										whse: resp.agentid,
										zone: resp.sdsApZone,
										salesAgreementNumber,
										postalCode: self.getShippingAddressZipCode(),
										country: shippingAddress.country ? shippingAddress.country : "US"
									}
								}, () => {
									if(servicesPayload.length > 0) {
										// Get all orderable services prices list
										self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
											if(resp.status) {
												// let orderableServices = self.props.state.order.orderableServices;
												// TO DO : Temporary conversion from json string to json
												resp.responseObject = JSON.parse(resp.responseObject);
												const orderableServicesTemp = [];
												orderableServices.responseObject.OrderabilityResponse.orderability.forEach(item => {
													let record = _.find(resp.responseObject.items, {itemNumber: item.service});
													// record.unitPrice = 200;
													if(record && (record.unitPrice || record.unitPrice === 0)) {
														orderableServicesTemp.push({
															...item,
															servicePrice: record.unitPrice,
															serviceDescription: item.description,
														});
													}
												});
												let finalData = [];
												self.state.createOrderForm.params.items.forEach(itm => {
													if (itm.item === self.state.selectedSKU) {
														finalData.push({
															sku: itm.item,
															services: _.filter(orderableServicesTemp, {itemnumber: itm.item}),
															zipCode: self.getShippingAddressZipCode()
														});
													}
												});
												let existingOrderableServices = self.props.state.order.orderableServices;
												existingOrderableServices = existingOrderableServices.filter(it => it.sku !== self.state.selectedSKU);
												existingOrderableServices = existingOrderableServices.concat(finalData);
												self.props.saveOrderableServices(existingOrderableServices);
												self.manageAvailableServices(finalData, self.state.selectedSKU, self.getShippingAddressZipCode());
											} else {
												browserHistory.push("/error");
											}
										})
									} else {
										let finalData = [];
										self.state.createOrderForm.params.items.forEach(itm => {
											finalData.push({
												sku: itm.item,
												services: [],
												zipCode: self.getShippingAddressZipCode()
											})
										})
										self.manageAvailableServices(finalData, self.state.selectedSKU, self.getShippingAddressZipCode());
									}
								});
							} else {
								browserHistory.push("/error");
							}
						});
					}
				}
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
		});
	}

	manageAvailableServices(finalData, sku, zipCode) {
		const self = this;
		const availableServices = _.find(finalData, {sku, zipCode});
		self.setState({
			availableServices: availableServices && availableServices.services
		}, () => {
			self.handleDialog("AddServicesOverlayDialog", true, null);
		})
	}

	// This is common function for upgrade and substitute both
	handleUpgradeItem(selectedUpgradeItem, whichAction = 'upgrade') {
		//Logic to replace item with new item
		var finalItems = [],
			self = this;
		//Ignore adding item in case that item is already added in order list
		if(_.find(self.state.createOrderForm.params.items, ['item', selectedUpgradeItem.sku])) {
			finalItems = self.state.createOrderForm.params.items;
		} else {
			self.state.createOrderForm.params.items.map((item, index) => {
				if(index === self.state.selectedSKUIndex) {
					let tempItm = JSON.parse(JSON.stringify(item));
					if (whichAction === 'substitute') {
						// keep existing item if it is already added in enter order and set action: 'delete'
						if(item.alreadyAdded) {
							const { deletedItems } = self.props.state.order;
							deletedItems.push(JSON.parse(JSON.stringify({
							    ...item,
							    action: 'delete'
							})));
							self.props.saveDeletedItems(deletedItems);
						}
						delete tempItm.alreadyAdded;
						delete tempItm.originalAction;
						tempItm.originalItem = item.item;
						tempItm.originalItemPrice = item.price;
						// WCP-7525: roll back
						// tempItm.substituteLevel = self.state.substituteLevel;
						tempItm.newSubAdded = 'Y';
						if (!selectedUpgradeItem.price || selectedUpgradeItem.price === "0") {
							selectedUpgradeItem.price = item.price;
							selectedUpgradeItem.originalPrice = item.originalPrice;
						}
						tempItm.action = 'new';
					} else { // For upgrade scenario
						if(item.alreadyAdded) {
							delete tempItm.alreadyAdded;
							tempItm = {
								...tempItm,
								action: 'update'
							};
						}
					}
					finalItems.push({
						...tempItm,
						...selectedUpgradeItem,
					});
				} else {
					finalItems.push(item);
				}
				return null;
			});
		}
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items: finalItems
				}
			},
			selectedSKU: selectedUpgradeItem.sku,
			showUpgradeProductOverlayDialog: false,
			showSubstituteProductOverlayDialog: false,
			isRequiredToMakeRecursiveAvailabilityCall: false,
		}, () => {
			self.isDataSufficientForAvailabilityCheck() && self.updateAvailability();
		})
		self.resetSelectedSKU();
	}

	handleReplace(replaceWith) {
		var self = this;
		if(replaceWith === 'same') {
			self.setState({
				showReplaceProductOverlayDialog: false
			});
		} else {
			//Logic to replace item with new item
			var finalItems = [];
			//Ignore adding item in case that item is already added in order list
			if(_.find(self.state.createOrderForm.params.items, ['item', self.state.replacementSKUData.replacingBy.item])) {
				finalItems = self.state.createOrderForm.params.items;
			} else {
				self.state.createOrderForm.params.items.map((item, index) => {
					if(index === self.state.selectedSKUIndex) {
						var tempItm = JSON.parse(JSON.stringify(item));
						if(item.alreadyAdded) {
							delete tempItm.alreadyAdded;
							tempItm = {
								...tempItm,
								action: 'update'
							};
						}
						finalItems.push({
							...tempItm,
							...self.state.replacementSKUData.replacingBy
						});
					} else {
						finalItems.push(item);
					}
					return null;
				});
			}
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						items: finalItems
					}
				},
				selectedSKU: self.state.replacementSKUData.replacingBy.sku,
				showReplaceProductOverlayDialog: false,
				isRequiredToMakeRecursiveAvailabilityCall: false,
			}, () => {
				self.isDataSufficientForAvailabilityCheck() && self.updateAvailability();
			})
		}
		self.resetSelectedSKU();
	}

	isRequestedDeliveryDateCheckNeeded = deliveryMethod => {
		return ['ADC', 'SDS'].includes(this.props.getDeliveryCalendarType(deliveryMethod));
	}

	continueFedExDeliveryWith(deliveryMethod, event) {
		event && event.preventDefault();
        const self = this;
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					deliveryMethod
				}
			},
			showChangeDeliveryMethodNOOverlayDialog: false,
			showFedExShipmentConfirmationOverlayDialog: false,
		}, () => {
			if(deliveryMethod !== "FedEx Ground") {
				self.checkPointsAndDeliveryMethod();
			} else {
	            //Continue with other logic of making service call
	            self.checkIfDuplicatePOOrNot();
			}
        })
	}
	isMService(itemName) {
		let flag = false;
		if (itemName.length === 4 && itemName.indexOf("M") === 0) {
			flag = true;
		}
		return flag;
	}
	updateItemsForADCTruckLoadDelivery(items) {
		const self = this;
		// WCP-7500: If the user selects ADC Truckload, remove any services (M000 codes) from the order and
		// send all lines as Crated.  Currently we put the order on CustomerNet user Request Hold if it had
		// uncrates selected and they change it to ADC Truckload - we no longer need to put the order on hold.
		items.forEach(item => {
			if (item.uncrateInd && item.uncrateInd === 'Y') {
				item.uncrateInd = "N";
			}
			if (item.relatedServices) {
				if (item.alreadyAdded) {
					item.relatedServices.forEach(itm => {
						if (self.isMService(itm.serviceId)) {
							itm.action = 'cancel';
						}
					});
				} else {
					item.relatedServices = item.relatedServices.filter(itm => !self.isMService(itm.serviceId));
				}
			}
			if (item.alreadyAdded && item.itemType === 'S' && self.isMService(item.item)) {
				item.action = 'cancel';
			}
		});
		return items;
	}
	continueSDSDeliveryWith(deliveryMethod, event) {
		event && event.preventDefault();
        const self = this;
		// If yes then deliveryMethod will be ADC Truckload
		if(deliveryMethod) {
			const { items } = self.state.createOrderForm.params;
			const isDeliveryMethodChanged = self.state.createOrderForm.params.deliveryMethod != deliveryMethod;

			let params = {
				...self.state.createOrderForm.params,
				items: self.updateItemsForADCTruckLoadDelivery(items),
				deliveryMethod
			};
			// If Yes, and all items are CRATED and there are no services selected, Update Shipping Method to ADC Truckload and move to Order Review.\
			// NOTES: For above condition no need to do anything else except updating delivery method

			// update delivery method first so that we can use loctype accordingly in call back of this set state to update warehousecode details
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params
				},
				showChangeDeliveryMethodNOOverlayDialog: false,
			}, () => {
				self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								warehouseCode: resp.agentid,
								warehouseName: resp.dockname,
								warehouseCodeCity: resp.dockcity,
								warehouseLoctype: resp.loctype
							}
						}
					}, () => {
						const pointValueByDelivery = self.getPointValueByDelivery(params.items);
						if(pointValueByDelivery.find(itm => itm.pointValue > 126.5)) {
							self.checkVelocityCustomerAndAction();
						} else {
							// If deliveryMethod needs calendar api to be called, we need to fetch the calendar and validate the selected dates before moving to Review page
							// proceedToOrderReview flag is set to true, it will be handled when the calendar is fetched
							if (isDeliveryMethodChanged && self.isRequestedDeliveryDateCheckNeeded(deliveryMethod)) {
								this.proceedToOrderReview = true;
								return;
							}
			            	//Continue with other logic of making service call
			            	self.checkIfDuplicatePOOrNot();
						}
					});
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
	        });
		} else {
			self.handleDialog("ChangeDeliveryMethodNOOverlayDialog", false, null);
			self.handleDialog("ActionForSDSOverlayDialog", true, null);
		}
	}

	checkVelocityCustomerAndAction() {
		const self = this;
		if(self.props.isVelocityCustomer) {
			self.checkIfDuplicatePOOrNot();
		} else {
			self.setState({
				genericDialogHeading: "Action",
				genericDialogText: "Your order exceeds a full truck.  Please remove some items from the order so that the points do not exceed 126.5",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true, null);
			});
		}
	}
	continueADCTruckloadForAlternateADCDeliveryWith(deliveryMethod, event) {
		event && event.preventDefault();
        const self = this;
		// If yes then deliveryMethod will be ADC Truckload
		if(deliveryMethod) {
			if (!self.state.shippingMethodList.find(item => item.value === deliveryMethod)) {
				deliveryMethod = 'ADC LTL';
			}
			const isDeliveryMethodChanged = self.state.createOrderForm.params.deliveryMethod != deliveryMethod;
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						deliveryMethod
					}
				},
			}, () => {
				self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								defaultWarehouseDetails: deliveryMethod === 'SDS Delivery' ? {
									warehouseCode: resp.agentid,
									warehouseName: resp.dockname,
									warehouseCodeCity: resp.dockcity,
									warehouseLoctype: resp.loctype,
								} : self.state.createOrderForm.params.defaultWarehouseDetails,
								warehouseCode: resp.agentid,
								warehouseName: resp.dockname,
								warehouseCodeCity: resp.dockcity,
								warehouseLoctype: resp.loctype
							}
						}
					}, () => {
						self.handleDialog("ChangeDeliveryMethodYESOverlayDialog", false, null);
						// If deliveryMethod needs calendar api to be called, we need to fetch the calendar and validate the selected dates before moving to Review page
						// proceedToOrderReview flag is set to true, it will be handled when the calendar is fetched
						if (isDeliveryMethodChanged && self.isRequestedDeliveryDateCheckNeeded(deliveryMethod)) {
							this.proceedToOrderReview = true;
							return;
						}
			            //Continue with other logic of making service call
			            self.checkIfDuplicatePOOrNot();
					});
				}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
	        });
		} else {
			// If No, display a message, “Please add items to this order to meet the 26 point minimum” then return the user to the Create Order screen, so they can add points.
			self.setState({
				showChangeDeliveryMethodYESOverlayDialog: false,
			}, () => {
				self.setState({
					genericDialogHeading: "Action",
					genericDialogText: "Please add items to this order to meet the 26 point minimum.",
					modalButtons: 'ok'
				}, () => {
					self.handleDialog("GenericOverlayDialog", true, null);
				});
			});
		}
	}
	continueADCTruckloadDeliveryWith(deliveryMethod, event) {
		event && event.preventDefault();
        const self = this;
		if(deliveryMethod) {
			const isDeliveryMethodChanged = self.state.createOrderForm.params.deliveryMethod != deliveryMethod;
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						deliveryMethod
					}
				},
			}, () => {
				self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								defaultWarehouseDetails: deliveryMethod === 'SDS Delivery' ? {
									warehouseCode: resp.agentid,
									warehouseName: resp.dockname,
									warehouseCodeCity: resp.dockcity,
									warehouseLoctype: resp.loctype,
								} : self.state.createOrderForm.params.defaultWarehouseDetails,
								warehouseCode: resp.agentid,
								warehouseName: resp.dockname,
								warehouseCodeCity: resp.dockcity,
								warehouseLoctype: resp.loctype
							}
						}
					}, () => {
						self.handleDialog("ChangeDeliveryMethodYESOverlayDialog", false, null);
						// If deliveryMethod needs calendar api to be called, we need to fetch the calendar and validate the selected dates before moving to Review page
						// proceedToOrderReview flag is set to true, it will be handled when the calendar is fetched
						if (isDeliveryMethodChanged && self.isRequestedDeliveryDateCheckNeeded(deliveryMethod)) {
							this.proceedToOrderReview = true;
							return;
						}
			            //Continue with other logic of making service call
			            self.checkIfDuplicatePOOrNot();
					});
				}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
	        });
		} else {
			// If No, display a message, “Please add items to this order to meet the 26 point minimum” then return the user to the Create Order screen, so they can add points.
			self.setState({
				showChangeDeliveryMethodYESOverlayDialog: false,
			}, () => {
				self.setState({
					genericDialogHeading: "Action",
					genericDialogText: "Please add items to this order to meet the 26 point minimum.",
					modalButtons: 'ok'
				}, () => {
					self.handleDialog("GenericOverlayDialog", true, null);
				});
			});
		}
	}
	handleCallBackAction(action, event) {
		event && event.preventDefault();
		const self = this;
		self.handleDialog('ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog', false, null);
		if (action === 'No') {
			self.setState({
				genericDialogHeading: "Action",
				genericDialogText: "Please add items to this order to meet the 26 point minimum or select a different shipping method.",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true, null);
			});
		} else {
			self.handleDialog("AddCustomerServiceNotesForADCTruckloadOverlayDialog", true, null);
		}
	}
	continueMATUOrLTIADeliveryWith(event) {
		event && event.preventDefault();
		const self = this;
		//Handle notes here
		let { params } = self.state.createOrderForm;
		params.customerServiceNotesDefault = 'Alaska order < 26 pts ';
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params
			},
			showChangeDeliveryMethodMATUOrLTIAOverlayDialog: false
		}, () => {
			// Continue with other logic of making service call
			self.checkIfDuplicatePOOrNot();
		});
	}

	continueADCLTLDeliveryWith(deliveryMethod, event) {
		event && event.preventDefault();
        const self = this;
		// If yes then deliveryMethod will be ADC Truckload
		if(deliveryMethod) {
			const isDeliveryMethodChanged = self.state.createOrderForm.params.deliveryMethod != deliveryMethod;
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						deliveryMethod
					}
				},
			}, () => {
				self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								warehouseCode: resp.agentid,
								warehouseName: resp.dockname,
								warehouseCodeCity: resp.dockcity,
								warehouseLoctype: resp.loctype
							}
						}
					}, () => {
						self.handleDialog("ChangeDeliveryMethodForADCLTLOverlayDialog", false, null);
						const pointValueByDelivery = self.getPointValueByDelivery(self.state.createOrderForm.params.items);
						if(pointValueByDelivery.find(itm => itm.pointValue > 126.5)) {
							self.checkVelocityCustomerAndAction();
						} else {
							// If deliveryMethod needs calendar api to be called, we need to fetch the calendar and validate the selected dates before moving to Review page
							// proceedToOrderReview flag is set to true, it will be handled when the calendar is fetched
							if (isDeliveryMethodChanged && self.isRequestedDeliveryDateCheckNeeded(deliveryMethod)) {
								this.proceedToOrderReview = true;
								return;
							}
							//Continue with other logic of making service call
				            self.checkIfDuplicatePOOrNot();
						}
					});
				}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
	        });
		} else {	// here in this case deliveryMethod will be false
			const params = self.state.createOrderForm.params;
			// If No, and points is <= 38, then let it go as ADC LTL and go to Order Review.
			if(params.pointValue <= 38 && params.orderWeight <= 12000) {
				self.setState({
					createOrderForm: {
						...self.state.createOrderForm,
						params: {
							...self.state.createOrderForm.params,
							deliveryMethod: 'ADC LTL'
						}
					},
				}, () => {
					self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
						self.setState({
							createOrderForm: {
								...self.state.createOrderForm,
								params: {
									...self.state.createOrderForm.params,
									warehouseCode: resp.agentid,
									warehouseName: resp.dockname,
									warehouseCodeCity: resp.dockcity,
									warehouseLoctype: resp.loctype
								}
							}
						}, () => {
							self.handleDialog("ChangeDeliveryMethodForADCLTLOverlayDialog", false, null);
				            //Continue with other logic of making service call
				            self.checkIfDuplicatePOOrNot();
						});
					}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
		        });
			} else {
				// If No and points is > 38, display a message, “Please remove some items so this order does not exceed 38 points or 12000 lbs.”, then return to the Create Order screen, so they can remove points.
				self.setState({
					showChangeDeliveryMethodForADCLTLOverlayDialog: false,
				}, () => {
					self.setState({
						genericDialogHeading: "Action",
						genericDialogText: "Please remove some items so this order does not exceed 38 points or 12000 lbs.",
						modalButtons: 'ok'
					}, () => {
						self.handleDialog("GenericOverlayDialog", true, null);
					});
				});
			}
		}
	}

	redirectToReviewOrderPage() {
		const self = this;
		self.checkIfWarehouseCodeForBackOrBulkOrderIsADCLOC(isCorrect => {
			if(isCorrect) {
				self.setState({
					isGetTaxServiceCallCompleted: false,
					taxDetails: null,
					isGetMinimumDeliveryCallCompleted: false,
					isPriceOrderParallelCallsCompleted: false,
				}, () => {
					self.makeParallelCallsOfPriceOrderForMultipleDelivery();
				});
			}
		});
	}

	fetchMinimumDelivery() {
		const self = this;
		const zipCode = self.getShippingAddressZipCode();
		const { selectedPriceSource } = self.props.state.user;
		self.props.getMinimumDelivery(`requestType=getMinimumDelivery&accountNumber=${self.props.getSelectedAccountNumber()}&agreementNumber=${selectedPriceSource.AGREEMENT_NUMBER}`, response => {
			if(response.status) {
				if(response.responseObject && response.responseObject.sa_price_list_min_del_req === 'Y') {
					if(response.responseObject.sa_price_list_min_del_req_amt) {
						// Use the amount
						self.setState({
							isGetMinimumDeliveryCallCompleted: true,
						}, () => {
							self.props.saveMinimumDeliveryAmount(response.responseObject.sa_price_list_min_del_req_amt);
							self.checkIfParallelPriceOrderCallsAreCompleted();
						});
					} else {
						// make another service call logic goes here
						zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'sds_loc', resp => {
							if(self.checkIfStateIsAk()) {
								resp = {
									agentid: "SEA",
									dockcity: "SEATTLE"
								}
							}
							if(resp && resp.agentid) {
								const { selectedAccount } = self.props.state.user;
								const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
								const servicesPayload = [{
									pricingEffectiveDate: moment().format('YYYYMMDD'),
									accountNumber,
									state: "NA",
									whse: resp.agentid,
									zone: resp.sdsApZone, // 'ZONE1',
									salesAgreementNumber,
									itemNumber: "NA"
								}];
								// Make service call to get delivery amount and update state
								self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
									if(resp.status) {
										self.setState({
											isGetMinimumDeliveryCallCompleted: true,
										}, () => {
											// TO DO : Temporary conversion from json string to json
											resp.responseObject = JSON.parse(resp.responseObject);
											// Use the amount
											const amount = resp.responseObject && resp.responseObject.items && resp.responseObject.items[0] ? resp.responseObject.items[0].unitPrice : 0;
											self.props.saveMinimumDeliveryAmount(amount?amount:0);
											self.checkIfParallelPriceOrderCallsAreCompleted();
										});
									} else {
										browserHistory.push('/error');
									}
								});
							}
						}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
					}
				} else {
					// Use the amount
					self.setState({
						isGetMinimumDeliveryCallCompleted: true
					}, () => {
						self.props.saveMinimumDeliveryAmount(0);
						self.checkIfParallelPriceOrderCallsAreCompleted();
					});
				}
			} else {
				browserHistory.push('/error');
			}
		});
	}

	preparePayloadOfCurrentDelivery(deliveryItems, createOrderPayload, whichDate, updateRequestedDeliveryDate) {
		deliveryItems = JSON.parse(JSON.stringify(deliveryItems));
		createOrderPayload = JSON.parse(JSON.stringify(createOrderPayload));

		let quantity = 0;
		let orderSubTotal = 0.00;
		// let estimatedTax = 0.00;
		deliveryItems.forEach(item => {
			if(updateRequestedDeliveryDate)
				item.requestedDeliveryDate = createOrderPayload[whichDate];
			// if(item.quantity &&
			// 	self.props.checkItemIsServiceOrNot(item.item) !== 'service' &&
			// 	self.props.getItemTypeByName(item.item) !== 'S'
			// ) {
			// 	quantity += parseInt(item.quantity, 10);
			// 	if(item.item !== 'M038' && item.item !== 'HANDLING CHARGE' && item.item !== 'LTL FREIGHT CHARGE') {
			// 		orderSubTotal += parseFloat(parseFloat(item.quantity * item.price).toFixed(2));
			// 	}
			// }
			if(item.quantity) {
				quantity += parseInt(item.quantity, 10);
				if(item.price) {
					orderSubTotal += parseFloat(parseFloat(item.quantity * item.price).toFixed(2));
				}
			}
			item.relatedServices && item.relatedServices.forEach(itm => {
				orderSubTotal += parseFloat(itm.extendedPrice);
			});
		});
		let payload = {
			...createOrderPayload,
			items: deliveryItems,
			quantity,
			// estimatedTax,
			orderSubTotal,
			orderTotal: parseFloat(orderSubTotal).toFixed(2),
			pointValue: _.sumBy(deliveryItems, itm => itm.item !== 'M038' && itm.item !== 'HANDLING CHARGE' && itm.item !== 'LTL FREIGHT CHARGE' ? itm.pointValue : 0).toFixed(2),
			orderWeight: _.sumBy(deliveryItems, itm => itm.item !== 'M038' && itm.item !== 'HANDLING CHARGE' && itm.item !== 'LTL FREIGHT CHARGE' ? itm.weight : 0).toFixed(2),
		};

		return payload;
	}

	checkIfParallelPriceOrderCallsAreCompleted() {
		const self = this;
		const {
			isGetMinimumDeliveryCallCompleted,
			completedPriceOrderCalls,
			noOfParallelPriceOrderCalls,
			priceOrderPayload
		} = self.state;
		if(isGetMinimumDeliveryCallCompleted && completedPriceOrderCalls === noOfParallelPriceOrderCalls) {
			// update bag items as per latest price order
			let items = self.state.createOrderForm.params.items;
			const otherPriceOrderItems = [];
			items.forEach((item, index) => {
				// if(item.keepOriginalPrice !== 'Y') {
					let data = null;
					if(item.onHold === 'Y') {
						data = self.state.priceOrderParallelCallsDataByHoldBackorders[0];
					} else {
						data = _.find(self.state.priceOrderParallelCallsData, {delivery: item.requestedDeliveryDateBackUp});
					}
					if(data && data.pricingData) {
						const { pricingData } = data;
						let salesPriceData = null;
						if (pricingData) {
							let priceOrderLineIndex = priceOrderPayload.find(itm => itm.originalLineIndex === (index + 1)).priceOrderLineIndex;
							salesPriceData = _.find(pricingData, itm => {
								return itm.itemPrice.item === (item.originalItem || item.item) && itm.itemPrice.lineIndex === priceOrderLineIndex && item.quantity.toString() === itm.itemPrice.qty.toString()
							});
						}
						const handlingChargeAvail = pricingData.find(itm => itm.itemPrice.item === 'HANDLING CHARGE');
						const ltlFreightChargeAvail = pricingData.find(itm => itm.itemPrice.item === 'LTL FREIGHT CHARGE');
						if (ltlFreightChargeAvail && !otherPriceOrderItems.find(itm => itm.item === 'LTL FREIGHT CHARGE' && itm.requestedDeliveryDate === item.requestedDeliveryDate && itm.onHold === item.onHold)) {
							let record = {
								item: 'LTL FREIGHT CHARGE',
								itemType: 'BAG',
								quantity: ltlFreightChargeAvail.itemPrice.qty,
								price: ltlFreightChargeAvail.itemPrice.salesPrice || 0,
								extendedPrice: ltlFreightChargeAvail.itemPrice.extendedPrice || 0,
								agreementNumber: self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER.toString(),
								requestedDeliveryDate: item.requestedDeliveryDate
							};
							if(item.onHold === 'Y') {
								record = {
									...record,
									onHold: 'Y'
								};
							}
							otherPriceOrderItems.push(record);
						}
						if (handlingChargeAvail && !otherPriceOrderItems.find(itm => itm.item === 'HANDLING CHARGE' && itm.requestedDeliveryDate === item.requestedDeliveryDate && itm.onHold === item.onHold)) {
							let record = {
								item: 'HANDLING CHARGE',
								itemType: 'BAG',
								quantity: handlingChargeAvail.itemPrice.qty,
								price: handlingChargeAvail.itemPrice.salesPrice,
								extendedPrice: handlingChargeAvail.itemPrice.extendedPrice,
								agreementNumber: '',
								requestedDeliveryDate: item.requestedDeliveryDate
							};
							if(item.onHold === 'Y') {
								record = {
									...record,
									onHold: 'Y'
								};
							}
							otherPriceOrderItems.push(record);
						}
						// If its not available from priceOrder service response then use it from search result pricing service
						// Its already getting saved in .price of products object
						if(!salesPriceData && item.price) {
							salesPriceData = {
								itemPrice: {
									salesPrice: item.price
								}
							}
						}
						if(salesPriceData && item.itemType !== 'S') {
							item.price = item.keepOriginalPrice !== 'Y' ? salesPriceData.itemPrice.salesPrice : item.price;
							item.relatedServices = (item.relatedServices || []).filter(itm => itm.type !== 'BAG').concat(self.props.prepareBagItems(salesPriceData));
						}
						if (item.relatedServices && item.relatedServices.length > 0) {
							item.relatedServices.forEach(service => {
								if (self.isMService(service.serviceId)) {
									const servicePriceData = _.find(data.pricingData, itm => {
										return itm.itemPrice.item === service.serviceId && service.quantity.toString() === itm.itemPrice.qty.toString()
									});
									if (servicePriceData) {
										service.price = servicePriceData.itemPrice.salesPrice;
									}
								}
							});
						}
						if(self.isMService(item.item)){
							const servicePriceData = _.find(data.pricingData, itm => {
								return itm.itemPrice.item === item.item && item.quantity.toString() === itm.itemPrice.qty.toString()
							});
							if (servicePriceData) {
								item.price = servicePriceData.itemPrice.salesPrice;
							}
						}
					}
				// }
			});
			self.setState({
				isPriceOrderParallelCallsCompleted: true,
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						items: items.concat(otherPriceOrderItems)
					}
				}
			}, () => {
				self.callBackToCheckParallelCallCompleted();
			});
		}
	}

	preparePriceOrderPayload(createOrderPayload) {
		const self = this;
		let orderTotal = 0.00;
		createOrderPayload.items.forEach(itm => {
			if(itm.quantity && itm.price) {
				orderTotal += parseFloat(itm.quantity * itm.price);
			}
		});
		const payload = {
			accountNumber: self.props.getSelectedAccountNumber(),
			orderTotal: orderTotal,
			warehouseCode: self.checkIfStateIsAk() ? "SEA" : createOrderPayload.warehouseCode,
			shipmentMethod: self.getDeliveryMethod(),
			// shipToState: (self.getDeliveryMethod() === "MATU-Ocean-Ocean-Full Container" || self.getDeliveryMethod() === "LTIA-Ocean-Ocean-Full Container") ? "WA" : createOrderPayload.shippingAddress.state,
			shipToState: JSON.parse(this.props.state.user.selectedAddress).STATE === undefined && JSON.parse(this.props.state.user.selectedAddress).COUNTRY ==="CA" ? null: createOrderPayload.shippingAddress.state,
			priceItems: [],
			priceDate: moment().format(messageConstants.DATE_FORMAT)
		};
		createOrderPayload.items.forEach(itm => {
			if (itm.item !== 'M038' && itm.item !== 'CUSTOMER MINIMUM DELIVERY' && itm.item !== 'LTL FREIGHT CHARGE' && itm.item !== 'HANDLING CHARGE') {
				// for substituted item we need to pass originalItem so this will ensure that we get a price and all of the correct BAGs (delivery, uncrate, service contracts)
				payload.priceItems.push({
					itemNumber: itm.originalItem || itm.item,
					qty: itm.quantity,
					agreementNumber: itm.agreementNumber,
					uncrateInd: itm.uncrateInd,
					grossPointValue: itm.pointValue ? itm.pointValue : 0,
				});
			}
			
			if(itm.relatedServices && itm.relatedServices.length>0){
				itm.relatedServices.forEach(service => {
					if(self.isMService(service.serviceId)){	
					payload.priceItems.push({
							itemNumber: service.serviceId,
							qty: service.quantity,
							agreementNumber: itm.agreementNumber,
							uncrateInd: "N",
							grossPointValue: 0,
						})
					}
				});
			}
		});
		return payload;
	}

	groupPayloadByDelivery(createOrderPayload, updateRequestedDeliveryDate, groupByHoldBackorders) {
		const self = this;
		let finalCreateOrderPayload = [];
		createOrderPayload = JSON.parse(JSON.stringify(createOrderPayload));
		let holdItems = [];
		if(groupByHoldBackorders) {
			holdItems = JSON.parse(JSON.stringify(createOrderPayload.items)).filter(item => item.onHold === 'Y');
		}

		// Exclude all hold back order items and then prepare group
		createOrderPayload.items = JSON.parse(JSON.stringify(createOrderPayload.items)).filter(item => item.onHold !== 'Y');

		const delivery1Items = createOrderPayload.items.filter(item => item.requestedDeliveryDateBackUp === 'delivery1');
		const delivery2Items = createOrderPayload.items.filter(item => item.requestedDeliveryDateBackUp === 'delivery2');
		const delivery3Items = createOrderPayload.items.filter(item => item.requestedDeliveryDateBackUp === 'delivery3');
		// This index is added to match it while reading parallel price order service call
		holdItems.forEach((item, index) => {
			item.priceOrderLineIndex = (index + 1).toString();
		});
		delivery1Items.forEach((item, index) => {
			item.priceOrderLineIndex = (index + 1).toString();
		});
		delivery2Items.forEach((item, index) => {
			item.priceOrderLineIndex = (index + 1).toString();
		});
		delivery3Items.forEach((item, index) => {
			item.priceOrderLineIndex = (index + 1).toString();
		});
		let whichRequestedDeliveryDate = [];
		if(delivery1Items.length > 0) {
			const payload = self.preparePayloadOfCurrentDelivery(delivery1Items, createOrderPayload, 'requestedDeliveryDate', updateRequestedDeliveryDate);
			finalCreateOrderPayload.push(payload);
			whichRequestedDeliveryDate.push({
				which: 'requestedDeliveryDate',
				delivery: 'delivery1',
				date: payload.items[0].requestedDeliveryDate
			});
		}
		if(delivery2Items.length > 0) {
			const payload = self.preparePayloadOfCurrentDelivery(delivery2Items, createOrderPayload, 'requestedDeliveryDate2', updateRequestedDeliveryDate);
			finalCreateOrderPayload.push(payload);
			whichRequestedDeliveryDate.push({
				which: 'requestedDeliveryDate2',
				delivery: 'delivery2',
				date: payload.items[0].requestedDeliveryDate
			});
		}
		if(delivery3Items.length > 0) {
			const payload = self.preparePayloadOfCurrentDelivery(delivery3Items, createOrderPayload, 'requestedDeliveryDate3', updateRequestedDeliveryDate);
			finalCreateOrderPayload.push(payload);
			whichRequestedDeliveryDate.push({
				which: 'requestedDeliveryDate3',
				delivery: 'delivery3',
				date: payload.items[0].requestedDeliveryDate
			});
		}

		// Check if group by holds and some hold items are there
		finalCreateOrderPayload = groupByHoldBackorders ? [] : finalCreateOrderPayload;
		if(groupByHoldBackorders && holdItems.length) {
			// 	single delivery -> there will be separate delivery item or no any other delivery except holds
			if(finalCreateOrderPayload.length === 1 || finalCreateOrderPayload.length === 0) {
				finalCreateOrderPayload.push(
					self.preparePayloadOfCurrentDelivery(holdItems, createOrderPayload, holdItems[0].requestedDeliveryDate, updateRequestedDeliveryDate)
				);
			}
			// 	multiple delivery -> it will pick which ever is the earliest
			else {
				let latestRequestedDeliveryDate = whichRequestedDeliveryDate[0];
				whichRequestedDeliveryDate.forEach(item => {
					const reqDelDate = item.date;
					if(moment(reqDelDate).isBefore(moment(latestRequestedDeliveryDate.date))) {
						latestRequestedDeliveryDate = item;
					}
				});

				finalCreateOrderPayload.push(
					self.preparePayloadOfCurrentDelivery(holdItems, createOrderPayload, latestRequestedDeliveryDate.which, updateRequestedDeliveryDate)
				);
			}
		}
		return finalCreateOrderPayload;
	}

	callBackAfterPriceOrder(delivery, whichattribute, response) {
		const self = this;
		const priceOrderParallelCallsData = self.state[whichattribute];
		priceOrderParallelCallsData.push({
			delivery,
			pricingData: response && response.status ? response.responseObject : null
		});
		self.setState({
			completedPriceOrderCalls: self.state.completedPriceOrderCalls + 1,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					isPriceOrderServiceIsDown: !response.status,
				}
			},
			[whichattribute]: priceOrderParallelCallsData
		}, () => {
			self.checkIfParallelPriceOrderCallsAreCompleted();
		});
	}

	makeParallelCallsOfPriceOrderForMultipleDelivery() {
		const self = this;
		const createOrderPayload = JSON.parse(JSON.stringify(self.state.createOrderForm.params));
		// set original index before setting price order line index
		createOrderPayload.items.forEach((item, index) => {
			item.originalLineIndex = (index + 1);
		});
		// Manipulate create order and group all items by delivery method in case of create order only
		const finalCreateOrderPayloadByHoldBackorders = self.groupPayloadByDelivery(createOrderPayload, true, true);
		const finalCreateOrderPayload = self.groupPayloadByDelivery(createOrderPayload, true, false);
		let priceOrderPayload = [];
		if (finalCreateOrderPayloadByHoldBackorders[0]) {
			priceOrderPayload = priceOrderPayload.concat(finalCreateOrderPayloadByHoldBackorders[0].items);
		}
		if (finalCreateOrderPayload[0]) {
			priceOrderPayload = priceOrderPayload.concat(finalCreateOrderPayload[0].items);
		}
		if (finalCreateOrderPayload[1]) {
			priceOrderPayload = priceOrderPayload.concat(finalCreateOrderPayload[1].items);
		}
		if (finalCreateOrderPayload[2]) {
			priceOrderPayload = priceOrderPayload.concat(finalCreateOrderPayload[2].items);
		}
		self.setState({
			noOfParallelPriceOrderCalls: finalCreateOrderPayload.length + finalCreateOrderPayloadByHoldBackorders.length,
			completedPriceOrderCalls: 0,
			priceOrderParallelCallsData: [],
			priceOrderParallelCallsDataByHoldBackorders: [],
			priceOrderPayload,
			// finalPriceOrderPayload: finalCreateOrderPayload,
			// finalPriceOrderPayloadByHoldBackorderse: finalCreateOrderPayloadByHoldBackorders
		}, () => {
			const zipCode = self.getShippingAddressZipCode();
			if(zipCode) {
				if(finalCreateOrderPayloadByHoldBackorders[0]) {
					// Make price order service call
					let payload = self.preparePriceOrderPayload(finalCreateOrderPayloadByHoldBackorders[0]);
					if(payload.priceItems.length) {
						// Hard code deliveryMethod to ADC Truckload for Hold Back order delivery
						payload = {
							...payload,
							shipmentMethod: 'ADC Truckload'
						};
						const zipCode = finalCreateOrderPayloadByHoldBackorders[0].shippingAddress.zip.split("-")[0];
						zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
							payload = {
								...payload,
								warehouseCode: resp.agentid,
							}
							self.props.getPriceOrder(payload, "requestType=priceOrder", response => {
								self.callBackAfterPriceOrder('delivery1', 'priceOrderParallelCallsDataByHoldBackorders', response);
							});
						}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
					} else {
						setTimeout(() => {
							self.callBackAfterPriceOrder('delivery1', 'priceOrderParallelCallsDataByHoldBackorders', {
								status: true,
								responseObject: []
							});
						}, 100);
					}
				}
				if(finalCreateOrderPayload[0]) {
					// Make price order service call
					const payload = self.preparePriceOrderPayload(finalCreateOrderPayload[0]);
					if(payload.priceItems.length) {
						self.props.getPriceOrder(payload, "requestType=priceOrder", response => {
							self.callBackAfterPriceOrder('delivery1', 'priceOrderParallelCallsData', response);
						});
					} else {
						setTimeout(() => {
							self.callBackAfterPriceOrder('delivery1', 'priceOrderParallelCallsData', {
								status: true,
								responseObject: []
							});
						}, 200);
					}
				}
				if(finalCreateOrderPayload[1]) {
					// Make price order service call
					const payload = self.preparePriceOrderPayload(finalCreateOrderPayload[1]);
					if(payload.priceItems.length) {
						self.props.getPriceOrder(payload, "requestType=priceOrder", response => {
							self.callBackAfterPriceOrder('delivery2', 'priceOrderParallelCallsData', response);
						});
					} else {
						setTimeout(() => {
							self.callBackAfterPriceOrder('delivery2', 'priceOrderParallelCallsData', {
								status: true,
								responseObject: []
							});
						}, 300);
					}
				}
				if(finalCreateOrderPayload[2]) {
					// Make price order service call
					const payload = self.preparePriceOrderPayload(finalCreateOrderPayload[2]);
					if(payload.priceItems.length) {
						self.props.getPriceOrder(payload, "requestType=priceOrder", response => {
							self.callBackAfterPriceOrder('delivery3', 'priceOrderParallelCallsData', response);
						});
					} else {
						setTimeout(() => {
							self.callBackAfterPriceOrder('delivery3', 'priceOrderParallelCallsData', {
								status: true,
								responseObject: []
							});
						}, 400);
					}
				}
				// Make parallel call to minimum delivery
				self.fetchMinimumDelivery();
				// Make parallel call of availability
				self.setState({
					isRequiredToMakeRecursiveAvailabilityCall: false,
					isUpdateAvailabilityCompleted: false,
				}, () => {
					self.updateAvailability(() => {
						self.setState({
							isUpdateAvailabilityCompleted: true
						}, () => {
							self.callBackToCheckParallelCallCompleted();
						});
					});
				})
			}
		});
	}

	callBackToCheckParallelCallCompleted() {
		const self = this;
		const {
			// isGetTaxServiceCallCompleted,
			isGetMinimumDeliveryCallCompleted,
			isPriceOrderParallelCallsCompleted,
			isUpdateAvailabilityCompleted,
			// orderAvailabilityCompleted,
			// taxDetails
		} = self.state;
		if(isGetMinimumDeliveryCallCompleted && isPriceOrderParallelCallsCompleted && isUpdateAvailabilityCompleted) {
			let orderSubTotal = 0;
			const groupByDelItemsByHoldBackorders = self.groupPayloadByDelivery(self.state.createOrderForm.params, false, true);
			let groupByDelItems = self.groupPayloadByDelivery(self.state.createOrderForm.params, false, false);
			groupByDelItems = groupByDelItems.concat(groupByDelItemsByHoldBackorders);
			const { freeDeliveryList } = self.props.state.order;
			groupByDelItems.forEach((groupedItems, index) => {
				let items = groupedItems.items;
				let totalbagDelvyPrice = 0;
				let totalbagDelvyQuantity = 0;
				items.forEach(item => {
					item.relatedServices && item.relatedServices.forEach(itm => {
						if(itm.type === 'BAG' && itm.serviceName.indexOf('DELIVERY') === 0) {
							if(freeDeliveryList.indexOf(itm.priceSubType) === -1) {
								// Only for bag items which starts with DELIVERY needs to sum up
								totalbagDelvyPrice += parseFloat(itm.price * itm.quantity);
								totalbagDelvyQuantity += parseInt(item.quantity, 10);
							}
						} else {
							itm.extendedPrice = parseFloat(itm.price * itm.quantity);
						}
					});
				});
				// if total bag items delivery price sum is less than minimum delivery amount then add one item at end
				const minimumDeliveryAmount = self.props.state.order.minimumDeliveryAmount;
				if(totalbagDelvyPrice < parseFloat(minimumDeliveryAmount)) {
					const perUnitDelvyPrice = minimumDeliveryAmount / totalbagDelvyQuantity;
					items.forEach(item => {
						const qty = parseInt(item.quantity, 10);
						item.relatedServices && item.relatedServices.forEach(itm => {
							if(itm.type === 'BAG' && itm.serviceName.indexOf('DELIVERY') === 0) {
								if(freeDeliveryList.indexOf(itm.priceSubType) === -1) {
									itm.extendedPrice = parseFloat(perUnitDelvyPrice * qty).toFixed(2);
									itm.price = parseFloat(perUnitDelvyPrice).toFixed(2);
								}
							}
							// orderSubTotal += parseFloat(itm.extendedPrice);
						});
					});
					if(totalbagDelvyQuantity > 0) {
						items.push({
							item: "CUSTOMER MINIMUM DELIVERY",
							itemType: 'BAG',
							quantity: 1,
							price: 0,
							extendedPrice: 0,
							agreementNumber: self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER.toString(),
							requestedDeliveryDate: items[0].requestedDeliveryDate
						});
					}
				}
			});
			let updatedItems = [];
			groupByDelItems.forEach(payload => {
				updatedItems = updatedItems.concat(payload.items);
			});
			let quantity = 0;
			let { items } = self.state.createOrderForm.params;
			items = JSON.parse(JSON.stringify(updatedItems));
			items.forEach(item => {
				const qty = parseInt(item.quantity, 10);
				quantity += qty;
				item.price = parseFloat(item.price).toFixed(2);
				item.extendedPrice = parseFloat(qty * item.price).toFixed(2);
				item.relatedServices && item.relatedServices.forEach(itm => {
					const qty = parseInt(itm.quantity, 10);
					quantity += qty;
					orderSubTotal += parseFloat(itm.extendedPrice);
				});
				if(item.item !== 'M038') {
					orderSubTotal += parseFloat(item.extendedPrice);
				}
			});
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						items,
						quantity,
						orderSubTotal,
						orderTotal: parseFloat(orderSubTotal).toFixed(2),
						billingReferenceLabel: self.state.createOrderForm.params.billingReference && self.state.createOrderForm.params.billingReference.length > 0 ? self.state.createOrderForm.params.billingReference[0].format : '',
					}
				},
			}, () => {
				// if customer class code is INTERNATIONAL then no need to make tax service call
				if (self.props.customerClassCodeOfSelectedAccount === 'INTERNATIONAL') {
					self.setState({
						noOfTaxParallelCalls: 0,
						completedNoOfTaxParallelCalls: 0,
						taxDetailsFromParallelCalls: [],
						taxDetailsFromParallelCallsByHoldBackorders: []
					}, () => {
						self.checkIfAllParallelTaxCallsCompleted();
					});
				} else {
					// call pim data to get geego_unspc_classification for tax service
					self.getUnsocClassifications(() => {
						const zipCode = self.getShippingAddressZipCode();
						zipCode && self.props.getShippingAddressesDetails(zipCode, false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
							if(self.checkIfStateIsAk()) {
								resp = {
									agentid: "SEA",
									dockcity: "SEATTLE"
								}
							}
							if(resp && resp.agentid) {
								let params = JSON.parse(JSON.stringify(self.state.createOrderForm.params));
								const items = _.pullAllBy(params.items, [{ 'item': 'CUSTOMER MINIMUM DELIVERY' }], 'item');
								params = {
									...params,
									items,
									shipFromAddress: {
										name: resp.dockname,
										address1: resp.dockaddr,
										address2: "",
										address3: "",
										address4: "",
										city: resp.dockcity,
										state: resp.dockst,
										zip: resp.dockzip,
										phone: "",
									}
								}
								if(self.getDeliveryMethod() === "MATU-Ocean-Ocean-Full Container" || self.getDeliveryMethod() === "LTIA-Ocean-Ocean-Full Container") {
									params = {
										...params,
										shipFromAddress: JSON.parse(JSON.stringify(params.shippingAddress))
									}
								}
								const payloadGroupByDeliveryForTaxByHoldBackorders = self.groupPayloadByDelivery(params, true, true);
								const payloadGroupByDeliveryForTax = self.groupPayloadByDelivery(params, true, false);
								self.setState({
									payloadGroupByDeliveryForTax,
									noOfTaxParallelCalls: payloadGroupByDeliveryForTax.length + payloadGroupByDeliveryForTaxByHoldBackorders.length,
									completedNoOfTaxParallelCalls: 0,
									taxDetailsFromParallelCalls: [],
									taxDetailsFromParallelCallsByHoldBackorders: [],
								}, () => {
									if(payloadGroupByDeliveryForTaxByHoldBackorders[0]) {
										const zipCode = payloadGroupByDeliveryForTaxByHoldBackorders[0].shippingAddress.zip.split("-")[0];
										zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
											let warehouseCode = resp.agentid,
												warehouseName = resp.dockname,
												warehouseCodeCity = resp.dockcity,
												warehouseLoctype = resp.loctype;
											// For no "_" found then it means user changed it to some other value so we need to search for "-" and pick first value
											if (warehouseLoctype) {
												warehouseLoctype = warehouseLoctype.indexOf("_") !== -1 ? warehouseLoctype.split('_') : warehouseLoctype.split('-');
												warehouseLoctype = warehouseLoctype.length ? warehouseLoctype[0].toUpperCase() : '';
											}
											payloadGroupByDeliveryForTaxByHoldBackorders[0] = {
												...payloadGroupByDeliveryForTaxByHoldBackorders[0],
												warehouseCode,
												warehouseName,
												warehouseCodeCity,
												warehouseLoctype,
												deliveryMethod: 'ADC Truckload'
											}
											const delivery = payloadGroupByDeliveryForTaxByHoldBackorders[0].items[0].originalDelivery;
											self.props.getTax(payloadGroupByDeliveryForTaxByHoldBackorders[0], "requestType=getTax", resp => {
												if(resp.status && resp.responseObject) {
													const taxDetails = resp.responseObject;
													const { taxDetailsFromParallelCallsByHoldBackorders } = self.state;
													taxDetailsFromParallelCallsByHoldBackorders.push({
														delivery,
														taxDetails
													})
													self.setState({
														completedNoOfTaxParallelCalls: self.state.completedNoOfTaxParallelCalls + 1,
														taxDetailsFromParallelCallsByHoldBackorders
													}, () => {
														self.checkIfAllParallelTaxCallsCompleted();
													});
												} else {
													browserHistory.push("/error");
												}
											});
										}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
									}
									if(payloadGroupByDeliveryForTax[0]) {
										const delivery = payloadGroupByDeliveryForTax[0].items[0].originalDelivery;
										self.props.getTax(payloadGroupByDeliveryForTax[0], "requestType=getTax", resp => {
											if(resp.status && resp.responseObject) {
												const taxDetails = resp.responseObject;
												const { taxDetailsFromParallelCalls } = self.state;
												taxDetailsFromParallelCalls.push({
													delivery,
													taxDetails
												})
												self.setState({
													completedNoOfTaxParallelCalls: self.state.completedNoOfTaxParallelCalls + 1,
													taxDetailsFromParallelCalls
												}, () => {
													self.checkIfAllParallelTaxCallsCompleted();
												});
											} else {
												browserHistory.push("/error");
											}
										});
									}
									if(payloadGroupByDeliveryForTax[1]) {
										const delivery = payloadGroupByDeliveryForTax[1].items[0].originalDelivery;
										self.props.getTax(payloadGroupByDeliveryForTax[1], "requestType=getTax", resp => {
											if(resp.status && resp.responseObject) {
												const taxDetails = resp.responseObject;
												const { taxDetailsFromParallelCalls } = self.state;
												taxDetailsFromParallelCalls.push({
													delivery,
													taxDetails
												})
												self.setState({
													completedNoOfTaxParallelCalls: self.state.completedNoOfTaxParallelCalls + 1,
													taxDetailsFromParallelCalls
												}, () => {
													self.checkIfAllParallelTaxCallsCompleted();
												});
											} else {
												browserHistory.push("/error");
											}
										});
									}
									if(payloadGroupByDeliveryForTax[2]) {
										const delivery = payloadGroupByDeliveryForTax[2].items[0].originalDelivery;
										self.props.getTax(payloadGroupByDeliveryForTax[2], "requestType=getTax", resp => {
											if(resp.status && resp.responseObject) {
												const taxDetails = resp.responseObject;
												const { taxDetailsFromParallelCalls } = self.state;
												taxDetailsFromParallelCalls.push({
													delivery,
													taxDetails
												})
												self.setState({
													completedNoOfTaxParallelCalls: self.state.completedNoOfTaxParallelCalls + 1,
													taxDetailsFromParallelCalls
												}, () => {
													self.checkIfAllParallelTaxCallsCompleted();
												});
											} else {
												browserHistory.push("/error");
											}
										});
									};
									self.props.saveCreateOrderPayload(params);
								})
							}
						}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
					});
				}
			});
		}
	}

	getUnsocClassifications(callback) {
		const self = this,
			{ items } = self.state.createOrderForm.params;
		let skuListForPim = [];
		items.forEach(item => {
			skuListForPim.push(item.item);
			if(item.relatedServices && item.relatedServices.length > 0) {
				item.relatedServices.forEach(itm => {
					skuListForPim.push(itm.serviceId);
				});
			}
		});
		skuListForPim = _.uniq(skuListForPim);
		self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
			if(response.status) {
				const responseObject = response.responseObject ? response.responseObject : null;
				let finalProducts = [];
				self.state.createOrderForm.params.items.forEach(item => {
					const pimItemData = _.find(responseObject, { item_number: item.item });
					item.productCode = (pimItemData && pimItemData.geego_unspc_classification) ? pimItemData.geego_unspc_classification : '';
					item.feature1 = (pimItemData && pimItemData.geego_feature_1) ? pimItemData.geego_feature_1 : '';
					item.itemCategory = (pimItemData && pimItemData.item_catalog_group) ? pimItemData.item_catalog_group : '';
					item.relatedServices && item.relatedServices.forEach(itm => {
						const pimItemData1 = _.find(responseObject, { item_number: itm.serviceId });
						itm.productCode = (pimItemData1 && pimItemData1.geego_unspc_classification) ? pimItemData1.geego_unspc_classification : '';
						itm.productCode = !itm.productCode ? item.productCode : itm.productCode;
						itm.feature1 = (pimItemData1 && pimItemData1.geego_feature_1) ? pimItemData1.geego_feature_1 : '';
						itm.itemCategory = (pimItemData1 && pimItemData1.item_catalog_group) ? pimItemData1.item_catalog_group : '';
					});
					finalProducts.push(item);
				});
				self.setState({
					createOrderForm: {
						...self.state.createOrderForm,
						params: {
							...self.state.createOrderForm.params,
							items: finalProducts
						}
					}
				}, () => {
					callback && callback();
				});
			}
		});
	}

	checkIfAllParallelTaxCallsCompleted() {
		const self = this;
		if(self.state.orderAvailabilityCompleted && self.state.noOfTaxParallelCalls === self.state.completedNoOfTaxParallelCalls) {
			// Update tax details & declining balance details
			const items = [];
			self.state.createOrderForm.params.items.forEach((item, index) => {
				let estimatedTax = 0;
				let itemTax = 0;
				if (self.props.customerClassCodeOfSelectedAccount === 'INTERNATIONAL') {
					items.push({
						...item,
						itemTax,
						estimatedTax	// This is we are saving to read root level totaltaxamount
					});
				} else {
					let data = null;
					if(item.onHold === 'Y') {
						data = self.state.taxDetailsFromParallelCallsByHoldBackorders && self.state.taxDetailsFromParallelCallsByHoldBackorders[0] ? self.state.taxDetailsFromParallelCallsByHoldBackorders[0] : null;
					} else {
						data = self.state.taxDetailsFromParallelCalls ? _.find(self.state.taxDetailsFromParallelCalls, {delivery: item.requestedDeliveryDateBackUp}) : null;
					}
					if(data && data.taxDetails) {
						const { taxDetails } = data;
						estimatedTax = taxDetails.invoice.totaltaxamount;
						let relatedServices = item.relatedServices && JSON.parse(JSON.stringify(item.relatedServices));
						if(item.item !== 'CUSTOMER MINIMUM DELIVERY') {
							const record = _.find(taxDetails.invoice.line, (itm) => {
								return itm.partnumber === item.item && item.quantity.toString() === itm.quantities.quantity.amount;
							});
							if(record) {
								itemTax = record.totaltaxamount;
								// estimatedTax += itemTax;
							}
							relatedServices && relatedServices.forEach(itm => {
								if(itm.type === 'BAG') {
									const record = _.find(taxDetails.invoice.line, (it) => {
										return it.partnumber === itm.serviceName && itm.quantity.toString() === it.quantities.quantity.amount;
									});
									if(record) {
										itm.itemTax = record.totaltaxamount;
										// estimatedTax += record.totaltaxamount;
									}
								} else {
									const record = _.find(taxDetails.invoice.line, (it) => {
										return it.partnumber === itm.serviceId && itm.quantity.toString() === it.quantities.quantity.amount;
									});
									if(record) {
										itm.itemTax = record.totaltaxamount;
										// estimatedTax += record.totaltaxamount;
									}
								}
							});
						}
						items.push({
							...item,
							relatedServices,
							itemTax,
							estimatedTax	// This is we are saving to read root level totaltaxamount
						});
					}
				}
			});
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						items,
						// estimatedTax: parseFloat(estimatedTax).toFixed(2),
						orderTotal: parseFloat(self.state.createOrderForm.params.orderTotal).toFixed(2),
					}
				}
			}, () => {
				self.props.saveCreateOrderPayload(self.state.createOrderForm.params);
				browserHistory.push("/editorder/orderreview");
			});
		}
	}

	checkIfDuplicatePOOrNot() {
		const self = this;
		if(self.state.isDuplicatePONumber) {
			self.handleDialog("DuplicatePOOverlayDialog", true);
		} else {
			self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
				if (self.checkIfStateIsAk()) {
					resp = {
						agentid: "SEA",
						dockcity: "SEATTLE"
					};
				}
				if(resp && resp.agentid) {
					// Manipulate alternateADC, defaultAlternateADC and warehouseCode, warehouseName, warehouseCodeCity, warehouseLoctype if these are not set properly
					let {
						deliveryMethod,
						alternateADC,
						defaultAlternateADC,
						warehouseCode,
						warehouseName,
						warehouseCodeCity,
						warehouseLoctype,
						defaultWarehouseDetails,
						items,
					} = self.state.createOrderForm.params;
					// If user is employee then only we need to check if alternateADC and defaultAlternateADC is set correctly or not
					if (self.props.state.user.userDetails.typeOfUser === 'employee' && (deliveryMethod === 'ADC Truckload' || deliveryMethod === 'ADC LTL')) {
						// check if alternateADC is set correctly then keep it as it is else we have to set it correctly as it means delivery method is getting changed via some dialog
						// as it may happen delivery method get change by some of delivery change dialog via any of below method:
						// continueADCLTLDeliveryWith
						// continueMATUOrLTIADeliveryWith
						// continueSDSDeliveryWith
						// continueADCTruckloadDeliveryWith
						// continueFedExDeliveryWith
						if (alternateADC === '' || defaultAlternateADC === '') {
							alternateADC = self.props.state.user.selectedADC;
							defaultAlternateADC = resp.agentid;
						}
					} else {
						alternateADC = '';
						defaultAlternateADC = '';
					}
					// WCP-7500: update items and uncrateInd in case of ADC Truckload
					if (deliveryMethod === 'ADC Truckload') {
						items = self.updateItemsForADCTruckLoadDelivery(items);
					}
					// default value set
					warehouseCode = resp.agentid;
					warehouseName = resp.dockname;
					warehouseCodeCity = resp.dockcity;
					warehouseLoctype = resp.loctype;
					// if alternateADC dropdown is there then update warehouseCode with that value
					if(alternateADC) {
						warehouseCode = alternateADC;
					} else if (defaultWarehouseDetails && defaultWarehouseDetails.warehouseCode !== self.state.createOrderForm.params.warehouseCode) {
						// if something changed then we have to keep that values
						warehouseCode = self.state.createOrderForm.params.warehouseCode;
						warehouseName = self.state.createOrderForm.params.warehouseName;
						warehouseCodeCity = self.state.createOrderForm.params.warehouseCodeCity;
						warehouseLoctype = self.state.createOrderForm.params.warehouseLoctype;
					}
					self.setState({
						createOrderForm: {
							...self.state.createOrderForm,
							params: {
								...self.state.createOrderForm.params,
								alternateADC,
								defaultAlternateADC,
								warehouseCode,
								warehouseName,
								warehouseCodeCity,
								warehouseLoctype,
								items,
							}
						}
					}, () => {
						self.redirectToReviewOrderPage();
					});
				}
			}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
		}
	}

	handleDuplicatePOAction(action) {
		const self = this;
		if(action === 'yes') {
			window.scrollTo(0, self.getElementOffset("mainPONumber"));
		} else {
			self.redirectToReviewOrderPage();
		}
	}

	handleCallBackAfterAddedNewAddress(data, addressCreated) {
		const self = this,
			shippingAddressList = self.state.shippingAddressList;
		if(!shippingAddressList.find(item => item.ADDRESS1 === data.address1 && item.CITY === data.city && item.STATE === data.state && item.POSTALCODE.indexOf(data.zipCode) === 0)) {
			shippingAddressList.push({
				FIRSTNAME: data.firstName,
				LASTNAME: data.lastName,
				ADDRESS1: data.address1,
				ADDRESS2: data.address2,
				ADDRESS3: data.address3,
				ADDRESS4: data.address4,
				CITY: data.city,
				COUNTY: data.county,
				STATE: data.state,
				POSTALCODE: data.zipCode,
				SITE_USE_ID: data.addressId,
				NEWADDRESS: true,
			});
		}
		const previousZipCode = self.state.createOrderForm.params.shippingAddress && self.state.createOrderForm.params.shippingAddress.zip;

		// Whenever new address added, just pull topload value from backup and set it as per item as for newly address no need to make call even with default siteNumber as well
		const items = JSON.parse(JSON.stringify(self.state.createOrderForm.params.items));
		items.forEach(itm => {
			itm.perItemPointValue = itm.perItemPointValueTopLoad;
		});
		const { selectedAccount } = self.props.state.user;
		self.setState({
			showAddShippingAddressOverlayDialog: false,
			shippingAddressList: shippingAddressList,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items,
					// For back up purpose as it will be required when press browser back
					shippingAddressList,
					shippingAddress: {
						name: selectedAccount.ORGANIZATIONNAME,
						firstName: data.firstName,
						lastName: data.lastName,
						addressId: data.addressId,
						address1: data.address1,
						address2: data.address2,
						address3: data.address3,
						address4: data.address4,
						city: data.city,
						county: data.county,
						state: data.state,
						zip: data.zipCode,
						phone: '',
						newAddress: true,
					}
				},
				errors: {
					...self.state.createOrderForm.errors,
					shippingAddressError: '',
				}
			}
		}, () => {
			if(previousZipCode !== data.zipCode && data.zipCode) {
				self.props.getShippingAddressesDetails(data.zipCode.split('-')[0], false, self.getLocTypeAccordingToDeliveryMethod(), () => {
					self.checkAvailabilityOfProducts(data.zipCode.split('-')[0], data.state);
					self.checkAvailabilityOfAddedServices(data.zipCode.split('-')[0]);
				},true,data.state, self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
			}
			self.updateDeliveryMethodDropdown(self.updateOrderPoints);
		});
	}

	handleChangeProductNumberTextBox(itemIndex, productNumber) {
        var products = this.state.products;
        products.map((item, index) => {
            if(index === itemIndex) {
                item.item = productNumber;
                if(productNumber === '') {
                    item.productDetails = null
                }
            }
            return null;
        })
        this.setState({
            products: products
        });
    }

	updateQuickOrderState(itemIndex, productDetails, makeAvailabilityCall) {
		const self = this,
			products = this.state.products;
        products.map((item, index) => {
            if(index === itemIndex) {
                item.productDetails = productDetails;
                item.item = productDetails.sku;
            }
            return null;
        })
        self.setState({
            products: products,
            isDataValid: true
        }, () => {
			if(makeAvailabilityCall) {
				const { selectedPriceSource } = self.props.state.user,
					skuListForPim = [productDetails.sku];

				// make service call to get pim details
				self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
					if(response.status) {
						const responseObject = response.responseObject ? response.responseObject : null;
						// update products in state with uncrateInd to use it later for priceOrder service
						let finalProducts = [];
						self.state.products.forEach(item => {
							if(!item.item) return null;
							let uncrateInd = "N";
							const pimItemData = _.find(responseObject, { item_number: item.item });
							if(pimItemData.geego_uncrateind) {
								let geego_uncrateind = pimItemData.geego_uncrateind;
								const { selectedAccountsAllPriceSources } = self.props.state.user;
								const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
								if(record) {
									uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
								}
							}
							// If uncrated is selected then only need to check below logic
							if (uncrateInd === 'Y') {
								const { deliveryMethod }= self.state.createOrderForm.params;
								if(!(deliveryMethod === "SDS Delivery" || deliveryMethod === 'SDS Delivery Next Day')) {
									uncrateInd = 'N';
								} else if (deliveryMethod === "SDS Delivery") {
									uncrateInd = 'Y';
								}
							}
							finalProducts.push({
								...item,
								uncrateInd
							});
						});
						self.setState({
							isPimCallCompleted: true,
							pimData: responseObject,
							products: finalProducts
						}, () => {
							self.callBackAfterAddingNewProduct();
						});
					}
				})
			}
		});
    }

	getSiteNumberOfSelectedShippingAddress() {
		const self = this;
		const { shippingAddressList } = self.state;
		const { shippingAddress } = self.state.createOrderForm.params;
		let siteNumber = null;
		if (shippingAddress && shippingAddressList.length) {
			const data = shippingAddressList.filter(address => address.PARTYSITEID !== undefined).find(itm => itm.ADDRESS1 === shippingAddress.address1 && itm.CITY === shippingAddress.city && itm.STATE === shippingAddress.state && itm.POSTALCODE.indexOf(shippingAddress.zip) === 0);
			if (data && data.PARTYSITEID) {
				siteNumber = data.PARTYSITEID;
			}
		}
		return siteNumber;
	}

	isNewAddressSelected() {
		const self = this;
		const { shippingAddressList } = self.state;
		const { shippingAddress } = self.state.createOrderForm.params;
		let newAddress = false;
		if (shippingAddress && shippingAddressList.length) {
			const data = shippingAddressList.find(itm => itm.ADDRESS1 === shippingAddress.address1 && itm.CITY === shippingAddress.city && itm.STATE === shippingAddress.state && itm.POSTALCODE.indexOf(shippingAddress.zip) === 0);
			if (data && !data.PARTYSITEID) {
				newAddress = true;;
			}
		}
		return newAddress;
	}

	callBackAfterAddingNewProduct() {
		const self = this;
		const { isPimCallCompleted, pimData } = this.state;
		const items = self.state.createOrderForm.params.items;

		if(isPimCallCompleted) {
			const finalObject = [];
			let isFedexableItemAdded = false;
			let attributeName = "geego_top_load";
			self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
				if(!resp && !self.isNewAddressSelected()) {
					attributeName = "geego_no_top_load";
				}
				self.state.products.forEach(item => {
					const availability = _.find(item.productDetails.availabilityData, {sku: item.item});
					const pimItemData = _.find(pimData, {item_number: item.item});
					if(availability && pimItemData) {
						const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
						const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
						const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
						const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
						const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
						const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
						const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
						isFedexableItemAdded = isFedexable;
						const agreementNumber = self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER.toString();
						let price = 0;
						price = _.find(item.productDetails.pricingData, { item_number: item.item });
						if(price && price.records && price.records.length > 0) {
							price = price.records[0].adjusted_unit_price || price.records[0].unit_price
							if(price) {
								item.price = price;
							}
						}
						items.push({
							item: item.item,
							itemDescription: item.productDetails && item.productDetails.description,
							itemType: availability.itemType,
							quantity: item.quantity,
							quantityError: '',
							imagePath:item.productDetails.imagePath,
							overpackQuantityRequired :(item.productDetails && item.productDetails.overpackQuantityRequired) || item.overpackQuantityRequired,
							packageQuantity:item.productDetails.packageQuantity || item.packageQuantity,
							price: item.price,
							relatedServices: [], // self.props.prepareBagItems(salesPriceData),
							originalPrice: item.price, // salesPriceData.itemPrice.salesPrice,
							pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * item.quantity) : 0.00,
							perItemPointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00,
							geego_cust_acct: pimItemData.geego_cust_acct,

							// Top load indicator value for backup
							perItemPointValueTopLoad: pimItemData['geego_top_load'] && pimItemData['geego_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_top_load']) : 0.00,
							// No top load indicator value for backup
							perItemPointValueNoTopLoad: pimItemData['geego_no_top_load'] && pimItemData['geego_no_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_no_top_load']) : 0.00,
							brand: pimItemData['geego_brand'],
							category: pimItemData['item_catalog_group'],
							geego_final_production_date: pimItemData['geego_final_production_date'],
							geego_distribution_start_date: pimItemData['geego_distribution_start_date'],
							geego_uncrateind: pimItemData.geego_uncrateind,
							weight: self.props.getOrderWeightFromPimData(pimItemData, item.quantity),
							perItemWeight: self.props.getOrderWeightFromPimData(pimItemData, 1),
							agreementNumber,
							hasReplacement,
							hasSubstitute,
							hasUpgrade,
							replacementSKUs,
							substituteSKUs,
							upgradeSKUs,
							isFedexable,
							poNumber: self.state.createOrderForm.params.poNumber,
							uncrateInd: item.uncrateInd,
							requestedDeliveryDate: self.state.createOrderForm.params.deliveryMode === 'single' ? 'delivery1' : '',
							requestedDeliveryDateBackUp: self.state.createOrderForm.params.deliveryMode === 'single' ? 'delivery1' : '',
							originalDelivery: self.state.createOrderForm.params.deliveryMode === 'single' ? 'delivery1' : '',
							action: 'new',
						});
						item = null;
					}
					item && finalObject.push(item);
				});
				const deliveryMethod = self.state.createOrderForm.params.deliveryMethod;
				self.setState({
					products: finalObject,
					createOrderForm: {
						...self.state.createOrderForm,
						params: {
							...self.state.createOrderForm.params,
							deliveryMethod: (!isFedexableItemAdded && deliveryMethod === 'FedEx Ground') ? '' : deliveryMethod,
							items
						}
					},
					isRequiredToMakeRecursiveAvailabilityCall: true,
				}, () => {
					self.updateOrderPoints();
					self.isDataSufficientForAvailabilityCheck() && self.updateAvailability(() => {
						self.updateMinimumDeliveryDateByDelivery();
					});
					// self.props.saveCreateOrderPayload({items: items});
				});
			}, self.getSiteNumberOfSelectedShippingAddress());
		}
	}

	handleMoreLines(event) {// add more products and qty
        event.preventDefault();
        const products = this.state.products;
        products.push({item: "", quantity: 1, availability: null, error: null, itemType: "M"});
        this.setState({
            products: products
        });
    }

	getIndexes(array, pickFromArray, value) {
		const indexes = [];
		array.forEach((itm, ind) => {
			if(itm === value)
				indexes.push(pickFromArray[ind]);
		});
		return indexes;
	}

	handleSelectedServices(serviceData, skuList, selectedSKUIndex, uncrateInd) {
		var self = this,
			items = self.state.createOrderForm.params.items,
			scrollToItemIndex = 0;
	    items.map((item, index) => {
			if(index === selectedSKUIndex) {
				scrollToItemIndex = index;
                if(skuList) {
                    item.relatedServices = skuList;
                }
				if(item.relatedServices.length === 0) {
					delete item.relatedServices;
				}
				// If user has changed uncratedInd then we have to keep it as it is.
				// else change it as per function param named uncrateInd
				// if (item.originalUncrateInd === item.uncrateInd) {
					item.uncrateInd = uncrateInd;
				// }
				// const bagItems = _.filter(item.relatedServices, {type: 'BAG'});
				// // if all related services are not of type BAG
				// if(bagItems.length !== item.relatedServices.length) {
				// 	item.uncrateInd = item.relatedServices && item.relatedServices.length > 0 ? 'Y' : 'N';
				// } else { // else all items are BAG items
				// 	item.uncrateInd = 'N';
				// }
			}
			return null;
		})
		self.setState({
			showAddServicesOverlayDialog: false,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items: items
				}
			}
		}, () => {
			window.scrollTo(0, self.getElementOffset("quantity"+scrollToItemIndex));
			self.resetSelectedSKU();
		});
	}

	handleActionChangeService(index, serviceId, event) {
		const self = this;
		if(event.target.value === 'D') {
			let items = self.state.createOrderForm.params.items;
			items.map((item, indx) => {
				if(index === indx) {
					item.relatedServices = _.pullAllBy(item.relatedServices, [{'serviceId': serviceId}], 'serviceId');
					item.uncrateInd = item.relatedServices.length === 0 ? 'N' : 'Y';
				}
				return null;
			})
			self.setState({
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						items: items
					}
				}
			});
			event.target.value = "";
		}
	}

	handleShowServiceDescription(serviceDetails, event) {
		event.preventDefault();
		var self = this;
		self.setState({
			genericDialogHeading: "Service",
            genericDialogText: serviceDetails.serviceId + " - " + serviceDetails.serviceName,
            modalButtons: 'ok'
		}, () => {
			self.handleDialog("GenericOverlayDialog", true);
		});
	}

	handleOnBlurQuantityService(index, serviceId, event) {
		if (event.target.value === '') {
			const self = this;
			self.handleChangeQuantityService(index, serviceId, { target: { value: 1, name: event.target.name } });
		}
	}

	handleChangeQuantityService(index, serviceId, event) {
		const self = this;
		let items = self.state.createOrderForm.params.items;
		let value = event.target.value;
		value = value === "0" ? 1 : value;
		items.map((item, indx) => {
			if(index === indx) {
				item.relatedServices.map((itm, ind) => {
					if(itm.serviceId === serviceId) {
						itm.quantity = value
						itm.quantityError = value === ''?'error':''
					}
					return null;
				})
			}
			return null;
		});
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			}
		});
	}

	onBlurValidatePhoneNumber(event) {
		const self = this;
		const phoneNumber = event.target.value;
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				errors: {
					...self.state.createOrderForm.errors,
					deliveryPhoneError: event.target.value !== "" && !self.props.isValidPhoneNumber(event.target.value)?"error":""
				}
			}
		}, () => {
			if(self.props.isValidPhoneNumber(phoneNumber)) {
				self.setState({
					createOrderForm: {
						...self.state.createOrderForm,
						params: {
							...self.state.createOrderForm.params,
							deliveryPhone: self.props.normalizePhoneNumber(phoneNumber)
						}
					}
				});
			}
		});
	}

	checkDeliveryMethod(loctype) {
		const self = this;
		self.getShippingAddressZipCode() && self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, loctype, resp => {
			if(resp && resp.agentid) {
				return true;
			} else {
				return false;
			}
		}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber(), "", false, self.props.getCountry(), true);
	}

	isPriceOrderServiceIsDown() {
		const self = this,
			{ errorsLog } = self.props.state.errors,
			{ isPriceOrderServiceIsDown } = self.state.createOrderForm.params;
		if (isPriceOrderServiceIsDown) {
			if(!_.find(errorsLog, ['errorMessage', 'Backend system is down. Your actual pricing will be updated later.'])) {
				return "Backend system is down. Your actual pricing will be updated later.";
			}
		}
		return "";
	}

	checkShowingOrdersCriteria(item) {
		const { eta, geego_final_production_date }= item;
		const today = moment();
		let flag = true;
		const geegoFinalProductionDate = geego_final_production_date && geego_final_production_date !== 'NULL' ? moment(geego_final_production_date) : null;
		if (geegoFinalProductionDate && geegoFinalProductionDate.isSameOrBefore(today) && (!eta || moment(eta).isAfter(today.add(routes.horizon, 'day')))) {
			flag = false;
		}
		return flag;
	}

	getRequestedDeliveryDateForItem = item => {
		switch (item.requestedDeliveryDate) {
			case 'delivery1':
				return this.state.date;
			case 'delivery2':
				return this.state.date2;
			case 'delivery3':
				return this.state.date3;
			default:
				return null;
		}
	}

	updateAvailability(callback) {
		const self = this;
		const shipSetList = [],
			skuList = [];
		const { deliveryMethod, shippingAddress, items, warehouseCode } = self.state.createOrderForm.params;
		const shipMethod = this.getShipMethod(deliveryMethod);
		items.forEach((item, index) => {
			if(!item.item) return null;
			if((item.itemType === 'M' || item.itemType === 'A') && !item.originalOrderNumber) {
				let finalProductionDate = null;
				if(item.geego_final_production_date && item.geego_final_production_date !== 'NULL') {
					finalProductionDate = moment(item.geego_final_production_date).format('MM/DD/YYYY');
				}
				if(self.validateFP(item) || item.onHold === 'Y') {
					skuList.push({
						itemNumber: item.item,
						qty: item.quantity,
						identifier: index + 1,
						shipSet: '',
						shipMethod,
						arrivalSetName: '',
						itemType: '',
						demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
						overrideFlag: 'N',
						quantityUOM: 'EA',
						finalProductionDate,
						agreementNumber: item.agreementNumber,
						requestedDeliveryDate: (self.getRequestedDeliveryDateForItem(item) || moment()).format('MM/DD/YYYY')
					});
				} else {
					if (!shipSetList.find(itm => itm.requestedDeliveryDate === item.requestedDeliveryDate)) {
						shipSetList.push({
							requestedDeliveryDate: item.requestedDeliveryDate,
							shipSet: parseInt(item.requestedDeliveryDate.replace('delivery', ''), 10)
						});
					}
					skuList.push({
						itemNumber: item.item,
						qty: item.quantity,
						identifier: index + 1,
						shipSet: shipSetList.find(itm => itm.requestedDeliveryDate === item.requestedDeliveryDate).shipSet,
						shipMethod,
						arrivalSetName: '',
						itemType: '',
						demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
						overrideFlag: 'N',
						quantityUOM: 'EA',
						finalProductionDate,
						agreementNumber: item.agreementNumber,
						requestedDeliveryDate: (self.getRequestedDeliveryDateForItem(item) || moment()).format('MM/DD/YYYY')
					});
				}
			}
		});
		if(skuList.length > 0) {
			self.setState({
				orderAvailabilityCompleted: false,
				availabilityError: false,
			}, () => {
				// availability call
				const data = shippingAddress;
				const zipCode = data ? data.zip.split('-')[0] : '';
						// new availability call
						const payload = {
							accountNumber: self.props.getSelectedAccountNumber(),
							warehouseCode: self.state.createOrderForm.params.alternateADC || warehouseCode,
							customerSiteId: data.addressId,
							orderSource: '',
							zipCode: zipCode && zipCode.slice(0, 5), // limiting zipcode to max 5 characters to avoid error in the api
							state: data.state,
							country: data.country || '',
							tradingPartnerId:'',
							dateType:'ARRIVAL',
							items: skuList,
						};
						self.props.checkAvailabilityForOrder(payload, response => {
							self.setState({
								availabilityData: response,
								availabilityError: response.length === 0 ? true : false,
							}, () => {
								self.callbackToUpdateItemsAfterAvailability(callback);
							});
						});
			});
		} else {
			self.setState({
				availabilityData: null
			}, () => {
				self.callbackToUpdateItemsAfterAvailability(callback);
			});
		}
	}

	callbackToUpdateItemsAfterAvailability(callback) {
		const self = this;
		const { availabilityData, createOrderForm, isRequiredToMakeRecursiveAvailabilityCall } = self.state;
		const { items } = createOrderForm.params;
		// Update items with latest availability
		let updatedItems = [];
		let needTOCallAvailabilityAgain = false;
		items.forEach((itm, index) => {
			if((itm.itemType === 'M' || itm.itemType === 'A') && !itm.originalOrderNumber) {
				// const currentShipSet = itm.requestedDeliveryDate.replace("delivery", "");
				let availability = availabilityData && availabilityData.find(it => it.itemNumber === itm.item && it.identifier === index + 1);
				if (availability) {
					if(isRequiredToMakeRecursiveAvailabilityCall && itm.onHold !== 'Y') {
						// if the item if we have passed shipSet
						// !availability.shipSet : Means it was previously FP product
						// 		then need to check by passing latest avail and eta and see if it not FP?
						// availability.shipSet : Means it was not previously FP product
						// 		then need to check by passing latest avail and eta and see if it is FP
						const previouslyFP = !availability.shipSet ? true : false;
						if(previouslyFP && itm.requestedDeliveryDate && !self.validateFP({
							geego_final_production_date: itm.geego_final_production_date,
							availability: availability.requestedDateQuantity,
							eta: self.props.pickTheDateFromString(availability.arrivalDate)
						})) {
							needTOCallAvailabilityAgain = true;
						} else if(!previouslyFP && self.validateFP({
							geego_final_production_date: itm.geego_final_production_date,
							availability: availability.requestedDateQuantity,
							eta: self.props.pickTheDateFromString(availability.arrivalDate)
						})) {
							needTOCallAvailabilityAgain = true;
						}
					}

					let onHold = itm.onHold;
					let onForce = itm.onForce;
					// If item action is Hold Backorder (onHold) currently, and has enough quantity on the requested date, we need to clear the flag and call availability again as shipset will change
					if (onHold === 'Y' && itm.quantity <= availability.requestedDateQuantity) {
						onHold = undefined;
						needTOCallAvailabilityAgain = true;
					}
					// If item action is Ship Complete (onForce) currently, and has enough quantity on the requested date, we need to clear the flag
					if (onForce === 'Y' && itm.quantity <= availability.requestedDateQuantity) {
						onForce = undefined;
					}

					updatedItems.push({
						...itm,
						onHold,
						onForce,
						availability: availability.requestedDateQuantity,
						eta: self.props.pickTheDateFromString(availability.arrivalDate),
						arrivalDate: self.props.pickTheDateFromString(availability.arrivalDate),
						groupArrivalDate: self.props.pickTheDateFromString(availability.groupArrivalDate),
						groupArrivalDateBkp: self.props.pickTheDateFromString(availability.groupArrivalDate),
						groupShipDate: self.props.pickTheDateFromString(availability.groupShipDate),
						groupShipDateBkp: self.props.pickTheDateFromString(availability.groupShipDate),
						shipDate: self.props.pickTheDateFromString(availability.shipDate),
						availabilityMessage: availability.message,
						actionError: ''
					});
				} else {
					// Pick availability from backup
					updatedItems.push({
						...itm,
						availability: itm.availabilityBkp,
						eta: itm.etaBkp,
						arrivalDate: '',
						groupArrivalDate: '',
						groupArrivalDateBkp: '',
						groupShipDate: '',
						groupShipDateBkp: '',
						shipDate: '',
						actionError: ''
					});
				}
			} else {
				updatedItems.push(itm);
			}
		});
		updatedItems = self.props.checkGroupShipDateByAvailabilityAndDelivery(updatedItems);
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items: updatedItems
				}
			},
			orderAvailabilityCompleted: true,
			isRequiredToMakeRecursiveAvailabilityCall: false
		}, () => {
			// // Check if any item is FP then call again update availability function by passing call back function
			if(needTOCallAvailabilityAgain) {
				self.updateAvailability(callback);
			} else {
				callback && callback();
			}
		});
	}

	validateFP(item) {
		const self = this;
		let finalProductionDate = null;
		if(item.geego_final_production_date && item.geego_final_production_date !== 'NULL') {
			finalProductionDate = item.geego_final_production_date;
		}
		return self.props.checkIfFPExceptAvailability({
			finalProductionDate: finalProductionDate,
			etaDate: item.eta
		});
	}

	showHideBackOrdersBlock(visibleBackOrders, event) {
		event.preventDefault();
		this.setState({
			visibleBackOrders
		});
	}

	addAvailableBackOrders(event) {
		event.preventDefault();
		this.setState({
			showBackOrders: true,
			visibleBackOrders: true,
		});
	}

	addSelectedBackOrders(event) {
		event.preventDefault();
		const self = this;
		let formError = false;
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		const backOrdersSelectedItems = [];
		const { items } = self.state.createOrderForm.params;
		if(backOrders && backOrders.responseObject) {
			backOrders.responseObject.forEach((item, index) => {
				item.orderDetail.orderLine.forEach((i, index) => {
					if(i.orderedQtyError || i.orderedQtyRequiredError) {
						formError = true;
					}
					if (i.selected && !self.checkIfAlreadyAdded(items, item.orderHeader.orderNumber, i.item, `${i.lineNum}.${i.shipmentNum}`)) {
						const priceSourceDetails = i.agreementNumber && self.props.state.user.selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === i.agreementNumber.toString());
						let newItem = {
							action: 'new',
   							boAvailableItem: 'Y',
							agreementNumber: i.agreementNumber,
							agreementType: priceSourceDetails && priceSourceDetails.AGREEMENT_TYPE,
							item: i.item,
							itemDescription: i.itemDescription,
							itemType: i.itemType,
							quantity: i.orderedQty,

							relatedServices: [],

							pointValue: parseFloat(i.perItemPointValue * i.orderedQty),
							perItemPointValue: i.perItemPointValue,

							// Top load indicator value for backup
							perItemPointValueTopLoad: i.perItemPointValueTopLoad,
							// No top load indicator value for backup
							perItemPointValueNoTopLoad: i.perItemPointValueNoTopLoad,
							brand: i.geego_brand,
							category: i.item_catalog_group,
							modifiers: i.modifiers,
							attribute:i.attribute,
							geego_final_production_date: i.geego_final_production_date,
							geego_distribution_start_date: i.geego_distribution_start_date,
							geego_uncrateind: i.geego_uncrateind,
							geego_cust_acct: i.geego_cust_acct,

							weight: i.weight,
							perItemWeight: i.perItemWeight,
							hasReplacement: i.hasReplacement,
							replacementSKUs: i.replacementSKUs,
							hasSubstitute: i.hasSubstitute,
							substituteSKUs: i.substituteSKUs,
							hasUpgrade: i.hasUpgrade,
							upgradeSKUs: i.upgradeSKUs,
							isFedexable: i.isFedexable,
							uncrateInd: i.uncrateInd,
							requestedDeliveryDate: 'delivery1',
							originalDelivery: 'delivery1',
							requestedDeliveryDateBackUp: 'delivery1',
							keepOriginalPrice: i.keepOriginalPrice,
							buyerLineNo: i.keepOriginalPO === 'Y' ? i.buyerLineNum : '',
							pricingDate: i.keepOriginalPrice === 'Y' ? self.props.pickTheDateFromString(i.pricingDate) : moment().format('MM/DD/YYYY'),
							keepOriginalPO: i.keepOriginalPO,
							poNumber: i.keepOriginalPO === 'Y' ? i.poNumber : '',
							originalOrderNumber: item.orderHeader.orderNumber,
							orderLineId: i.orderLineId,
							lineNo: `${i.lineNum}.${i.shipmentNum}`,
						};
						if(i.keepOriginalPrice === 'Y') {
							const { backOrders } = self.props.state.order;
							if(backOrders && backOrders.responseObject) {
								const backOrder = backOrders.responseObject.find(itm => itm.orderHeader.orderNumber === i.originalOrderNumber);
								const itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => itm.item === i.item && itm.lineNumber === i.lineNumber);
								// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
								if(itemDetails) {
									newItem = {
										...newItem,
										price: itemDetails.itemPrice.salesPrice,
										originalPrice: itemDetails.itemPrice.salesPrice
									};
								}
							}
						}
						backOrdersSelectedItems.push(newItem);
					}
				});
			});
		}
		if(bulkOrdersHold && bulkOrdersHold.responseObject) {
			bulkOrdersHold.responseObject.forEach((item, index) => {
				item.orderDetail.orderLine.forEach((i, index) => {
					if(i.orderedQtyError || i.orderedQtyRequiredError) {
						formError = true;
					}
					if (i.selected && !self.checkIfAlreadyAdded(items, item.orderHeader.orderNumber, i.item, `${i.lineNum}.${i.shipmentNum}`)) {
						const priceSourceDetails = i.agreementNumber && self.props.state.user.selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === i.agreementNumber.toString());
						let newItem = {
							agreementNumber: i.agreementNumber,
							agreementType: priceSourceDetails && priceSourceDetails.AGREEMENT_TYPE,
							item: i.item,
							itemDescription: i.itemDescription,
							itemType: i.itemType,
							quantity: i.reservedQty,

							relatedServices: [],

							pointValue: parseFloat(i.perItemPointValue * i.reservedQty),
							perItemPointValue: i.perItemPointValue,

							// Top load indicator value for backup
							perItemPointValueTopLoad: i.perItemPointValueTopLoad,
							// No top load indicator value for backup
							perItemPointValueNoTopLoad: i.perItemPointValueNoTopLoad,
							brand: i.geego_brand,
							category: i.item_catalog_group,
							modifiers: i.modifiers,

							geego_final_production_date: i.geego_final_production_date,
							geego_distribution_start_date: i.geego_distribution_start_date,
							geego_uncrateind: i.geego_uncrateind,
							geego_cust_acct: i.geego_cust_acct,

							weight: i.weight,
							perItemWeight: i.perItemWeight,
							hasReplacement: i.hasReplacement,
							replacementSKUs: i.replacementSKUs,
							hasSubstitute: i.hasSubstitute,
							substituteSKUs: i.substituteSKUs,
							hasUpgrade: i.hasUpgrade,
							upgradeSKUs: i.upgradeSKUs,
							isFedexable: i.isFedexable,
							uncrateInd: i.uncrateInd,
							requestedDeliveryDate: 'delivery1',
							originalDelivery: 'delivery1',
							requestedDeliveryDateBackUp: 'delivery1',
							keepOriginalPrice: i.keepOriginalPrice,
							buyerLineNo: i.keepOriginalPO === 'Y' ? i.buyerLineNum : '',
							pricingDate: i.keepOriginalPrice === 'Y' ? self.props.pickTheDateFromString(i.pricingDate) : moment().format('MM/DD/YYYY'),
							keepOriginalPO: i.keepOriginalPO,
							poNumber: i.keepOriginalPO === 'Y' ? i.poNumber : '',
							originalOrderNumber: item.orderHeader.orderNumber,
							orderLineId: i.orderLineId,
							lineNo: `${i.lineNum}.${i.shipmentNum}`,
						};
						if(i.keepOriginalPrice === 'Y') {
							const { bulkOrdersHold } = self.props.state.order;
							if(bulkOrdersHold && bulkOrdersHold.responseObject) {
								const bulkOrderHold = bulkOrdersHold.responseObject.find(itm => itm.orderHeader.orderNumber === i.originalOrderNumber);
								const itemDetails = bulkOrderHold && bulkOrderHold.orderDetail && bulkOrderHold.orderDetail.orderLine.find(itm => itm.item === i.item && itm.lineNumber === i.lineNumber);
								// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
								if(itemDetails) {
									newItem = {
										...newItem,
										price: itemDetails.itemPrice.salesPrice,
										originalPrice: itemDetails.itemPrice.salesPrice
									};
								}
							}
						}
						backOrdersSelectedItems.push(newItem);
					}
				});
			});
		}
		let backOrderErrorMessage = '';
		if(backOrdersSelectedItems.length === 0) {
			backOrderErrorMessage = 'Please select at least one item.';
			self.setState({
				backOrderErrorMessage,
			});
		} else if(formError) {
			backOrderErrorMessage = 'Please check errors.';
			self.setState({
				backOrderErrorMessage,
			});
		} else {
			let orderNumbers = [];
			// check if already data exists in state else add that order number to orderNumbers list
			backOrdersSelectedItems.forEach(item => {
				item.modifiers = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "modifiers");
				const shipmentNumber = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "shipmentNumber");
				const lineNo = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "lineNo");
				item.lineNo = lineNo + '.' + (shipmentNumber || 1);
				if (shipmentNumber === "" || lineNo === "" || item.modifiers === "") {
					orderNumbers.push(item.originalOrderNumber);
				}
			});
			// make calls to get order details
			orderNumbers = _.uniq(orderNumbers);
			if (orderNumbers.length) {
				self.props.getOrderDetailsInParallelBatches(orderNumbers, () => {
					self.updateItemsAsPerUpdatedBackOrdersSelectedItems(backOrdersSelectedItems);
				});
			} else {
				self.updateItemsAsPerUpdatedBackOrdersSelectedItems(backOrdersSelectedItems);
			}
		}
	}

	updateItemsAsPerUpdatedBackOrdersSelectedItems(backOrdersSelectedItems) {
		const self = this;
		backOrdersSelectedItems.forEach(item => {
			item.modifiers = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "modifiers");
			const shipmentNumber = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "shipmentNumber");
			const lineNo = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "lineNo");
			item.lineNo = lineNo + '.' + (shipmentNumber || 1);
			item.originalItem = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "originalItem");
			item.attribute = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "attribute");
		});
		self.getPricingOfNotKeepOriginalPrice(backOrdersSelectedItems, (updatedBackOrderItems) => {
			let items = self.state.createOrderForm.params.items;
			items = items.concat(updatedBackOrderItems);
			self.setState({
				backOrderErrorMessage: '',
				createOrderForm: {
					...self.state.createOrderForm,
					params: {
						...self.state.createOrderForm.params,
						items,
					}
				}
			}, () => {
				self.updateMinimumDeliveryDateByDelivery(() => {
					self.updateOrderPoints();
				});
			});
		});
	}

	getPricingOfNotKeepOriginalPrice(backOrdersSelectedItems, callback) {
		const self = this;
		const notKeepOriginalPrice = backOrdersSelectedItems.filter(item => item.keepOriginalPrice !== 'Y');
		if(notKeepOriginalPrice.length) {
			const items = JSON.parse(JSON.stringify(backOrdersSelectedItems));
			self.props.makeParallelCallsForCartPrices(
				notKeepOriginalPrice,
				true,
				true,
				'order',
				null,
				() => {
					const { prices } = self.props.state.order;
					if(prices) {
						items.forEach((item, index) => {
							if(item.keepOriginalPrice !== 'Y') {
								let price = 0;
								price = _.find(prices, (itm) => {
									return itm.item_number === item.item && itm.records[0] && itm.records[0].sa_number.toString() === item.agreementNumber.toString();
								});
								if(price && price.records && price.records.length > 0) {
									price = price.records[0].adjusted_unit_price || price.records[0].unit_price
								} else {
									price = 0;
								}
								item.price = price;
								item.originalPrice = price;
							}
						});
						callback(items);
					} else {
						browserHistory.push("/error");
					}
				}
			);
		} else {
			callback(backOrdersSelectedItems);
		}
	}

	checkIfAlreadyAdded(items, orderNumber, item, lineNo) {
		let flag = false;
		if(items.find(itm => itm.item === item && itm.originalOrderNumber === orderNumber && itm.lineNo === lineNo)) {
			flag = true;
		}
		return flag;
	}

	actionAllBackOrderLine(indexList, action) {
		const self = this;
		const items = self.state.createOrderForm.params.items;
		// First delete action of current product first in order to keep it latest
		// It will get updated accordingly below
		let LocalStorageVar =localStorage.getItem( "RDDate" ) ? JSON.parse( localStorage.getItem( "RDDate" ) ): null;
		items.forEach((itm, indx) => {
			if(itm.availability == 0 && this.isBackOrderEligible(itm,LocalStorageVar)){
				indexList=indexList.filter(item=> {
					return item.index != indx})
			}
			delete itm.actionError;
			delete itm.onForce;
			delete itm.onHold;
			if(indexList.find(item => item.index === indx)) {
				itm[action] = "Y";
				if (action === "onHold") {
					itm.uncrateInd = 'N';
					if (itm.relatedServices) {
						itm.relatedServices =  itm.relatedServices.filter(it => {
							const itemName = it.serviceId.toLowerCase();
							return !(itemName.length === 4 && itemName.indexOf("m") === 0);
						});
					}
				}
			}
		});
		self.setState({
			currentIndex: null,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items,
				}
			}
		}, () => {
			self.isDataSufficientForAvailabilityCheck() && self.updateAvailability(() => {
				self.updateMinimumDeliveryDateByDelivery(() => {
					if(indexList.find(item => item.fddItem === 'NEW')) {
						let {
							date,
							date2,
							date3,
							createOrderForm: {
								params: {
									requestedDeliveryDate,
									requestedDeliveryDate2,
									requestedDeliveryDate3,
								}
							}
						} = self.state;
						indexList.forEach((item) => {
							if(item.fddItem === 'NEW') {
								if(item.requestedDeliveryDateBackUp === 'delivery1') {
									date = null;
									requestedDeliveryDate = '';
								} else if(item.requestedDeliveryDateBackUp === 'delivery2') {
									date2 = null;
									requestedDeliveryDate2 = '';
								} else if(item.requestedDeliveryDateBackUp === 'delivery3') {
									date3 = null;
									requestedDeliveryDate3 = '';
								}
							}
						});
						self.setState({
							date,
							date2,
							date3,
							createOrderForm: {
								...self.state.createOrderForm,
								params: {
									...self.state.createOrderForm.params,
									requestedDeliveryDate,
									requestedDeliveryDate2,
									requestedDeliveryDate3,
								}
							}
						});
					}
				});
			});
			self.updateOrderPoints();
		});
	}

	handleUpdateWarehouseDetails(resp) {
		const self = this;
		let agentid = resp.facilitycode.value;
		let dockname = resp.facilityname.value;
		let dockcity = resp.facilitycity.value;
		let loctype = resp.locationcode.value;
		let { deliveryMethod } = this.state.createOrderForm.params;
		const { shippingMethodList } = self.state;
		if (dockname) {
			if(dockname.toUpperCase().indexOf('SDS') !== -1) {
				deliveryMethod = 'SDS Will Call';
				if(!shippingMethodList.find(itm => itm.label === 'SDS Will Call')) {
					shippingMethodList.push({
						label: "SDS Will Call",
						value: "SDS Will Call",
						display: true,
					});
				}
			} else if(dockname.toUpperCase().indexOf('ADC') !== -1) {
				deliveryMethod = 'ADC Will Call';
				if(!shippingMethodList.find(itm => itm.label === 'ADC Will Call')) {
					shippingMethodList.push({
						label: "ADC Will Call",
						value: "ADC Will Call",
						display: true,
					});
				}
			}
		}
		self.setState({
			shippingMethodList,
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					deliveryMethod,
					warehouseCode: agentid,
					warehouseName: dockname,
					warehouseCodeCity: dockcity,
					warehouseLoctype: loctype,
				}
			}
		}, () => {
			const { shippingAddressDetailsListWithZipCode } = self.props.state.user;
			const record = {
				agentid: agentid,
				dockaddr: "",
				dockcity: dockcity,
				dockname: dockname,
				dockphone: "",
				dockst: "",
				dockzip: self.getShippingAddressZipCode(),
				hdApZone: "",
				inventoryLoc: "",
				legLocCode: "",
				loctype: self.getLocTypeAccordingToDeliveryMethod(),
				mtApZone: "",
				sdsApZone: "",
				vcode: "",
			};
			if (shippingAddressDetailsListWithZipCode.find(itm => itm.zipCode === self.getShippingAddressZipCode())) {
				shippingAddressDetailsListWithZipCode.forEach(itm => {
					if (itm.zipCode === self.getShippingAddressZipCode() && !itm.details.find(it => it.loctype === self.getLocTypeAccordingToDeliveryMethod())) {
						itm.details.push(record);
					}
				});
			} else {
				shippingAddressDetailsListWithZipCode.push({
					zipCode: self.getShippingAddressZipCode(),
					details: [record]
				});
			}
			self.props.updateShippingAddresses(shippingAddressDetailsListWithZipCode);
		});
	}

	validatePONumberCharacters(event) {
		const self = this;
		self.setState({
			invalidPONumberRootLevel: !self.props.isValidPONumberCharacter(event)
		});
	}

	validatePONumberCharactersItemLevel(index, event) {
		const self = this;
		const { items } = self.state.createOrderForm.params;
		items[index].invalidPONumberItemLevel = !self.props.isValidPONumberCharacter(event);
		self.setState({
			createOrderForm: {
				...self.state.createOrderForm,
				params: {
					...self.state.createOrderForm.params,
					items
				}
			}
		});
	}

	getSelectedAddressParams() {
		const self = this;
		const { shippingAddress } = self.state.createOrderForm.params;
		let queryString = '';
		if (shippingAddress) {
			const {
				state,
				zip,
			} = shippingAddress;
			queryString = `&state=${state}&country=US&zip=${zip ? zip.split('-')[0] : zip}`;
		}
		return queryString;
	}

	handleAddNewAddress(event) {
		event.preventDefault();
		this.handleDialog("AddShippingAddressOverlayDialog", true);
		this.props.showAddressVerificationDialog(false);
	}

	getRDDByDelivery(item) {
		const self = this;
		let rdd = null;
		const { requestedDeliveryDate, requestedDeliveryDate2, requestedDeliveryDate3 } = self.state.createOrderForm.params;
		if(item.requestedDeliveryDateBackUp === 'delivery1') {
			rdd = requestedDeliveryDate;
		} else if(item.requestedDeliveryDateBackUp === 'delivery2') {
			rdd = requestedDeliveryDate2;
		} else if(item.requestedDeliveryDateBackUp === 'delivery3') {
			rdd = requestedDeliveryDate3;
		}
		return rdd && moment(rdd);
	}

	validateSubstituteCriteria(item) {
		const self = this;
		let flag = false;
		const rdd = self.getRDDByDelivery(item);
		const eta = moment(item.eta);
		if (rdd && eta) {
			// Do not offer Substitutes when the RDD > TODAY+16 days
			const todayPlus16 = moment().add(16, 'day');
			// If the model has an ETA before the RDD they select, do not offer a substitute.
			if (!(moment(rdd).isAfter(todayPlus16) || eta.isBefore(rdd))) {
				flag = true;
			}
		}
		return flag;
	}

	anyRestrictedItemsAdded(callback) {
		const self = this;
		const restrictedItems = self.state.createOrderForm.params.items.filter(item => self.props.isAnyModelIsRestrictedInSelectedAccount(item));
		if (restrictedItems.length === 0) {
			callback();
		}
	}

	render() {
		const self = this,
			{ disableDeliveryAndShippingAddressDropdown } = self.state,
			{ selectedAccount, selectedPriceSource, userDetails, adcList , accountResponsibilityData} = self.props.state.user,
			{ allowedCustomerClassCodes } = self.props.state.order,
			{ params, errors } = self.state.createOrderForm,
			customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "",
			typeOfAccount = self.props.getSelectedAccountType();
		const deliveryCalendarType = self.props.getDeliveryCalendarType(params.deliveryMethod);
		const availableSDSDates = (this.state.sdsDeliveryCalendar && this.state.sdsDeliveryCalendar.dates) || [];
		const disableManualDeliveryDateInput = !!(deliveryCalendarType);
		let holdBackOrderFlag = false;
		if (accountResponsibilityData && accountResponsibilityData.responseObject && accountResponsibilityData.responseObject.holdBackOrder === "Y") {
			holdBackOrderFlag = true;
			}
		const showHoldOrForceBackorderForCustomerClass = CUSTOMER_CLASS_CODES_FOR_HOLD_OR_FORCE_BACKORDER.includes(selectedAccount.CUSTOMERCLASSCODE) || holdBackOrderFlag ;
		// eslint-disable-next-line
		let subCustomerClasification = '';

		const selectedAccountsAllPriceSources = self.props.getSalesAgreementList();

		if(selectedPriceSource && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.length > 0) {
			const data = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER === selectedPriceSource.AGREEMENT_NUMBER);
			subCustomerClasification = data && data["Sub Account Classification"] ? data["Sub Account Classification"].toLowerCase() : '';
		}
		const groupArrivalDates = [];
		let isDelivery1Items = false;
		let isDelivery2Items = false;
		let isDelivery3Items = false;
		if(params.items) {
			const pointValueByDelivery = self.getPointValueByDelivery(params.items);
			const items = JSON.parse(JSON.stringify(params.items)).filter(itm => itm.item !== 'LTL FREIGHT CHARGE' && itm.item !== 'HANDLING CHARGE' && itm.onHold !== 'Y');
			const delivery1Items = items.find(item => item.requestedDeliveryDateBackUp === 'delivery1');
			const delivery2Items = items.find(item => item.requestedDeliveryDateBackUp === 'delivery2');
			const delivery3Items = items.find(item => item.requestedDeliveryDateBackUp === 'delivery3');
			if(delivery1Items) {
				isDelivery1Items = true;
				const pointAndWeightDetails = pointValueByDelivery.find(itm => itm.delivery === 'delivery1');
				groupArrivalDates.push({
					groupArrivalDate: delivery1Items.groupArrivalDate,
					delivery: ' for Delivery 1',
					pointValue: pointAndWeightDetails.pointValue,
					orderWeight: pointAndWeightDetails.orderWeight,
				});
			}
			if(delivery2Items) {
				isDelivery2Items = true;
				const pointAndWeightDetails = pointValueByDelivery.find(itm => itm.delivery === 'delivery2');
				groupArrivalDates.push({
					groupArrivalDate: delivery2Items.groupArrivalDate,
					delivery: ' for Delivery 2',
					pointValue: pointAndWeightDetails.pointValue,
					orderWeight: pointAndWeightDetails.orderWeight,
				});
			}
			if(delivery3Items) {
				isDelivery3Items = true;
				const pointAndWeightDetails = pointValueByDelivery.find(itm => itm.delivery === 'delivery3');
				groupArrivalDates.push({
					groupArrivalDate: delivery3Items.groupArrivalDate,
					delivery: ' for Delivery 3',
					pointValue: pointAndWeightDetails.pointValue,
					orderWeight: pointAndWeightDetails.orderWeight,
				});
			}
		}
		let anyHoldBackOrderOptionInDropdown = false;
		let anyForceBackOrderOptionInDropdown = false;
		const forceIndexes = [],
			holdIndexes = [];
		let deliveryMethodDetail = '';
		let selectAllItemsNotAvail= false;
		if(params) {
			deliveryMethodDetail = `${params.warehouseCode}${params.warehouseName ? ('-'+params.warehouseName) : ''}`;
			//commenting as part of 7305
			// const adcDetails = self.props.state.user.adcList.find(itm => itm.label === params.alternateADC);
			// if (params.alternateADC && adcDetails) {
			// 	const state = adcDetails.name;
			// 	deliveryMethodDetail = `${params.alternateADC} - ${state}`;
			// }
			let LocalStorageVar =JSON.parse( localStorage.getItem( "RDDate" ) );
				selectAllItemsNotAvail = params.items.every((item)=>{
				return item.availability >= item.quantity && (item.lifeCyclePhase !== "Near End of Life") || this.isBackOrderEligible(item,LocalStorageVar)
			})
		}
		const isViewOrdersAccess = self.props.isResponsibilityExists("View Orders");
		let isOrderAvailabilityError = false;
		const whseCode = params.alternateADC?params.alternateADC:params.warehouseCode;
        return (
            <div>
				<div className="push">
					{self.props.showErrorsOfPage('cart')}
				</div>
                <div className="push">
					<h1 className="pageTitle">Edit Order</h1>
                </div>
				<p className="bold red">{self.isPriceOrderServiceIsDown()}</p>
               <form className="createOrderForm" name="createOrderForm" id="createOrderForm" action="" onSubmit={params.deliveryMethod !== 'ADC Velocity' && showHoldOrForceBackorderForCustomerClass ?this.handleReviewOrder.bind(this):this.handleReviewForceOrder.bind(this)}>
                    <div className="largePush">
						<p className="bold red" id="errorMessage">{this.state.errorMessage}</p>
						{/* this.props.state.order.availabilityError && <p className="bold red">{this.props.state.order.availabilityError}</p> */}
                        <table style={{width: '100%'}} className="formTableTypeA createOrderTableA">
                            <tbody>
								<tr>
									<td style={{textAlign: 'left'}}>CSO (Order number)</td>
									<td>{params.orderNumber}</td>
								</tr>
								{params.referenceNumber && params.referenceNumber.indexOf("CTN") === 0 && <tr>
									<td style={{textAlign: 'left'}}>Order Reference #</td>
									<td>{params.referenceNumber}</td>
								</tr>}
                                <tr>
                                    <td style={{textAlign: 'left'}}>Order Date</td>
                                 	<td>{params.orderDate}</td>
                                </tr>
								<tr>
                                    <td style={{textAlign: 'left'}}>Order Type</td>
                                    <td>{params.orderType}</td>
                                </tr>
                                <tr>
                                    <td style={{textAlign: 'left'}}>P.O.<br /><i className="unbold">(for your reference)</i></td>
                                    <td>
										<input onBlur={this.handleBlurOfRootLevelPO} onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateParam, undefined, undefined)} onKeyPress={this.validatePONumberCharacters.bind(this)} id="mainPONumber" className={'txt-uppercase ' + errors.poNumberError} defaultValue={params.poNumber} type="text" name="poNumber" onChange={this.onChangeUpdateParam.bind(this)} maxLength={50} />
										{this.state.invalidPONumberRootLevel && <p className="bold red">{this.state.invalidPONumberMessage}</p>}
										{this.state.isDuplicatePONumber && <p className="bold importantText">You have entered a duplicate PO number</p>}
									</td>
                                </tr>
								{this.state.billingProfile && this.state.billingProfile.status && this.state.billingProfile.responseObject && this.state.billingProfile.responseObject.length > 0
									?<tr>
	                                    <td style={{textAlign: 'left'}}>
	                                        Invoice<br />References
	                                    </td>
	                                    <td style={{backgroundColor: '#f5f8fb'}}>
	                                        <p style={{margin: '0 10px'}}>Your company requires you to enter the following invoice reference information:<br /><span className="required">* required fields</span></p>
											{params.billingReference.map((item, index) => {
												let billingReferenceValue = this.state.billingProfile && _.find(this.state.billingProfile.responseObject, {name: item.name});
												billingReferenceValue = billingReferenceValue && billingReferenceValue.value;
												return <div className="custDualFields" key={index}>
		                                            <label htmlFor={"custom_jobnum"+index}>{item.requiredFlag === 'Y'?<u className="required">*</u>:null}{item.name}</label>
													{item.possibleValues && item.possibleValues.length > 0
														?<select defaultValue={item.value} className={item.error} name={"custom_jobnum"+index} onChange={this.handleInvoicePreferencesChange.bind(this, index)} id={"custom_jobnum"+index} disabled>
															<option value="">-- Select Reason --</option>
															{item.possibleValues.map((itm, inx) =>
																<option key={inx} value={itm}>{itm}</option>
															)}
														</select>
														:<input type="text" defaultValue={item.value} className={item.error} name={"custom_jobnum"+index} onChange={this.handleInvoicePreferencesChange.bind(this, index)} id={"custom_jobnum"+index} disabled/>
													}
													{/* <span className="billingReferencesValue">{billingReferenceValue && `(${billingReferenceValue})`}&nbsp;</span> */}
		                                        </div>
											})}
	                                    </td>
	                                </tr>
									:null
								}
                                <tr>
                                    <td style={{textAlign: 'left'}}>
                                       Billing Address
                                    </td>
									{selectedPriceSource && selectedPriceSource.BILL_TO_LOCATION
										?<td>
											{selectedPriceSource.BILL_TO_LOCATION}
										</td>
										:<td>
											{params.billingAddress && params.billingAddress.name}<br />
											{params.billingAddress && params.billingAddress.address1 && params.billingAddress.address1.trim()}
											{params.billingAddress && params.billingAddress.address1 && params.billingAddress.address1.trim() !== ""?<br/>:null}
											{params.billingAddress && params.billingAddress.city && params.billingAddress.city.trim()}, {params.billingAddress && params.billingAddress.state && params.billingAddress.state.trim()} {params.billingAddress && params.billingAddress.zip && params.billingAddress.zip.trim()}
	                                    </td>
									}
                               	</tr>
								<tr>
									<td style={{textAlign: 'left'}}>
										Ship To Address
									</td>
									<td>
										<select disabled={disableDeliveryAndShippingAddressDropdown || params.disableShipToAddressDropdown} name="shippingAddress" className={errors.shippingAddressError} value={params.shippingAddress && params.shippingAddress.address1 ? params.shippingAddress.address1 : ''} onChange={this.handleUpdateShippingAddress.bind(this)}>
											<option value={null}>-- Select Address --</option>
											{this.state.shippingAddressList && this.state.shippingAddressList
											.slice()
											.sort((a, b) => {
												const addrA = (a && a.ADDRESS1) ? a.ADDRESS1.toLowerCase() : '';
												const addrB = (b && b.ADDRESS1) ? b.ADDRESS1.toLowerCase() : '';
												return addrA.localeCompare(addrB);
											})
											.map((itm, ind) => {
												const list = [];
												if(itm.ADDRESS1) list.push(itm.ADDRESS1);
												if(itm.CITY) list.push(itm.CITY);
												if(itm.STATE) list.push(itm.STATE);
												if(itm.LOCATION) list.push(itm.LOCATION);
												return <option key={ind} value={itm.ADDRESS1}>
													{list.join(', ')}
												</option>
											})}
										</select>
										{params.shippingAddress && <p className="shippingAddress">
											{self.props.showOtherFieldsInAddShippingAddress
												? params.shippingAddress.firstName && params.shippingAddress.lastName
													? <span>
														{`${params.shippingAddress.firstName} ${params.shippingAddress.lastName}`}
														<br />
													</span>
													: <span>
														{params.shippingAddress.name}{params.shippingAddress && params.shippingAddress.name ? <br /> : null}
													</span>
												: <span>
													{params.shippingAddress.name}{params.shippingAddress && params.shippingAddress.name ? <br /> : null}
												</span>
											}
											{params.shippingAddress.address1 && params.shippingAddress.address1.trim()}
											{params.shippingAddress.address1 && params.shippingAddress.address1.trim() !== ""?<br/>:null}
											{params.shippingAddress.address2 && params.shippingAddress.address2.trim()}
											{params.shippingAddress.address2 && params.shippingAddress.address2.trim() !== ""?<br/>:null}
											{params.shippingAddress.address3 && params.shippingAddress.address3.trim()}
											{params.shippingAddress.address3 && params.shippingAddress.address3.trim() !== ""?<br/>:null}
											{params.shippingAddress.city && `${params.shippingAddress.city.trim()},`} {params.shippingAddress.state && params.shippingAddress.state.trim()} {params.shippingAddress.zip && params.shippingAddress.zip.trim()}
										</p>}
										{this.props.showAddNewAddressLink && !(disableDeliveryAndShippingAddressDropdown || params.disableShipToAddressDropdown)
											?<p><a href="" onClick={this.handleAddNewAddress.bind(this)}>Add New Shipping Address</a></p>
											:null
										}
									</td>
								</tr>
								<tr>
                                    <td style={{textAlign: 'left'}}>Shipping Method <a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "ShippingMethodDescriptionsOverlayDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></td>
                                    <td>
                                        <select className={errors.deliveryMethodError} disabled={self.state.disabledDeliveryDropdown || disableDeliveryAndShippingAddressDropdown} name="deliveryMethod" value={params.deliveryMethod} onChange={this.onChangeUpdateParam.bind(this)}>
											{params.deliveryMethod === "" && <option value="">-- Select Shipping Method --</option>}
											{
											this.state.shippingMethodList.map((item, index) => {
												//To remove ADC Velocity option in dropdown if the order was not created with ADC velocity 
												if(params.deliveryMethod !== 'ADC Velocity' && item.value !== 'ADC Velocity'){
												return <option key={index} value={item.value}>{item.label}</option>
											}
											// To remove ADC Velocity option if ship to address has defualt shipping method as ADC Velocity
											else if(params.deliveryMethod === 'ADC Velocity' && item.value !== 'ADC Velocity'){
												return <option key={index} value={item.value}>{item.label}</option>
											}
											// To display the option when in disabled mode
											else if((self.state.disabledDeliveryDropdown || disableDeliveryAndShippingAddressDropdown) && params.deliveryMethod === 'ADC Velocity' && item.value === 'ADC Velocity'){
												return <option key={index} value={item.value}>{item.label}</option>
											}
											})}
                                        </select>&nbsp; &nbsp;
										{userDetails && userDetails.typeOfUser === 'employee' && (params.deliveryMethod === 'ADC Truckload' || params.deliveryMethod === 'ADC LTL') &&
											<select
												onChange={this.onChangeUpdateParam.bind(this)}
												name="alternateADC"
												className={params.alternateADC !== params.defaultAlternateADC ? 'red' : ''}
												value={params.alternateADC}
												disabled={
													params.alternateADC === 'CH2' ||
													params.alternateADC === 'FON' 
													
												}
											>
												{adcList.map((item, index) => {
													if (
														(item.label === 'CH2' && params.alternateADC !== 'CH2') ||
														(item.label === 'FON' && params.alternateADC !== 'FON') 
														
													) {
														return null;
													}
													return <option key={index} className={item.label === params.defaultAlternateADC ? 'black' : 'red'}value={item.label}>{item.label}</option>
												})}
											</select>
										}
										{deliveryMethodDetail && <strong>
											&nbsp; &nbsp;<span className={params.alternateADC !== params.defaultAlternateADC ? 'red' : ''}>{deliveryMethodDetail}</span>
											&nbsp; &nbsp; {(params.deliveryMethod === 'SDS Will Call' || params.deliveryMethod === 'ADC Will Call') &&
												<a href="" onClick={self.handleDialog.bind(this, "ChangeDeliveryMethodOverlayDialog", true)}>Change</a>
											}
										</strong>}
                                    </td>
                                </tr>
                               	<tr>
                                    <td style={{verticalAlign: 'top', textAlign: 'left'}}>
                                        Requested Delivery Date
                                    </td>
                                    <td>
                                        <div id="newOrderShipToContainer">
											<div className="clearfix">
												<div id="dropDateSelect" className="rightCol clearfix">
													<label htmlFor="drop_date-one" className="normal">
														<input id="drop_date-one" name="deliveryMode" defaultValue="single" type="radio" defaultChecked={params.deliveryMode === 'single' ? true : false} onClick={this.onChangeUpdateParam.bind(this)} />
															One Delivery
													</label>
													<label htmlFor="drop_date-multiple" className="normal">
														<input id="drop_date-multiple" name="deliveryMode" defaultValue="multiple" type="radio" defaultChecked={params.deliveryMode === 'multiple' ? true : false} onClick={this.onChangeUpdateParam.bind(this)} />
														Multiple Deliveries <em>(up to three)</em>
													</label>
												</div>
											</div>
											<div className="newOrderShipTo move-calendar-right">
												<h1><span style={{fontSize: '1.4em'}}>1</span><sup>st</sup> Delivery</h1>
												<div className={errors.requestedDeliveryDateError}>
													<DatePicker id="requestedDeliveryDate" filterDate={deliveryCalendarType === 'SDS' ? date => availableSDSDates.some(calendarDate => calendarDate.available && calendarDate.date === date.format('MM/DD/YYYY')) : this.props.isWeekday} disabled={this.state.disableCalendar} minDate={self.state.minDate1} maxDate={this.state.maxDate1} placeholderText="Click to select a date" selected={this.state.date} readOnly={disableManualDeliveryDateInput} onChange={this.handleChange} />&nbsp;<var>(mm/dd/yyyy)</var>
												</div>
											</div>
											{params.deliveryMode === 'multiple' && <div className="newOrderShipTo move-calendar-right">
												<h1><span style={{fontSize: '1.4em'}}>2</span><sup>nd</sup> Delivery</h1>
												<div className={errors.requestedDeliveryDate2Error}>
													<DatePicker id="requestedDeliveryDate2" filterDate={deliveryCalendarType === 'SDS' ? date => availableSDSDates.some(calendarDate => calendarDate.available && calendarDate.date === date.format('MM/DD/YYYY')) : this.props.isWeekday} disabled={this.state.disableCalendar} minDate={self.state.minDate2} maxDate={this.state.maxDate2} placeholderText="Click to select a date" selected={this.state.date2} readOnly={disableManualDeliveryDateInput} onChange={this.handleChange2} />&nbsp;<var>(mm/dd/yyyy)</var>
												</div>
											</div>}
											{params.deliveryMode === 'multiple' && <div className="newOrderShipTo move-calendar-right">
												<h1><span style={{fontSize: '1.4em'}}>3</span><sup>rd</sup> Delivery</h1>
												<div className={errors.requestedDeliveryDate3Error}>
													<DatePicker id="requestedDeliveryDate3" filterDate={deliveryCalendarType === 'SDS' ? date => availableSDSDates.some(calendarDate => calendarDate.available && calendarDate.date === date.format('MM/DD/YYYY')) : this.props.isWeekday} disabled={this.state.disableCalendar} minDate={self.state.minDate3} maxDate={this.state.maxDate3} placeholderText="Click to select a date" selected={this.state.date3} readOnly={disableManualDeliveryDateInput} onChange={this.handleChange3} />&nbsp;<var>(mm/dd/yyyy)</var>
												</div>
											</div>}
                                        </div>
                                        <div className="clear" />
                                    </td>
                                </tr>
								<tr>
                                    <td style={{textAlign: 'left'}}>
                                        Delivery Phone
                                    </td>
									<td>
										<input onBlur={this.onBlurValidatePhoneNumber.bind(this)} onKeyPress={this.props.acceptNumbersOnly} id="deliveryPhone" className={errors.deliveryPhoneError} value={params.deliveryPhone} type="text" name="deliveryPhone" onChange={this.onChangeUpdateParam.bind(this)} maxLength={14} />
									</td>
								</tr>
                                <tr>
                                    <td style={{textAlign: 'left'}}>
                                        Shipping Instructions
                                    </td>
                                    <td className="containingTextArea">
										{params.deliveryInstructions && params.deliveryInstructions.length === 300
											?<span className="bold red">We are sorry, delivery instruction is limited to 300 characters.</span>
											:null
										}
                                        <textarea maxLength={300} rows={6} cols={40} name="deliveryInstructions" defaultValue={params.deliveryInstructions} onChange={this.onChangeUpdateParam.bind(this)} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="largePush">
						{groupArrivalDates.map((item, index) => {
							const tempGroupArrivalDate = !item.groupArrivalDate || moment(item.groupArrivalDate, 'MM/DD/YYYY').isAfter(moment().add(routes.horizon, 'days')) ? 'Not Available' : item.groupArrivalDate;
							return <div key={index} className="orderPoints" style={{float: 'none', marginBottom: '20px'}}>
								{(params && params.deliveryMethod !== 'ADC Velocity')?<span className="red">Estimated Arrival Date<a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "GroupETADescriptionDialog", true)} style={{verticalAlign: 'super'}}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a>
									{groupArrivalDates.length > 1 ? item.delivery : null} : {tempGroupArrivalDate}</span>:<span className="red" style={{ marginRight:'20px'}}>{groupArrivalDates.length > 1 ? item.delivery.replace(/for/i, "") : null}</span>}<span className={params.deliveryMethod !== 'ADC Velocity' ? 'orderPointsBlock' : 'pointsBlock'}>Order Points: {(+item.pointValue).toFixed(2)}</span>Order Weight: {item.orderWeight}
							</div>
						})}
						{params && params.deliveryMethod !== 'ADC Velocity' && <div className="orderPoints">
                            Order Points: {params.pointValue} &nbsp; &nbsp; Order Weight: {params.orderWeight}
						</div>}
						{params.deliveryMethod === 'SDS Delivery' || params.deliveryMethod === 'SDS Delivery Next Day'
							?<div className="servicesIconLegend">
                             	<img className="icon" src="../images/icon-services-large.png" width={27} height={27} alt="Add Services" title="Add Services" />
                            	Select this icon to UNCRATE<br />the product or add services.
	                        </div>
							:null
						}
                        <div className="clear" />
                        <table className="dataTableType2 createOrderTableB milktoast" id="myProductListX">
                            <thead>
                                <tr>
                                    <th className="product">Product</th>
									<th className="priceSource">Price<br/>Info</th>
                                    <th className="availability"><u>Avail Qty</u><br/>ETA <a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "AvailQtyEtaDescriptionsOverlayDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
                                    <th className="price">
                                        {typeOfAccount === 'RETAIL' || params.deliveryMethod.indexOf('Will Call') !== -1?"Net Price":"Price"}<br />
                                        <span className="unbold">(Each)</span>
                                    </th>
                                    <th className="quantity">Quantity</th>
									<th className="poNumber">P.O.</th>
                                    <th className="action">Action</th>
									<th className="shipTo">Select<br/>Delivery</th>
                                    <th className="delCrate">Crated/<br/>Uncrated</th>
									{params.deliveryMethod === 'SDS Delivery' || params.deliveryMethod === 'SDS Delivery Next Day'
										?<th className="services">Add<br/>Services</th>
										:null
									}
                                </tr>
                                <tr>
                                    <th className="toast" colSpan={10}></th>
                            	</tr>
                            </thead>
                            <tbody>
	                            {params.items.map((item, index)=> {
									let searchKeywordObjectOverPack = self.state.searchKeywordItem.find((searchItem)=>searchItem.sku === item.item) || item;
									let optionOverPackValues = [];
									if(searchKeywordObjectOverPack && searchKeywordObjectOverPack.overpackQuantityRequired && (searchKeywordObjectOverPack.overpackQuantityRequired === "1" || searchKeywordObjectOverPack.overpackQuantityRequired.toLowerCase() === "true" || searchKeywordObjectOverPack.overpackQuantityRequired.toLowerCase() === "yes") ){
										if(searchKeywordObjectOverPack.packageQuantity && searchKeywordObjectOverPack.packageQuantity > 1){
											optionOverPackValues[0]= "select";
											for(let i=1 ; i<=20 ; i++){
												optionOverPackValues[i] = (searchKeywordObjectOverPack.packageQuantity * (i));
											}
										}
									}
									if(item.item === "CUSTOMER MINIMUM DELIVERY" || item.item === 'HANDLING CHARGE' || item.item === 'LTL FREIGHT CHARGE') return null;
									let showHoldBackOrderOption = false;
									const checkAvailabilityValue = !item.originalOrderNumber && item.itemType !== "S" && self.props.checkAvailability(item.availability, item.requestedDeliveryDate);
									// do not show hold back order option in case
									if (self.state.createOrderForm.params.alternateADC === self.state.createOrderForm.params.defaultAlternateADC && self.checkShowingOrdersCriteria(item) && item.itemType !== "S" && !item.originalOrderNumber && (item.availability === 0 || (item.quantity && item.quantity > item.availability))) {
										anyHoldBackOrderOptionInDropdown = true;
										showHoldBackOrderOption = true;
										holdIndexes.push({
											index,
											fddItem: checkAvailabilityValue,
											requestedDeliveryDate: item.requestedDeliveryDate,
										});
									}
									let showForceBackOrderOption = false;
									const currentDelivery = item.requestedDeliveryDate.replace('delivery', '');
									const currentDeliveryMinDateForRDD = self.state[`minDate${currentDelivery}`];
									if (self.checkShowingOrdersCriteria(item) &&
										params.deliveryMethod !== 'SDS Delivery Next Day' &&
										!item.originalOrderNumber &&
										item.itemType !== "S" &&
										(
											item.availability === 0 ||
											(item.quantity && item.quantity > item.availability)
										) &&
										(
											(
												checkAvailabilityValue === 'NEW' &&
												!params.items.find(itm => itm.originalOrderNumber) &&
												item.geego_distribution_start_date &&
												currentDeliveryMinDateForRDD &&
												moment(item.geego_distribution_start_date).isSameOrBefore(currentDeliveryMinDateForRDD)
											) ||
											checkAvailabilityValue !== 'NEW'
										)
									) {
										anyForceBackOrderOptionInDropdown = true;
										showForceBackOrderOption = true;
										forceIndexes.push({
											index
										});
									}
									if (params.alternateADC && params.defaultAlternateADC !== params.alternateADC) {
										showHoldBackOrderOption = false;
									}
									let eta = !item.originalOrderNumber && !(item.availability >= item.quantity) && item.itemType !== "S"
										? (self.validateFP(item) ? 'FP' : self.props.checkETA(item.eta, item.requestedDeliveryDate))
										: null;
									// if its allowed cust class or retail and for current line is crated then disable else keep it enable
									const itemLevelDisableUncrateDropdown = (allowedCustomerClassCodes.indexOf(customerClassCode) !== -1 || typeOfAccount === "RETAIL")
										&& item.uncrateInd === 'N' ? true : false;
									let LocalStorageVar =JSON.parse( localStorage.getItem( "RDDate" ) );
									if(this.isBackOrderEligible(item,LocalStorageVar)){
										showForceBackOrderOption = false;
									}
									let isItemAvailabilityError = false;
									if (item.availabilityMessage && this.props.state.order.itemAvailabilityFailedMsgList.some(itemAvailabilityFailedMsg => item.availabilityMessage.toLowerCase().includes(itemAvailabilityFailedMsg.toLowerCase()))) {
										isItemAvailabilityError = true;
										isOrderAvailabilityError = true;
									}
	                            	return [
										<tr key={index} className={(index === this.state.selectedSKUIndex?'highlight-row':'')}>
		                                    <td className="product">
												{item.itemType !== "S"
													?<a className="sku" href={'/product-specs/product-number/'+item.item} target="_blank">{item.item}</a>
													:item.item
												}
												{parseInt(item.price, 10) === 0 && <p className="red">This item is not priced. Please select different sales agreement.</p>}
												{self.props.isAnyModelIsRestrictedInSelectedAccount(item) && <p className="red">Please remove the highlighted model. GEA is not currently selling this model to this account.</p>}
												{isItemAvailabilityError && <p className="red">{`This item cannot be ordered from ${whseCode}`}</p>}
		                                    </td>
											<td className="priceSource">
		                                        <a className="priceSource m-auto" onClick={this.handlePriceSourceDialog.bind(this, item.agreementNumber, "PriceSourceOverlayDialog", true, item)} href="">$</a>
		                                    </td>
		                                    <td className={`availability ${item.originalOrderNumber || (this.isBackOrderEligible(item,LocalStorageVar)) ? 'green-text' : ''}`}>
												{item.originalOrderNumber && self.props.getWarehouseCodeDetailsFromBackOrBulkOrder(item.originalOrderNumber)}
												<span className={`${item.availability >= item.quantity || (this.isBackOrderEligible(item,LocalStorageVar))? 'green-text' : 'red'}`}>
		                                        	{checkAvailabilityValue}<br/>
													{eta}
												</span>
		                                    </td>
		                                    <td className="price text-right">
		                                        {this.props.formatMoney(item.price, 0, ".", ",", false, "$")}
		                                    </td>
											{optionOverPackValues.length > 0?
											<td className="quantity">
													<select className={`itemQuantity ${item.quantityError}`}
													//onFocus={this.onFocusQuantity.bind(this, item.item,(pimItemData && pimItemData.geego_overpack_quantity))}
													//onBlur={this.onBlurQuantity.bind(this, item)}
													onChange={this.onChangeUpdateItems.bind(this, index, item.item)}
													name="quantity"
													disabled={item.originalOrderNumber ? true : false}
													value={item.quantity}>
														{optionOverPackValues.map((val, index)=>{
																return <option 
																		id={"quantity"+index}
																		key={index} 
																		value={val}>{val}</option>
															}) }
													</select>
												</td>:<td className="quantity">
													<input
													id={"quantity"+index}
													onPaste={this.props.doNothing}
													disabled={item.originalOrderNumber ? true : false}
													type="text" name="quantity"
													className={`itemQuantity ${item.quantityError}`}
													onKeyPress={this.props.acceptNumbersOnly}
													onChange={this.onChangeUpdateItems.bind(this, index, item.item)}
													value={item.quantity}
													size={1}
												/>
		                                    </td>}
											<td className="poNumber">
		                                        <input value={item.poNumber} onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateItems, index, item.item)} onKeyPress={this.validatePONumberCharactersItemLevel.bind(this, index)} className="txt-uppercase" type="text" name="poNumber" onChange={this.onChangeUpdateItems.bind(this, index, item.item)} maxLength={50} />
												{item.invalidPONumberItemLevel && <p className="bold red">{this.state.invalidPONumberMessage}</p>}
		                                    </td>
		                                    <td className="action">
												<select
													className={item.actionError}
													onChange={
														this.handleSelectAction.bind(this, index, item, !item.originalOrderNumber && item.itemType !== "S" && self.props.checkAvailability(item.availability, item.geego_distribution_start_date))
													}
													value={item.onHold === 'Y' ? "H" : (item.onForce === "Y" ? "F" : "")}
													disabled={item.item === 'M038'}
												>
													<option value="">Select Action</option>
													{item.itemType !== "S" && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject
														&& selectedAccountsAllPriceSources.responseObject.length > 1 &&
														<option value="P">Sales Agreement</option>
													}
													<option value="D">Delete</option>
													{item.itemType !== "S" && typeOfAccount === "RETAIL" && item.hasUpgrade && <option value="U">Upgrade</option>}
													{item.itemType !== "S"
														&& item.availability === 0
														&& (typeOfAccount === "CONTRACT" || typeOfAccount === "PRO CHANNEL" || typeOfAccount === "HQ")
														&& self.props.isValidClassificationCodeForSubstitute(subCustomerClasification)
														&& self.props.isValidClassificationCodeForSubstitute(customerClassCode)
														&& item.hasSubstitute
														&& self.validateSubstituteCriteria(item)
														&& <option value="S">Substitute</option>}
													{item.itemType !== "S" && item.hasReplacement && <option value="R">Replace</option>}
													{showHoldBackOrderOption && showHoldOrForceBackorderForCustomerClass && (params && params.deliveryMethod !== 'ADC Velocity') && !(this.isBackOrderEligible(item,LocalStorageVar)) && <option value="H">Hold Backorder</option>}
													{showForceBackOrderOption && showHoldOrForceBackorderForCustomerClass && (params && params.deliveryMethod !== 'ADC Velocity') && <option value="F">Ship Complete</option>}
												</select>
		                                    </td>
											<td className="shipTo">
												<select
													value={item.requestedDeliveryDate}
													name="requestedDeliveryDate"
													className={item.requestedDeliveryDateError}
													onChange={this.onChangeUpdateItems.bind(this, index, item.item)}
													disabled={params.deliveryMode === 'single'}
												>
													<option value="">-- Select --</option>
													{(self.state.date || isDelivery1Items) && <option value="delivery1">Delivery 1</option>}
													{(self.state.date2 || isDelivery2Items) && <option value="delivery2">Delivery 2</option>}
													{(self.state.date3 || isDelivery3Items) && <option value="delivery3">Delivery 3</option>}
												</select>
											</td>
		                                    <td className="delCrate">
												{item.itemType !== "S" && <select
													name="uncrateInd"
													onChange={this.onChangeUpdateItems.bind(this, index, item.item)}
													value={item.uncrateInd}
													disabled={itemLevelDisableUncrateDropdown}
												>
													<option value="N">Crated</option>
													<option value="Y">Uncrated</option>
												</select>}
		                                    </td>
											{params.deliveryMethod === 'SDS Delivery' || params.deliveryMethod === 'SDS Delivery Next Day'
												?<td className="services">
													{item.onHold !== 'Y' && (item.itemType === 'M' || item.itemType === 'A') && (!itemLevelDisableUncrateDropdown || (itemLevelDisableUncrateDropdown && item.uncrateInd === "Y"))
			                                        	?<a className="servicesLink" onClick={this.handleAddServices.bind(this, index, item.item, itemLevelDisableUncrateDropdown)} href="">
															<img className="icon" src="../images/icon-services-large.png" width={27} height={27} alt="Add Services" title="Add Services" />
														</a>
														:null
													}
			                                    </td>
												:null
											}
		                                </tr>,
										item.relatedServices?
											item.relatedServices.map((itm, ind) => {
												if(itm.type === "BAG") return null;
												return <tr key={ind}>
				                                    <td className="product">
				                                        &nbsp; &nbsp; <a href="" onClick={this.handleShowServiceDescription.bind(this, itm)}>{itm.serviceId}</a>
				                                    </td>
													<td className="priceSource">
				                                        <a className="priceSource m-auto" onClick={this.handlePriceSourceDialog.bind(this, item.agreementNumber, "PriceSourceOverlayDialog", true, item)} href="">$</a>
				                                    </td>
				                                    <td className="availability"></td>
				                                    <td className="price text-right">{this.props.formatMoney(itm.price, 0, ".", ",", false, "$")}</td>
				                                    <td className="quantity">
														<input type="text" onPaste={this.props.doNothing} id={"servicequantity"+ind} className={`itemQuantity ${itm.quantityError}`} onKeyPress={this.props.acceptNumbersOnly} value={itm.quantity} onChange={this.handleChangeQuantityService.bind(this, index, itm.serviceId)} defaultValue={item.quantity} size={1} />
													</td>
													<td className="poNumber" />
				                                    <td className="action">
				                                        <select name={"action_XXXXXXXXXXX"+ind} onChange={this.handleActionChangeService.bind(this, index, itm.serviceId)}>
				                                            <option value="">Select Action</option>
				                                            <option value="D">Delete</option>
				                                        </select>
				                                    </td>
													<td className="shipTo"></td>
													<td className="delCrate"></td>
													{params.deliveryMethod === 'SDS Delivery' || params.deliveryMethod === 'SDS Delivery Next Day'
														?<td className="services"></td>
														:null
													}
			                                	</tr>
											}):
										null
									]
	                            })}
								{this.state.products.map((item, index) => {
									if(!item) return null;
									return <tr key={index}>
	                                    <td className={"product " + item.error}>
											<AccountNumberAutoSuggests
												checkAvailabilityAndOrderability={this.props.checkAvailabilityAndOrderability}
												selectedAddressParams={this.getSelectedAddressParams()}
												getShippingAddressesDetails={this.props.getShippingAddressesDetails}
												width="auto"
												size={8}
												updateQuickOrderState={this.updateQuickOrderState.bind(this)}
												onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)}
												itemIndex={index}
												zipCode={self.getShippingAddressZipCode()}
												getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
											/>
											{(item.productDetails && item.productDetails.status === false) || (item.productDetails)
	                                            ?<span className="quickOrderTableRowError">You must enter a valid full or partial product number.</span>
	                                            :null
	                                        }
	                                    </td>
										<td className="priceSource">
	                                    </td>
										<td className="availability">
	                                        {item.productDetails && item.productDetails.availableQty}<br/>
											{item.productDetails && item.productDetails.etaDate}
	                                    </td>
	                                    <td className="price text-right">
	                                        {this.props.formatMoney(item.price, 0, ".", ",", false, "$")}
	                                    </td>
	                                    <td className="quantity">
	                                        <input type="text" className={`itemQuantity ${item.quantityError}`} onKeyPress={this.props.acceptNumbersOnly} defaultValue={item.quantity} size={1} />
	                                    </td>
										<td className="poNumber" />
	                                    <td className="action">
											<select onChange={this.handleSelectActionAddedProducts.bind(this, index)}>
												<option value="">Select Action</option>
												<option value="D">Delete</option>
											</select>
	                                    </td>
										<td className="shipTo"></td>
										<td className="delCrate">
											<select>
												<option>Crated</option>
												<option>Uncrated</option>
											</select>
	                                    </td>
										<td></td>
	                                </tr>
								})}
                            </tbody>
                        </table>
                        <div className="forgotSomething">
						{!selectAllItemsNotAvail && showHoldOrForceBackorderForCustomerClass && ((anyHoldBackOrderOptionInDropdown || anyForceBackOrderOptionInDropdown) && (params && params.deliveryMethod !== 'ADC Velocity')) && <div className="need-backorder-line-action float-right bold">
							Select for ALL items not available by the Request date:&nbsp;
								{anyForceBackOrderOptionInDropdown && <span><a className="blueButton" onClick={self.actionAllBackOrderLine.bind(this, forceIndexes, 'onForce')}>Ship Complete</a>&nbsp; &nbsp; &nbsp;</span>}
								{anyHoldBackOrderOptionInDropdown && <span><a className="blueButton" onClick={self.actionAllBackOrderLine.bind(this, holdIndexes, 'onHold')}>Hold</a></span>}
							</div>}
                            <b>Forgot something?</b>
                            &nbsp;
                            <a className="bold noUnderline uppercase" href="" id="myProductListXadd" onClick={this.handleMoreLines.bind(this)}>+ <u>Add</u></a>
                        </div>
						{isViewOrdersAccess && (self.props.state.order.isBackOrdersAvailable || self.props.state.order.isBulkOrdersHoldAvailable) && <p>
							{!self.state.showBackOrders
								?<strong><a href="#" id="a--addLineItem" onClick={self.addAvailableBackOrders.bind(this)}>{self.state.visibleBackOrders ? "-" : "+"} ADD AVAILABLE BACKORDERS</a></strong>
								:<strong><a href="#" id="a--addLineItem" onClick={self.showHideBackOrdersBlock.bind(this, !self.state.visibleBackOrders)}>{this.state.visibleBackOrders ? "-" : "+"} ADD AVAILABLE BACKORDERS</a></strong>
							}
						</p>}
                        <div className="clear" />
						{self.state.showBackOrders && <div style={{width: '100%', float: 'right', display: this.state.visibleBackOrders ? "block" : "none" }}>
							{self.state.backOrderErrorMessage && <p className="red bold">{self.state.backOrderErrorMessage}</p>}
							<BackOrdersAvailable whichPage="editorder" selectedState = {self.getShippingAddressState()} checkIfStateIsAk={self.checkIfStateIsAk} items={self.state.createOrderForm.params.items} zipCode={self.getShippingAddressZipCode()} selectedAddressParams={self.getSelectedAddressParams()} {...self.props} updateOrderPoints={this.updateOrderPoints} stateParams={self.state.createOrderForm.params}/>
							<p>
                        		<a className="float-left blueButton" onClick={self.addSelectedBackOrders.bind(this)}>Add Selected Backorders</a>
                        		<a className="float-right blueButton" onClick={self.showHideBackOrdersBlock.bind(this, false)}>Close Backorders</a>
							</p>
						</div>}
                        {!self.state.visibleBackOrders && <p className="textRight">
                            <input type="submit" id="editOrderSubmit" data-forceindex = {JSON.stringify(forceIndexes)} className="blueButton uppercase" value="Review Order" disabled={isOrderAvailabilityError} />
                        </p>}
						<div className="clear" />
                    </div>
                </form>
				{this.state.showPriceSourceOverlayDialog?
					<PriceSourceOverlayDialog
						formatMoney={this.props.formatMoney}
						isResponsibilityExists={this.props.isResponsibilityExists}
						selectedItem={this.state.selectedItem}
						orderDate={moment().format('MM/DD/YYYY')}
						selectedAccountsAllPriceSources={this.props.state.user.selectedAccountsAllPriceSources}
						priceSource={this.state.selectedPriceSource}
						showDialog={true}
						handleDialog={this.handleDialog}
						typeOfAccount={this.props.getSelectedAccountType()}
					/>:null}
				{this.state.showSelectPriceSourceOverlayDialog?<SelectPriceSourceOverlayDialog selectedPriceSource={this.state.selectedPriceSource} changeSelectedPriceSource={this.changeSelectedPriceSource.bind(this)} handleDialog={this.handleDialog} selectedAccountsAllPriceSources={selectedAccountsAllPriceSources} showDialog={true} />:null}
				{this.state.showAddShippingAddressOverlayDialog?<AddShippingAddressOverlayDialog showOtherFieldsInAddShippingAddress={this.props.showOtherFieldsInAddShippingAddress} handleDialog={this.handleDialog} existingAddresses={this.state.addressList} handleCallBackAfterAddedNewAddress={this.handleCallBackAfterAddedNewAddress.bind(this)} showDialog={true} />:null }
				{this.state.showDuplicatePOOverlayDialog?<DuplicatePOOverlayDialog handleAction={this.handleDuplicatePOAction} showDialog={true} />:null }
				{this.state.showShippingMethodDescriptionsOverlayDialog?<ShippingMethodDescriptionsOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null }
                {this.state.showChangeDeliveryMethodNOOverlayDialog?<ChangeDeliveryMethodNOOverlayDialog continueDeliveryWith={this.continueSDSDeliveryWith.bind(this)} currentDeliveryMethod={this.getDeliveryMethod()} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showChangeDeliveryMethodYESOverlayDialog?<ChangeDeliveryMethodYESOverlayDialog shippingMethodList={self.state.shippingMethodList} continueDeliveryWith={this.continueADCTruckloadDeliveryWith.bind(this)} currentDeliveryMethod={this.getDeliveryMethod()} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showMultipleDeliveryPointCriteriaNotMatchedOverlayDialog?<MultipleDeliveryPointCriteriaNotMatchedOverlayDialog doesNotMatchedPointCriteria={this.state.doesNotMatchedPointCriteria} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showChangeDeliveryMethodYESForAlternateADCOverlayDialog?<ChangeDeliveryMethodYESForAlternateADCOverlayDialog continueDeliveryWith={this.continueADCTruckloadForAlternateADCDeliveryWith.bind(this)} currentDeliveryMethod={this.getDeliveryMethod()} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showNotHavingEnoughPointsOverlayDialog?<NotHavingEnoughPointsOverlayDialog handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showFedExShipmentConfirmationOverlayDialog?<FedExShipmentConfirmationOverlayDialog continueDeliveryWith={this.continueFedExDeliveryWith.bind(this)} currentDeliveryMethod={this.getDeliveryMethod()} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showChangeDeliveryMethodOverlayDialog?<ChangeDeliveryMethodOverlayDialog acceptAlphaNumericOnly={this.props.acceptAlphaNumericOnly} handleUpdateWarehouseDetails={this.handleUpdateWarehouseDetails.bind(this)} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showSubstituteProductOverlayDialog && this.state.substituteSKUData?
					<SubstituteProductOverlayDialog resetSelectedSKU={this.resetSelectedSKU} selectedRDD={this.state.selectedRDD} handleUpgradeItem={this.handleUpgradeItem.bind(this)} substituteSKUData={this.state.substituteSKUData} sku={this.state.selectedSKU} handleDialog={this.handleDialog} showDialog={true} />
				:null }
				{this.state.showReplaceProductOverlayDialog && this.state.replacementSKUData?
					<ReplaceProductOverlayDialog resetSelectedSKU={this.resetSelectedSKU} handleReplace={this.handleReplace.bind(this)} replacementSKUData={this.state.replacementSKUData} handleDialog={this.handleDialog} showDialog={true} />
				:null }
				{this.state.showUpgradeProductOverlayDialog && this.state.upgradeSKUData?
					<UpgradeProductOverlayDialog resetSelectedSKU={this.resetSelectedSKU} handleUpgradeItem={this.handleUpgradeItem.bind(this)} upgradeSKUData={this.state.upgradeSKUData} sku={this.state.selectedSKU} handleDialog={this.handleDialog} showDialog={true} />
				:null }
				{this.state.showAddServicesOverlayDialog && this.state.availableServices?
					<AddServicesOverlayDialog
						availableServices={this.state.availableServices}
						resetSelectedSKU={this.resetSelectedSKU}
						handleSelectedServices={this.handleSelectedServices.bind(this)}
						handleDialog={this.handleDialog}
						itemLevelDisableUncrateDropdown={this.state.itemLevelDisableUncrateDropdown}
						selectedSKU={this.state.selectedSKU}
						selectedSKUIndex={this.state.selectedSKUIndex}
						formatAmount2Decimal={this.props.formatAmount2Decimal}
						items={this.state.createOrderForm.params.items}
						getPIMItemInfo={this.props.getPIMItemInfo}
						showDialog={true}
						requiredPayloadForServicePricing={this.state.requiredPayloadForServicePricing}
					/>
				:null }
				{/*{this.state.showNoRecordsFoundOverlayDialog?<NoRecordsFoundOverlayDialog resetSelectedSKU={this.resetSelectedSKU.bind(this)} resetOverlayDialog={this.resetOverlayDialog.bind(this)} showDialog={true} />:null}*/}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showKeepOriginalPOGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} flag="KeepOriginalPOGenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} handleYes={(e) => this.updatePoNumberAtLineLevel(false, e)} showDialog={true} />:null}
				{this.state.showInvalidSalesAgreementOverlayDialog?<InvalidSalesAgreementOverlayDialog invalidSAItems={this.state.invalidSAItems} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog?<ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog handleDialog={this.handleDialog} showDialog={true} handleCallBackAction={this.handleCallBackAction} />:null}
				{this.state.showAddCustomerServiceNotesForADCTruckloadOverlayDialog?<AddCustomerServiceNotesForADCTruckloadOverlayDialog handleAddNotesForADCTruckLoad={this.handleAddNotesForADCTruckLoad.bind(this)} customerServiceNotes={this.state.createOrderForm.params.customerServiceNotes || ''} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showChangeDeliveryMethodForADCLTLOverlayDialog?<ChangeDeliveryMethodForADCLTLOverlayDialog continueDeliveryWith={this.continueADCLTLDeliveryWith.bind(this)} currentDeliveryMethod={this.getDeliveryMethod()} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showChangeDeliveryMethodMATUOrLTIAOverlayDialog?<ChangeDeliveryMethodMATUOrLTIAOverlayDialog continueDeliveryWith={this.continueMATUOrLTIADeliveryWith.bind(this)} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showDoNotDeliverySelectedAddressOverlayDialog?<DoNotDeliverySelectedAddressOverlayDialog handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showActionForSDSOverlayDialog?<ActionForSDSOverlayDialog handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showNoDuplicateFromBackOrdersOverlayDialog?<NoDuplicateFromBackOrdersOverlayDialog duplicateItems={this.state.duplicateItems} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showLineNoMissingFromBackOrdersOverlayDialog?<LineNoMissingFromBackOrdersOverlayDialog lineNoMissing={this.state.lineNoMissing} removeMissingLineNumberItems={this.removeMissingLineNumberItems.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showAvailQtyEtaDescriptionsOverlayDialog?<AvailQtyEtaDescriptionsOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showGroupETADescriptionDialog?<GenericOverlayDialog
									flag="GroupETADescriptionDialog"
									genericDialogHeading={`Estimated Arrival Date`}
									genericDialogText={`Estimated Arrival Date to the customer's location`}
									showDialog={true}
									handleDialog={this.handleDialog.bind(this)}
									showModalCloseButton
								/>:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getPriceOrder: (payload, params, response) => dispatch(getPriceOrder(payload, params, response)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
	getOrderableServices: (payload, params, response) => dispatch(getOrderableServices(payload, params,response)),
	saveCreateOrderPayload: (data) => dispatch(saveCreateOrderPayload(data)),
	checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
	getTax: (payload, params, response) => dispatch(getTax(payload, params, response)),
	checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
	getMinimumDelivery: (params, callback) => dispatch(getMinimumDelivery(params, callback)),
	saveMinimumDeliveryAmount: (data) => dispatch(saveMinimumDeliveryAmount(data)),
	saveDeletedItems: (data) => dispatch(saveDeletedItems(data)),
	updateShippingAddresses: (data) => dispatch(updateShippingAddresses(data)),
	showAddressVerificationDialog: (flag) => dispatch(showAddressVerificationDialog(flag)),
	saveOrderableServices: (data) => dispatch(saveOrderableServices(data)),
	getSearchKeywordSuggestionList: (payload, callback, showloader) => dispatch(getSearchKeywordSuggestionList(payload, callback, showloader)),
	getDeliveryCalendar: (payload, queryString, showLoader, callback) => dispatch(getDeliveryCalendar(payload, queryString, showLoader, callback)),
	setAvailabilityError: (data) => dispatch(setAvailabilityError(data)),
});

EditOrder = connect(mapStateToProps, mapDispatchToProps)(EditOrder);
export default EditOrder;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/editOrder.js